(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[6],{

/***/ "9wPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions$c; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AddAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectors$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AuthProvider$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LoggedIn$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Login$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MyAccountMenu$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MyAccountRootConnectedClientOnlyWithContext; });
/* unused harmony export Profile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return state$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return state; });
/* unused harmony export Types */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return index$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return WithUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getToken; });
/* unused harmony export init */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isDataLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isDataUnavailable; });
/* unused harmony export useAccount */
/* unused harmony export useAddressBook */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return useAddressBookList; });
/* harmony import */ var _grandvision_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("k3MI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _grandvision_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ytpp");
/* harmony import */ var _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("wE1k");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("G4qV");
/* harmony import */ var _grandvision_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MZek");
/* harmony import */ var _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("B4sh");
/* harmony import */ var _grandvision_layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/z68");
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("J2iB");
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("3WX/");
/* harmony import */ var lodash_omitBy__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_omitBy__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Dott");
/* harmony import */ var history__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("LhCv");
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("fhwx");
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_html_parser__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _grandvision_elements__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("m5xE");
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ehos");
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(throttle_debounce__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _grandvision_stores__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("KOn7");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("zYMJ");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("RsJ5");
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("MFHg");
/* harmony import */ var _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("lylx");
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("5rFJ");
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("BOF4");
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(jwt_decode__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var auth0_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("sK8x");
/* harmony import */ var redux_saga__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("rRWa");
/* harmony import */ var specified__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("tj7F");
/* harmony import */ var specified__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(specified__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _grandvision_carts__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("ioLe");
/* harmony import */ var _grandvision_products__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("J2Fv");



























var FETCH_ADDRESSES = 'auth/addresses/fetch-list';
var FETCH_ADDRESSES_SUCCESS = 'auth/addresses/fetch-list-success';
var FETCH_ADDRESSES_FAILED = 'auth/addresses/fetch-list-failed';
var TOGGLE_MODAL = 'auth/adresses/toggle_modal';
var ADD_ADDRESS = 'auth/addresses/add-address';
var ADD_ADDRESS_SUCCESS = 'auth/addresses/add-address-success';
var ADD_ADDRESS_FAILED = 'auth/addresses/add-address-failed';
var EDIT_ADDRESS = 'auth/addresses/edit-address';
var EDIT_ADDRESS_SAVE = 'auth/addresses/edit-address-save';
var EDIT_ADDRESS_SUCCESS = 'auth/addresses/edit-address-success';
var EDIT_ADDRESS_FAILED = 'auth/addresses/edit-address-failed';
var DELETE_ADDRESS = 'auth/addresses/delete-address';
var DELETE_ADDRESS_CONFIRM = 'auth/addresses/add-address-confirm';
var DELETE_ADDRESS_SUCCESS = 'auth/addresses/delete-address-success';
var DELETE_ADDRESS_FAILED = 'auth/addresses/delete-address-failed';
var action = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action, payload = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload;
/**
 * Fetch list
 */
var fetchList = action(FETCH_ADDRESSES);
var fetchListSuccess = action(FETCH_ADDRESSES_SUCCESS, payload());
var fetchListFailed = action(FETCH_ADDRESSES_FAILED, function (error) { return ({ error: error }); });
/**
 * ToggleModal
 */
var toggleModal = action(TOGGLE_MODAL, payload());
/**
 * Add address
 */
var addAddress = action(ADD_ADDRESS, payload());
var addAddressSuccess = action(ADD_ADDRESS_SUCCESS, payload());
var addAddressFailed = action(ADD_ADDRESS_FAILED, function (error) { return ({ error: error }); });
/**
 * Delete address
 */
var deleteAddress = action(DELETE_ADDRESS, payload());
var deleteAddressConfirm = action(DELETE_ADDRESS_CONFIRM);
var deleteAddressSuccess = action(DELETE_ADDRESS_SUCCESS, payload());
var deleteAddressFailed = action(DELETE_ADDRESS_FAILED, function (error, id) { return ({
    error: error,
    id: id,
}); });
/**
 * Edit address
 */
var editAddress = action(EDIT_ADDRESS, payload());
var editAddressSave = action(EDIT_ADDRESS_SAVE, payload());
var editAddressSuccess = action(EDIT_ADDRESS_SUCCESS, payload());
var editAddressFailed = action(EDIT_ADDRESS_FAILED, function (error) { return ({ error: error }); });

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_ADDRESSES: FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS: FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILED: FETCH_ADDRESSES_FAILED,
  TOGGLE_MODAL: TOGGLE_MODAL,
  ADD_ADDRESS: ADD_ADDRESS,
  ADD_ADDRESS_SUCCESS: ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_FAILED: ADD_ADDRESS_FAILED,
  EDIT_ADDRESS: EDIT_ADDRESS,
  EDIT_ADDRESS_SAVE: EDIT_ADDRESS_SAVE,
  EDIT_ADDRESS_SUCCESS: EDIT_ADDRESS_SUCCESS,
  EDIT_ADDRESS_FAILED: EDIT_ADDRESS_FAILED,
  DELETE_ADDRESS: DELETE_ADDRESS,
  DELETE_ADDRESS_CONFIRM: DELETE_ADDRESS_CONFIRM,
  DELETE_ADDRESS_SUCCESS: DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILED: DELETE_ADDRESS_FAILED,
  fetchList: fetchList,
  fetchListSuccess: fetchListSuccess,
  fetchListFailed: fetchListFailed,
  toggleModal: toggleModal,
  addAddress: addAddress,
  addAddressSuccess: addAddressSuccess,
  addAddressFailed: addAddressFailed,
  deleteAddress: deleteAddress,
  deleteAddressConfirm: deleteAddressConfirm,
  deleteAddressSuccess: deleteAddressSuccess,
  deleteAddressFailed: deleteAddressFailed,
  editAddress: editAddress,
  editAddressSave: editAddressSave,
  editAddressSuccess: editAddressSuccess,
  editAddressFailed: editAddressFailed
});

var fetchList$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/fetch_list');
var fetchListSuccess$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/fetch_list_success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var fetchListFailed$1 = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/fetch_list_failed', function (error) { return ({ error: error }); });
var cancel = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/cancel', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var cancelSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/cancel-success', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var cancelFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/cancel-failed', function (error) { return ({ error: error }); });

var actions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchList: fetchList$1,
  fetchListSuccess: fetchListSuccess$1,
  fetchListFailed: fetchListFailed$1,
  cancel: cancel,
  cancelSuccess: cancelSuccess,
  cancelFailed: cancelFailed
});

var SIGNUP = 'my-account/create/signup';
var SIGNUP_SUCCESS = 'my-account/create/sign-success';
var SIGNUP_FAILED = 'my-account/create/signup-failed';
var SET_PASSWORD = 'my-account/create/set-password';
var SET_PASSWORD_SUCCESS = 'my-account/create/set-password-success';
var SET_PASSWORD_FAILED = 'my-account/create/set-password-failed';
var signup = function (payload) { return ({
    type: SIGNUP,
    payload: payload,
}); };
var signUpSuccess = function (payload) { return ({
    type: SIGNUP_SUCCESS,
    payload: payload,
}); };
var signUpFailed = function (error) { return ({
    type: SIGNUP_FAILED,
    error: error,
}); };
var setPassword = function (payload) { return ({
    type: SET_PASSWORD,
    payload: payload,
}); };
var setPasswordSuccess = function (payload) { return ({
    type: SET_PASSWORD_SUCCESS,
    payload: payload,
}); };
var setPasswordFailed = function (error) { return ({
    type: SET_PASSWORD_FAILED,
    error: error,
}); };

var actions$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SIGNUP: SIGNUP,
  SIGNUP_SUCCESS: SIGNUP_SUCCESS,
  SIGNUP_FAILED: SIGNUP_FAILED,
  SET_PASSWORD: SET_PASSWORD,
  SET_PASSWORD_SUCCESS: SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILED: SET_PASSWORD_FAILED,
  signup: signup,
  signUpSuccess: signUpSuccess,
  signUpFailed: signUpFailed,
  setPassword: setPassword,
  setPasswordSuccess: setPasswordSuccess,
  setPasswordFailed: setPasswordFailed
});

var LOGIN = 'account/login';
var LOGIN_FAILED = 'account/login_failed';
var PARSE_HASH = 'account/login/parse-hash';
var PARSE_HASH_FAILED = 'account/login/parse-hash-failed';
var PARSE_HASH_SUCCEEDED = 'account/login_success';
var RECOVER_SESSION = 'account/login/recover-session';
var RECOVER_SESSION_FAILED = 'account/login/recover-session-failed';
var loginWithPassword = function (payload) { return ({
    type: LOGIN,
    payload: payload,
}); };
var parseHash = function () { return ({ type: PARSE_HASH }); };
var parseHashFailed = function (payload) { return ({
    type: PARSE_HASH_FAILED,
    payload: payload,
}); };
var parseHashSucceeded = function (payload) { return ({
    type: PARSE_HASH_SUCCEEDED,
    payload: payload,
}); };
var loginFailed = function (error) { return ({
    type: LOGIN_FAILED,
    error: error,
}); };
var recoverSession = function () { return ({
    type: RECOVER_SESSION,
}); };
var recoverSessionFailed = function (error) { return ({
    type: RECOVER_SESSION_FAILED,
    error: error,
}); };

var actions$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOGIN: LOGIN,
  LOGIN_FAILED: LOGIN_FAILED,
  PARSE_HASH: PARSE_HASH,
  PARSE_HASH_FAILED: PARSE_HASH_FAILED,
  PARSE_HASH_SUCCEEDED: PARSE_HASH_SUCCEEDED,
  RECOVER_SESSION: RECOVER_SESSION,
  RECOVER_SESSION_FAILED: RECOVER_SESSION_FAILED,
  loginWithPassword: loginWithPassword,
  parseHash: parseHash,
  parseHashFailed: parseHashFailed,
  parseHashSucceeded: parseHashSucceeded,
  loginFailed: loginFailed,
  recoverSession: recoverSession,
  recoverSessionFailed: recoverSessionFailed
});

var LOG_OUT = 'account/log_out';
var LOGGED_OUT = 'account/logged_out';
var logOut = function () { return ({
    type: LOG_OUT,
}); };
var loggedOut = function () { return ({
    type: LOGGED_OUT,
}); };

var actions$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LOG_OUT: LOG_OUT,
  LOGGED_OUT: LOGGED_OUT,
  logOut: logOut,
  loggedOut: loggedOut
});

var FETCH_PAGE = 'auth/orders/fetch_page';
var FETCH_PAGE_SUCCESS = 'auth/orders/fetch_page_success';
var FETCH_PAGE_FAILED = 'auth/orders/fetch_page_failed';
var FETCH_LEGACY_PAGE = 'auth/orders/fetch_legacy_page';
var FETCH_LEGACY_PAGE_SUCCESS = 'auth/orders/fetch_legacy_page_success';
var FETCH_LEGACY_PAGE_FAILED = 'auth/orders/fetch_legacy_page_failed';
var FETCH_DETAIL = 'auth/orders/fetch_detail';
var FETCH_DETAIL_SUCCESS = 'auth/orders/fetch_detail_success';
var FETCH_DETAIL_FAILED = 'auth/orders/fetch_detail_failed';
var FETCH_LEGACY_DETAIL = 'auth/orders/fetch_legacy_detail';
var FETCH_LEGACY_DETAIL_SUCCESS = 'auth/orders/fetch_legacy_detail_success';
var FETCH_LEGACY_DETAIL_FAILED = 'auth/orders/fetch_legacy_detail_failed';
var REORDER = 'auth/orders/reorder';
var REORDER_SUCCESS = 'auth/orders/reorder_success';
var REORDER_FAILED = 'auth/orders/reorder_failed';
var fetchPage = function (payload) { return ({
    type: FETCH_PAGE,
    payload: payload,
}); };
var fetchPageSuccess = function (payload) { return ({
    type: FETCH_PAGE_SUCCESS,
    payload: payload,
}); };
var fetchPageFailed = function (error) { return ({
    type: FETCH_PAGE_FAILED,
    error: error,
}); };
var fetchLegacyPage = function (payload) { return ({
    type: FETCH_LEGACY_PAGE,
    payload: payload,
}); };
var fetchLegacyPageSuccess = function (payload) { return ({
    type: FETCH_LEGACY_PAGE_SUCCESS,
    payload: payload,
}); };
var fetchLegacyPageFailed = function (error) { return ({
    type: FETCH_LEGACY_PAGE_FAILED,
    error: error,
}); };
var fetchDetail = function (payload) { return ({
    type: FETCH_DETAIL,
    payload: payload,
}); };
var fetchDetailSuccess = function (payload) { return ({
    type: FETCH_DETAIL_SUCCESS,
    payload: payload,
}); };
var fetchDetailFailed = function (error) { return ({
    type: FETCH_DETAIL_FAILED,
    error: error,
}); };
var fetchLegacyDetail = function (payload) { return ({
    type: FETCH_LEGACY_DETAIL,
    payload: payload,
}); };
var fetchLegacyDetailSuccess = function (payload) { return ({
    type: FETCH_LEGACY_DETAIL_SUCCESS,
    payload: payload,
}); };
var fetchLegacyDetailFailed = function (error) { return ({
    type: FETCH_LEGACY_DETAIL_FAILED,
    error: error,
}); };
var reorder = function (payload) { return ({
    type: REORDER,
    payload: payload,
}); };
var reorderSuccess = function () { return ({
    type: REORDER_SUCCESS,
}); };
var reorderFailed = function (error) { return ({
    type: REORDER_FAILED,
    error: error,
}); };

var actions$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_PAGE: FETCH_PAGE,
  FETCH_PAGE_SUCCESS: FETCH_PAGE_SUCCESS,
  FETCH_PAGE_FAILED: FETCH_PAGE_FAILED,
  FETCH_LEGACY_PAGE: FETCH_LEGACY_PAGE,
  FETCH_LEGACY_PAGE_SUCCESS: FETCH_LEGACY_PAGE_SUCCESS,
  FETCH_LEGACY_PAGE_FAILED: FETCH_LEGACY_PAGE_FAILED,
  FETCH_DETAIL: FETCH_DETAIL,
  FETCH_DETAIL_SUCCESS: FETCH_DETAIL_SUCCESS,
  FETCH_DETAIL_FAILED: FETCH_DETAIL_FAILED,
  FETCH_LEGACY_DETAIL: FETCH_LEGACY_DETAIL,
  FETCH_LEGACY_DETAIL_SUCCESS: FETCH_LEGACY_DETAIL_SUCCESS,
  FETCH_LEGACY_DETAIL_FAILED: FETCH_LEGACY_DETAIL_FAILED,
  REORDER: REORDER,
  REORDER_SUCCESS: REORDER_SUCCESS,
  REORDER_FAILED: REORDER_FAILED,
  fetchPage: fetchPage,
  fetchPageSuccess: fetchPageSuccess,
  fetchPageFailed: fetchPageFailed,
  fetchLegacyPage: fetchLegacyPage,
  fetchLegacyPageSuccess: fetchLegacyPageSuccess,
  fetchLegacyPageFailed: fetchLegacyPageFailed,
  fetchDetail: fetchDetail,
  fetchDetailSuccess: fetchDetailSuccess,
  fetchDetailFailed: fetchDetailFailed,
  fetchLegacyDetail: fetchLegacyDetail,
  fetchLegacyDetailSuccess: fetchLegacyDetailSuccess,
  fetchLegacyDetailFailed: fetchLegacyDetailFailed,
  reorder: reorder,
  reorderSuccess: reorderSuccess,
  reorderFailed: reorderFailed
});

var FETCH_LIST = 'auth/prescriptions/fetch_list';
var FETCH_LIST_SUCCESS = 'auth/prescriptions/fetch_list_success';
var FETCH_LIST_FAILED = 'auth/prescriptions/fetch_list_failed';
var FETCH_SIGNED = 'auth/prescriptions/fetch_signed';
var FETCH_SIGNED_SUCCESS = 'auth/prescriptions/fetch_signed_success';
var FETCH_SIGNED_FAILED = 'auth/prescriptions/fetch_signed_failed';
var fetchList$2 = function () { return ({
    type: FETCH_LIST,
}); };
var fetchListSuccess$2 = function (payload) { return ({
    type: FETCH_LIST_SUCCESS,
    payload: payload,
}); };
var fetchListFailed$2 = function (error) { return ({
    type: FETCH_LIST_FAILED,
    error: error,
}); };
var fetchSigned = function () { return ({
    type: FETCH_SIGNED,
}); };
var fetchSignedSucccess = function (payload) { return ({
    type: FETCH_SIGNED_SUCCESS,
    payload: payload,
}); };
var fetchSignedFailed = function (error) { return ({
    type: FETCH_SIGNED_FAILED,
    error: error,
}); };

var actions$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_LIST: FETCH_LIST,
  FETCH_LIST_SUCCESS: FETCH_LIST_SUCCESS,
  FETCH_LIST_FAILED: FETCH_LIST_FAILED,
  FETCH_SIGNED: FETCH_SIGNED,
  FETCH_SIGNED_SUCCESS: FETCH_SIGNED_SUCCESS,
  FETCH_SIGNED_FAILED: FETCH_SIGNED_FAILED,
  fetchList: fetchList$2,
  fetchListSuccess: fetchListSuccess$2,
  fetchListFailed: fetchListFailed$2,
  fetchSigned: fetchSigned,
  fetchSignedSucccess: fetchSignedSucccess,
  fetchSignedFailed: fetchSignedFailed
});

var FETCH_OPT_INS = 'privacy/fetch-opt-ins';
var FETCH_OPT_INS_SUCCESS = 'privacy/fetch-opt-ins-success';
var FETCH_OPT_INS_FAILED = 'privacy/fetch-opt-ins-failed';
var UPDATE_OPT_INS = 'privacy/update-opt-ins';
var UPDATE_OPT_INS_SUCCESS = 'privacy/update-opt-ins-success';
var UPDATE_OPT_INS_FAILED = 'privacy/update-opt-ins-failed';
var fetchOptIns = function () { return ({
    type: FETCH_OPT_INS,
}); };
var fetchOptInsSuccess = function (payload) { return ({
    type: FETCH_OPT_INS_SUCCESS,
    payload: payload,
}); };
var fetchOptInsFailed = function (error) { return ({
    type: FETCH_OPT_INS_FAILED,
    error: error,
}); };
var updateOptIns = function (payload) { return ({
    type: UPDATE_OPT_INS,
    payload: payload,
}); };
var updateOptInsSuccess = function () { return ({
    type: UPDATE_OPT_INS_SUCCESS,
}); };
var updateOptInsFailed = function (error) { return ({
    type: UPDATE_OPT_INS_FAILED,
    error: error,
}); };

var actions$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_OPT_INS: FETCH_OPT_INS,
  FETCH_OPT_INS_SUCCESS: FETCH_OPT_INS_SUCCESS,
  FETCH_OPT_INS_FAILED: FETCH_OPT_INS_FAILED,
  UPDATE_OPT_INS: UPDATE_OPT_INS,
  UPDATE_OPT_INS_SUCCESS: UPDATE_OPT_INS_SUCCESS,
  UPDATE_OPT_INS_FAILED: UPDATE_OPT_INS_FAILED,
  fetchOptIns: fetchOptIns,
  fetchOptInsSuccess: fetchOptInsSuccess,
  fetchOptInsFailed: fetchOptInsFailed,
  updateOptIns: updateOptIns,
  updateOptInsSuccess: updateOptInsSuccess,
  updateOptInsFailed: updateOptInsFailed
});

var FETCH_USER_DATA = 'auth/fetch-user-data';
var FETCH_USER_DATA_FAILED = 'auth/fetch-user-data-failed';
var FETCH_USER_DATA_SUCCESS = 'auth/fetch-user-data-success';
var UPDATE_USER_DATA = 'auth/update-user-data';
var UPDATE_USER_DATA_FAILED = 'auth/update-user-data-failed';
var UPDATE_USER_DATA_SUCCESS = 'auth/update-user-data-success';
var STORE_FORM_DATA = 'auth/store-form-data';
var TOGGLE_FORM_EDIT_MODE = 'auth/toggle-form-edit-mode';
var toggleFormEditMode = function (payload) { return ({
    type: TOGGLE_FORM_EDIT_MODE,
    payload: payload,
}); };
var fetchUserData = function () { return ({
    type: FETCH_USER_DATA,
}); };
var fetchUserDataFailed = function (error) { return ({
    type: FETCH_USER_DATA_FAILED,
    error: error,
}); };
var fetchUserDataSuccess = function (payload) { return ({
    type: FETCH_USER_DATA_SUCCESS,
    payload: payload,
}); };
var updateUserData = function (payload) { return ({
    type: UPDATE_USER_DATA,
    payload: payload,
}); };
var updateUserDataFailed = function (payload) { return ({
    type: UPDATE_USER_DATA_FAILED,
    payload: payload,
}); };
var updateUserDataSuccess = function (payload) { return ({
    type: UPDATE_USER_DATA_SUCCESS,
    payload: payload,
}); };

var actions$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_USER_DATA: FETCH_USER_DATA,
  FETCH_USER_DATA_FAILED: FETCH_USER_DATA_FAILED,
  FETCH_USER_DATA_SUCCESS: FETCH_USER_DATA_SUCCESS,
  UPDATE_USER_DATA: UPDATE_USER_DATA,
  UPDATE_USER_DATA_FAILED: UPDATE_USER_DATA_FAILED,
  UPDATE_USER_DATA_SUCCESS: UPDATE_USER_DATA_SUCCESS,
  STORE_FORM_DATA: STORE_FORM_DATA,
  TOGGLE_FORM_EDIT_MODE: TOGGLE_FORM_EDIT_MODE,
  toggleFormEditMode: toggleFormEditMode,
  fetchUserData: fetchUserData,
  fetchUserDataFailed: fetchUserDataFailed,
  fetchUserDataSuccess: fetchUserDataSuccess,
  updateUserData: updateUserData,
  updateUserDataFailed: updateUserDataFailed,
  updateUserDataSuccess: updateUserDataSuccess
});

var RESET_PASSWORD = 'account/reset-password/reset-password';
var RESET_PASSWORD_SUCCESS = 'account/reset-password/reset-password-success';
var RESET_PASSWORD_FAILED = 'account/reset-password/reset-password-failed';
var UPDATE_PASSWORD = 'account/reset-password/update-password';
var UPDATE_PASSWORD_FAILED = 'account/reset-password/update-password-failed';
var UPDATE_PASSWORD_SUCCESS = 'account/reset-password/update-password-success';
var CHANGE_PASSWORD = 'account/reset-password/change-password';
var CHANGE_PASSWORD_FAILED = 'account/reset-password/change-password-failed';
var CHANGE_PASSWORD_SUCCESS = 'account/reset-password/change-password-success';
var resetPassword = function (payload) { return ({
    type: RESET_PASSWORD,
    payload: payload,
}); };
var resetPasswordSuccess = function (payload) { return ({
    type: RESET_PASSWORD_SUCCESS,
    payload: payload,
}); };
var resetPasswordFailed = function (error) { return ({
    type: RESET_PASSWORD_FAILED,
    error: error,
}); };
var updatePassword = function (payload) { return ({
    type: UPDATE_PASSWORD,
    payload: payload,
}); };
var updatePasswordFailed = function (error) { return ({
    type: UPDATE_PASSWORD_FAILED,
    error: error,
}); };
var updatePasswordSuccess = function (payload) { return ({
    type: UPDATE_PASSWORD_SUCCESS,
    payload: payload,
}); };
var changePassword = function (payload) { return ({
    type: CHANGE_PASSWORD,
    payload: payload,
}); };
var changePasswordFailed = function (error) { return ({
    type: CHANGE_PASSWORD_FAILED,
    error: error,
}); };
var changePasswordSuccess = function (payload) { return ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload: payload,
}); };

var actions$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RESET_PASSWORD: RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS: RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILED: RESET_PASSWORD_FAILED,
  UPDATE_PASSWORD: UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILED: UPDATE_PASSWORD_FAILED,
  UPDATE_PASSWORD_SUCCESS: UPDATE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD: CHANGE_PASSWORD,
  CHANGE_PASSWORD_FAILED: CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS: CHANGE_PASSWORD_SUCCESS,
  resetPassword: resetPassword,
  resetPasswordSuccess: resetPasswordSuccess,
  resetPasswordFailed: resetPasswordFailed,
  updatePassword: updatePassword,
  updatePasswordFailed: updatePasswordFailed,
  updatePasswordSuccess: updatePasswordSuccess,
  changePassword: changePassword,
  changePasswordFailed: changePasswordFailed,
  changePasswordSuccess: changePasswordSuccess
});

var FETCH_DETAIL$1 = 'auth/subscriptions/fetch-detail';
var FETCH_DETAIL_SUCCESS$1 = 'auth/subscriptions/fetch-detail-success';
var FETCH_DETAIL_FAILED$1 = 'auth/subscriptions/fetch-detail-failed';
var PAUSE = 'auth/subscriptions/pause';
var PAUSE_SUCCESS = 'auth/subscriptions/pause-success';
var PAUSE_FAILED = 'auth/subscriptions/pause-failed';
var QUANTITY = 'auth/subscriptions/quantity';
var QUANTITY_SUCCESS = 'auth/subscriptions/quantity-success';
var QUANTITY_FAILED = 'auth/subscriptions/quantity-failed';
var FETCH_PRODUCT_DATA = 'auth/subscriptions/fetch-product-data';
var FETCH_PRODUCT_DATA_SUCCESS = 'auth/subscriptions/fetch-product-data-success';
var FETCH_PRODUCT_DATA_FAILED = 'auth/subscriptions/fetch-product-data-failed';
var FETCH_LIST$1 = 'auth/subscriptions/fetch-list';
var FETCH_LIST_SUCCESS$1 = 'auth/subscriptions/fetch-list-success';
var FETCH_LIST_FAILED$1 = 'auth/subscriptions/fetch-list-failed';
var SUBSCRIPTION_ADDRESS_UPDATE = 'auth/subscriptions/subscription-address/update';
var SUBSCRIPTION_ADDRESS_RESET = 'auth/subscriptions/subscription-address/reset';
var SUBSCRIPTION_ADDRESS_SAVE = 'auth/subscriptions/subscription-address/save';
var SUBSCRIPTION_ADDRESS_SAVE_FAILED = 'auth/subscriptions/subscription-address/save-failed';
var SUBSCRIPTION_ADDRESS_SAVE_SUCCESS = 'auth/subscriptions/subscription-address/save-success';
var SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE = 'auth/subscriptions/subscription-address/set-is-edit-mode';
var SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN = 'auth/subscriptions/subscription-address/is-modal-open';
var fetchDetail$1 = function (payload) { return ({
    type: FETCH_DETAIL$1,
    payload: payload,
}); };
var fetchDetailSuccess$1 = function (payload) { return ({
    type: FETCH_DETAIL_SUCCESS$1,
    payload: payload,
}); };
var fetchDetailFailed$1 = function (error) { return ({
    type: FETCH_DETAIL_FAILED$1,
    error: error,
}); };
var pause = function (payload) { return ({
    type: PAUSE,
    payload: payload,
}); };
var pauseSuccess = function (payload) { return ({
    type: PAUSE_SUCCESS,
    payload: payload,
}); };
var pauseFailed = function (error) { return ({
    type: PAUSE_FAILED,
    error: error,
}); };
var quantity = function (payload) { return ({
    type: QUANTITY,
    payload: payload,
}); };
var quantitySuccess = function (payload) { return ({
    type: QUANTITY_SUCCESS,
    payload: payload,
}); };
var quantityFailed = function (payload) { return ({
    type: QUANTITY_FAILED,
    payload: payload,
}); };
var fetchProductData = function (payload) { return ({
    type: FETCH_PRODUCT_DATA,
    payload: payload,
}); };
var fetchProductDataSuccess = function (payload) { return ({
    type: FETCH_PRODUCT_DATA_SUCCESS,
    payload: payload,
}); };
var fetchProductDataFailed = function (payload) { return ({
    type: FETCH_PRODUCT_DATA_FAILED,
    payload: payload,
}); };
var fetchList$3 = function () { return ({ type: FETCH_LIST$1 }); };
var fetchListSuccess$3 = function (payload) { return ({
    type: FETCH_LIST_SUCCESS$1,
    payload: payload,
}); };
var fetchListFailed$3 = function (error) { return ({
    type: FETCH_LIST_FAILED$1,
    error: error,
}); };
var updateSubscriptionAddress = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_UPDATE,
    payload: payload,
}); };
var resetSubscriptionAddress = function () { return ({
    type: SUBSCRIPTION_ADDRESS_RESET,
}); };
var saveSubscriptionAddress = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_SAVE,
    payload: payload,
}); };
var saveSubscriptionAddressSuccess = function () { return ({
    type: SUBSCRIPTION_ADDRESS_SAVE_SUCCESS,
}); };
var saveSubscriptionAddressFailed = function (error) { return ({
    type: SUBSCRIPTION_ADDRESS_SAVE_FAILED,
    error: error,
}); };
var setSubscriptionFormIsModalOpen = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN,
    payload: payload,
}); };
var setSubscriptionFormIsEditMode = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE,
    payload: payload,
}); };

var actions$a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_DETAIL: FETCH_DETAIL$1,
  FETCH_DETAIL_SUCCESS: FETCH_DETAIL_SUCCESS$1,
  FETCH_DETAIL_FAILED: FETCH_DETAIL_FAILED$1,
  PAUSE: PAUSE,
  PAUSE_SUCCESS: PAUSE_SUCCESS,
  PAUSE_FAILED: PAUSE_FAILED,
  QUANTITY: QUANTITY,
  QUANTITY_SUCCESS: QUANTITY_SUCCESS,
  QUANTITY_FAILED: QUANTITY_FAILED,
  FETCH_PRODUCT_DATA: FETCH_PRODUCT_DATA,
  FETCH_PRODUCT_DATA_SUCCESS: FETCH_PRODUCT_DATA_SUCCESS,
  FETCH_PRODUCT_DATA_FAILED: FETCH_PRODUCT_DATA_FAILED,
  FETCH_LIST: FETCH_LIST$1,
  FETCH_LIST_SUCCESS: FETCH_LIST_SUCCESS$1,
  FETCH_LIST_FAILED: FETCH_LIST_FAILED$1,
  SUBSCRIPTION_ADDRESS_UPDATE: SUBSCRIPTION_ADDRESS_UPDATE,
  SUBSCRIPTION_ADDRESS_RESET: SUBSCRIPTION_ADDRESS_RESET,
  SUBSCRIPTION_ADDRESS_SAVE: SUBSCRIPTION_ADDRESS_SAVE,
  SUBSCRIPTION_ADDRESS_SAVE_FAILED: SUBSCRIPTION_ADDRESS_SAVE_FAILED,
  SUBSCRIPTION_ADDRESS_SAVE_SUCCESS: SUBSCRIPTION_ADDRESS_SAVE_SUCCESS,
  SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE: SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE,
  SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN: SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN,
  fetchDetail: fetchDetail$1,
  fetchDetailSuccess: fetchDetailSuccess$1,
  fetchDetailFailed: fetchDetailFailed$1,
  pause: pause,
  pauseSuccess: pauseSuccess,
  pauseFailed: pauseFailed,
  quantity: quantity,
  quantitySuccess: quantitySuccess,
  quantityFailed: quantityFailed,
  fetchProductData: fetchProductData,
  fetchProductDataSuccess: fetchProductDataSuccess,
  fetchProductDataFailed: fetchProductDataFailed,
  fetchList: fetchList$3,
  fetchListSuccess: fetchListSuccess$3,
  fetchListFailed: fetchListFailed$3,
  updateSubscriptionAddress: updateSubscriptionAddress,
  resetSubscriptionAddress: resetSubscriptionAddress,
  saveSubscriptionAddress: saveSubscriptionAddress,
  saveSubscriptionAddressSuccess: saveSubscriptionAddressSuccess,
  saveSubscriptionAddressFailed: saveSubscriptionAddressFailed,
  setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen,
  setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode
});

/*
 * UnlinkOrder actions
 */
var unlinkOrder = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/orders/unlink', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var unlinkOrderSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/orders/unlink-success');
var unlinkOrderFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/orders/unlink-failed', function (error) { return ({
    error: error,
}); });
/*
 * UnlinkAppointment actions
 */
var unlinkAppointment = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/unlink', _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].payload());
var unlinkAppointmentSuccess = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/unlink-success');
var unlinkAppointmentFailed = _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].action('auth/appointments/unlink-failed', function (error) { return ({
    error: error,
}); });

var actions$b = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unlinkOrder: unlinkOrder,
  unlinkOrderSuccess: unlinkOrderSuccess,
  unlinkOrderFailed: unlinkOrderFailed,
  unlinkAppointment: unlinkAppointment,
  unlinkAppointmentSuccess: unlinkAppointmentSuccess,
  unlinkAppointmentFailed: unlinkAppointmentFailed
});

var INIT = 'auth/init';
var GOTO = 'auth/goto';
var CHANGE_FORM_VALUE = 'auth/change-form-value';
var CREATE_ORDER = 'auth/create-order';
var CREATE_ORDER_SUCCESS = 'auth/create-order-success';
var CREATE_ORDER_FAILED = 'auth/create-order-failed';
var TOGGLE_OPT_INS = 'auth/toggle-opt-ins';
var init = function (payload) { return ({
    type: INIT,
    payload: payload,
}); };
var goto = function (payload) { return ({
    type: GOTO,
    payload: payload,
}); };
var changeFormValue = function (payload) { return ({
    type: CHANGE_FORM_VALUE,
    payload: payload,
}); };
var createOrder = function (payload) { return ({
    type: CREATE_ORDER,
    payload: payload,
}); };
var createOrderSuccess = function (payload) { return ({
    type: CREATE_ORDER_SUCCESS,
    payload: payload,
}); };
var createOrderFailed = function (error) { return ({
    type: CREATE_ORDER_FAILED,
    error: error,
}); };
var toggleOptIns = function (payload) { return ({
    type: TOGGLE_OPT_INS,
    payload: payload,
}); };

var actions$c = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddressBookActions: actions,
  AppointmentsActions: actions$1,
  CreateAccountActions: actions$2,
  LoginActions: actions$3,
  LogoutActions: actions$4,
  ProfileActions: actions$8,
  PrivacyActions: actions$7,
  OrdersActions: actions$5,
  SubscriptionsActions: actions$a,
  PrescriptionsActions: actions$6,
  ResetPasswordActions: actions$9,
  UnlinkActions: actions$b,
  INIT: INIT,
  GOTO: GOTO,
  CHANGE_FORM_VALUE: CHANGE_FORM_VALUE,
  CREATE_ORDER: CREATE_ORDER,
  CREATE_ORDER_SUCCESS: CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILED: CREATE_ORDER_FAILED,
  TOGGLE_OPT_INS: TOGGLE_OPT_INS,
  init: init,
  goto: goto,
  changeFormValue: changeFormValue,
  createOrder: createOrder,
  createOrderSuccess: createOrderSuccess,
  createOrderFailed: createOrderFailed,
  toggleOptIns: toggleOptIns
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/**
 * This represents all states the auth package can be in
 */
var AuthState;
(function (AuthState) {
    AuthState["Uninitialized"] = "uninitialized";
    AuthState["Initialized"] = "initialized";
    AuthState["LoggedIn"] = "logged-in";
    AuthState["LoggedOut"] = "logged-out";
    AuthState["ParseHashFailed"] = "parse-hash-failed";
})(AuthState || (AuthState = {}));
function getLoggedInState(auth) {
    if (!auth || isUninitialized(auth) || isInitialized(auth)) {
        return 'loading';
    }
    if (isLoggedIn(auth)) {
        return AuthState.LoggedIn;
    }
    return AuthState.LoggedOut;
}
var isState = function (stateName) { return function (state) {
    return state.state === stateName;
}; };
var isUninitialized = isState(AuthState.Uninitialized);
var isInitialized = isState(AuthState.Initialized);
var isLoggedInPasswordless = function (state) {
    return state.state === AuthState.LoggedIn && state.type === 'passwordless';
};
var isLoggedIn = function (state) {
    return state.state === AuthState.LoggedIn && state.type === 'regular';
};
var isParseHashFailed = isState(AuthState.ParseHashFailed);
var isLoggedOut = isState(AuthState.LoggedOut);

var state = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AuthState () { return AuthState; },
  getLoggedInState: getLoggedInState,
  isUninitialized: isUninitialized,
  isInitialized: isInitialized,
  isLoggedInPasswordless: isLoggedInPasswordless,
  isLoggedIn: isLoggedIn,
  isParseHashFailed: isParseHashFailed,
  isLoggedOut: isLoggedOut
});

var getAuth = function (state) { return state.auth; };
/**
 * This will return true for all states except uninitialized
 */
var isInitialized$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) { return auth && !isUninitialized(auth); });
var isUninitialized$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return isUninitialized(auth);
});
var isLoggedIn$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) { return auth && auth.state === AuthState.LoggedIn; });
var getRouting = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) { return (isUninitialized(auth) ? undefined : auth.routing); });
var getRoutes = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getRouting, function (routing) {
    return routing ? routing.routes : undefined;
});
var getBasePath = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getRouting, function (routing) {
    return routing ? routing.basePath : undefined;
});
var getCheckoutRoute = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getRouting, function (routing) { return (routing ? routing.checkoutRoute : undefined); });
var getFormattedRoutes = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getRoutes, getBasePath, function (routes, basePath) {
    if (!routes || !basePath) {
        return undefined;
    }
    return Object.entries(routes).reduce(function (formattedRoutes, _a) {
        var _b;
        var _c = __read(_a, 2), name = _c[0], route = _c[1];
        return (__assign((_b = {}, _b[name] = "/" + basePath + "/" + route, _b), formattedRoutes));
    }, {});
});
var getDomain = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(isInitialized$1, getAuth, function (isInitialized, auth) {
    return isInitialized ? auth.domain : undefined;
});
var getCustomDomain = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(isInitialized$1, getAuth, function (isInitialized, auth) {
    return isInitialized ? auth.customDomain : undefined;
});
var getUserId = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return isLoggedIn(auth) ? auth.userId : undefined;
});
var isLoggedOut$1 = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) { return auth && auth.state === AuthState.LoggedOut; });
var getOptIns = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return !isUninitialized(auth) ? auth.optIns : [];
});
var getOptInsForSignup = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOptIns, function (optIns) {
    return optIns.filter(function (o) { return o.isInSignup; });
});
var getUnlinkAppointmentCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return !isUninitialized(auth) ? auth.unlinkAppointmentCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getUnlinkOrderCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return !isUninitialized(auth) ? auth.unlinkOrderCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAuth: getAuth,
  isInitialized: isInitialized$1,
  isUninitialized: isUninitialized$1,
  isLoggedIn: isLoggedIn$1,
  getRouting: getRouting,
  getRoutes: getRoutes,
  getBasePath: getBasePath,
  getCheckoutRoute: getCheckoutRoute,
  getFormattedRoutes: getFormattedRoutes,
  getDomain: getDomain,
  getCustomDomain: getCustomDomain,
  getUserId: getUserId,
  isLoggedOut: isLoggedOut$1,
  getOptIns: getOptIns,
  getOptInsForSignup: getOptInsForSignup,
  getUnlinkAppointmentCall: getUnlinkAppointmentCall,
  getUnlinkOrderCall: getUnlinkOrderCall
});

var ViewMode;
(function (ViewMode) {
    ViewMode["ADD"] = "ADD";
    ViewMode["DELETE"] = "DELETE";
    ViewMode["EDIT"] = "EDIT";
})(ViewMode || (ViewMode = {}));

var getAddressBook = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) { return (isLoggedIn(auth) ? auth.addressBook : undefined); });
var getAddressBookList = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.list : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
});
var getAddressBookListLength = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAddressBook, function (addressBook) {
    return addressBook && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(addressBook.list) ? addressBook.list.result.length : undefined;
});
var getAddCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.calls.add : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getEditCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.calls.edit : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getModalState = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.modalState : { isOpen: false, viewMode: ViewMode.ADD };
});
var getEditedAddress = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAddressBook, function (addressBook) {
    return (addressBook === null || addressBook === void 0 ? void 0 : addressBook.currentlyEditingId) ? addressBook === null || addressBook === void 0 ? void 0 : addressBook.pendingListChanges[addressBook.currentlyEditingId] : undefined;
});

var selectors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAddressBook: getAddressBook,
  getAddressBookList: getAddressBookList,
  getAddressBookListLength: getAddressBookListLength,
  getAddCall: getAddCall,
  getEditCall: getEditCall,
  getModalState: getModalState,
  getEditedAddress: getEditedAddress
});

var AddAddress = function (_a) {
    var addressForm = _a.addressForm, onSubmit = _a.onSubmit, className = _a.className;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var addCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddCall);
    var isAddCallLoading = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(addCall);
    var isAddCallFailed = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(addCall);
    var handleSubmit = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (state) {
        var _a = _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].getValuesFromState(state.formState), firstName = _a.firstName, lastName = _a.lastName, streetName = _a.streetName, rest = __rest(_a, ["firstName", "lastName", "streetName"]);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(__assign({ firstName: firstName,
            lastName: lastName,
            streetName: streetName, addressTypes: [] }, rest));
    }, []);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        isAddCallFailed && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: getLabel('checkout.addressBook.newAddress.error') })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Form */ "j"], { name: "add-address", "data-t": "add-address", onSubmit: handleSubmit, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('add-address', className) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("fieldset", { disabled: isAddCallLoading, className: "add-address__fieldset", "data-t": "add-address__fieldset" }, addressForm))));
};

var FormName;
(function (FormName) {
    FormName["personalDetails"] = "personalDetails";
    FormName["billingAddress"] = "billingAddress";
    FormName["preferredStore"] = "preferredStore";
})(FormName || (FormName = {}));
var isProfileForm = function (formName) {
    if (typeof formName === 'string') {
        return formName in FormName;
    }
    return formName.formName in FormName;
};

var state$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get FormName () { return FormName; },
  isProfileForm: isProfileForm
});

var getParsedDataFromLS = function () {
    try {
        var value = window.localStorage.getItem(FormName.personalDetails);
        if (value !== null && value !== 'undefined' && value !== '' && value.trim() !== '') {
            var returnValue = JSON.parse(value);
            if (typeof returnValue !== 'object') {
                return undefined;
            }
            if (Object.values(returnValue).some(function (v) { return typeof v !== 'string'; })) {
                return undefined;
            }
            return returnValue;
        }
        else {
            return undefined;
        }
    }
    catch (error) {
        console.error(error);
    }
};
var writeUserDataToLS = function (data) {
    try {
        window.localStorage.setItem(FormName.personalDetails, JSON.stringify(data));
    }
    catch (error) {
        console.error(error);
    }
};
var removeUserDataFromLS = function () {
    try {
        window.localStorage.removeItem(FormName.personalDetails);
    }
    catch (error) {
        console.error(error);
    }
};

var UNAVAILABLE = { status: 'unavailable' };
function isDataUnavailable(state) {
    return state.status === 'unavailable';
}
function isDataLoading(state) {
    return state.status === _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* LOADING */ "j"];
}
function isDataSuccess(state) {
    return state.status === _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* SUCCESS */ "o"];
}
var fetchIfUninit = function (props) {
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(props.auth.profile.userData)) {
        props.fetchUserData();
    }
    if (props.loadOptIns && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(props.auth.privacy.optInsOnServer)) {
        props.fetchOptIns();
    }
};
var resourceToDataState = function (resource, defaultState, extractSuccess) {
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(resource)) {
        return extractSuccess(resource);
    }
    else if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(resource)) {
        return UNAVAILABLE;
    }
    else {
        return defaultState;
    }
};
function WithUserData(Component$1) {
    var wrappedName = Component$1.displayName || Component$1.name || 'Component';
    var Wrapper = /** @class */ (function (_super) {
        __extends(Wrapper, _super);
        function Wrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Wrapper.prototype.componentDidMount = function () {
            var auth = this.props.auth;
            if (isInitialized(auth)) {
                this.props.recoverSession();
            }
            if (isLoggedIn(auth)) {
                fetchIfUninit(this.props);
            }
        };
        Wrapper.prototype.componentDidUpdate = function (prevProps) {
            if (isUninitialized(prevProps.auth) && isInitialized(this.props.auth)) {
                this.props.recoverSession();
            }
            if (isInitialized(prevProps.auth) && isLoggedIn(this.props.auth)) {
                fetchIfUninit(this.props);
            }
        };
        Wrapper.prototype.render = function () {
            var _a = this.props, auth = _a.auth, loadOptIns = _a.loadOptIns;
            var email = auth.email;
            var userData = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])();
            var optInsData = loadOptIns ? Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() : UNAVAILABLE;
            if (!isUninitialized(auth) && !isInitialized(auth)) {
                userData = UNAVAILABLE;
                optInsData = UNAVAILABLE;
            }
            if (isLoggedIn(auth)) {
                userData = resourceToDataState(auth.profile.userData, Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(), function (userData) {
                    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(__assign(__assign({}, userData.result), { email: email }));
                });
                optInsData = resourceToDataState(auth.privacy.optInsOnServer, loadOptIns ? Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() : UNAVAILABLE, function (serverOptIns) { return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(serverOptIns.result.optinValues); });
            }
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Component$1, __assign({}, this.props, { userData: userData, optInsData: optInsData }));
        };
        Wrapper.displayName = "WithUserData(" + wrappedName + ")";
        return Wrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
    var mapStateToProps = function (state) { return ({
        auth: getAuth(state),
    }); };
    var ConnectedWrapper = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps, {
        recoverSession: recoverSession,
        fetchUserData: fetchUserData,
        fetchOptIns: fetchOptIns,
    })(Wrapper);
    return function (props) {
        return props.isMyAccountEnabled ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(ConnectedWrapper, __assign({}, props))) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Component$1, __assign({}, props, { userData: UNAVAILABLE, optInsData: UNAVAILABLE })));
    };
}

var Loader = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SkeletonLoader */ "hb"], { className: "myaccount-menu-loader", "data-t": "myaccount-menu-loader" },
    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "16" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "100%", height: "16", rx: "5", fill: "currentColor" })))); };

var SummaryName;
(function (SummaryName) {
    SummaryName["addressSummary"] = "addressSummary";
    SummaryName["storeAddressSummary"] = "storeAddressSummary";
    SummaryName["personalDetailsSummary"] = "personalDetailsSummary";
    SummaryName["preferredStoreSummary"] = "preferredStoreSummary";
    SummaryName["paymentDetailsSummary"] = "paymentDetailsSummary";
    SummaryName["personalGreeting"] = "personalGreeting";
    SummaryName["menuGreeting"] = "menuGreeting";
})(SummaryName || (SummaryName = {}));
var DefaultFormTemplates = function () {
    var _a;
    return (_a = {},
        _a[FormName.personalDetails] = (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlContext */ "g"].Consumer, null, function (intl) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* FirstName */ "i"], { label: intl.getLabel('checkout.contact.firstName'), errorMessage: intl.getLabel('checkout.contact.firstName.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* LastName */ "p"], { label: intl.getLabel('checkout.contact.lastName'), errorMessage: intl.getLabel('checkout.contact.lastName.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* PhoneNumber */ "t"], { label: intl.getLabel('checkout.contact.phoneNumber'), errorMessage: intl.getLabel('checkout.contact.phoneNumber.errorMessage') }))); })),
        _a[FormName.billingAddress] = (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlContext */ "g"].Consumer, null, function (intl) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null,
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* FirstName */ "i"], { label: intl.getLabel('checkout.contact.firstName'), errorMessage: intl.getLabel('checkout.contact.firstName.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* LastName */ "p"], { label: intl.getLabel('checkout.contact.lastName'), errorMessage: intl.getLabel('checkout.contact.lastName.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* AddressLine */ "a"], { count: "1", label: intl.getLabel('checkout.address.addressLine') + ' 1', errorMessage: intl.getLabel('checkout.address.addressLine.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* HouseNumber */ "m"], { label: intl.getLabel('checkout.contact.houseNumber'), errorMessage: intl.getLabel('checkout.contact.houseNumber.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* HouseNumberSuffix */ "n"], { label: intl.getLabel('checkout.contact.houseNumberSuffix'), errorMessage: intl.getLabel('checkout.contact.houseNumberSuffix.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* PostalCode */ "u"], { label: intl.getLabel('checkout.address.postalCode'), errorMessage: intl.getLabel('checkout.address.postalCode.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* City */ "c"], { label: intl.getLabel('checkout.address.city'), errorMessage: intl.getLabel('checkout.address.city.errorMessage') }),
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Region */ "y"], { required: false, label: intl.getLabel('checkout.address.district') }))); })),
        _a);
};
var DefaultSummaryTemplates = function () {
    var _a;
    return (_a = {},
        _a[SummaryName.addressSummary] = function (_a, title) {
            var data = _a.data;
            return (
            // TODO: Clean up soon. This became very messy becuase of inconsistencies in interfaces (due to OpCo acceptance criteria).
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null,
                title && react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", { className: "h6" }, title),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.firstName, data.lastName]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.streetName, data.streetinteger]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.addressLine1, data.streetNumber, data.additionalStreetInfo]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.addressLine2),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.addressLine3),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.postalCode, data.city]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.region),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.country)));
        },
        _a[SummaryName.storeAddressSummary] = function (_a, title) {
            var data = _a.data;
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null,
                title && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", null,
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("b", null, title))),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.storeName),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.streetName, data.streetNumber]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.postalCode, data.town]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.country, data.province && "(" + data.province + ")"])));
        },
        _a[SummaryName.personalDetailsSummary] = function (_a, title) {
            var data = _a.data, email = _a.email;
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null,
                title && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", null,
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("b", null, title))),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.firstName, data.lastName]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.phone),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(email)));
        },
        _a[SummaryName.preferredStoreSummary] = function (_a, title) {
            var data = _a.data;
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null,
                title && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", null,
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("b", null, title))),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.storeName),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.streetName, data.streetNumber]),
                Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([data.postalCode, data.town])));
        },
        _a[SummaryName.paymentDetailsSummary] = function (_a, title) {
            var data = _a.data, getLabel = _a.getLabel;
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("section", { className: "payment-details-summary" },
                title && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", null,
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("b", null, title))),
                data.type && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "row" },
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(getLabel('account.subscription.payment.method') + ": "),
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.type))),
                data.details.bankName && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "row" },
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(getLabel('account.subscription.payment.provider') + ": "),
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.details.bankName))),
                data.details.bankNumber && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "row" },
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(getLabel('account.subscription.payment.accountNumber') + ": "),
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.details.bankNumber))),
                data.details.bankSortCode && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "row" },
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(getLabel('account.subscription.payment.sortCode') + ": "),
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.details.bankSortCode))),
                data.details.bankAccountHolderName && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "row" },
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(getLabel('account.subscription.payment.accountHolder') + ": "),
                    Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(data.details.bankAccountHolderName)))));
        },
        _a[SummaryName.personalGreeting] = function (_a) {
            var data = _a.data, getLabel = _a.getLabel;
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, data && data.firstName
                ? getLabel('account.profile.title.personalized', {
                    labelData: data,
                    hideLabelKey: true,
                })
                : getLabel('account.profile.title')));
        },
        _a[SummaryName.menuGreeting] = function (_a) {
            var data = _a.data, getLabel = _a.getLabel;
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, data && data.firstName && data.lastName
                ? getLabel('account.menu.greeting.withPersonalDetails', {
                    labelData: data,
                })
                : getLabel('account.menu.greeting.withoutPersonalDetails')));
        },
        _a);
};
var DefaultOrderTemplates = function () { return ({
    address: function (address) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null,
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([address.firstName, address.lastName]),
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([address.streetName, address.streetNumber, address.additionalStreetInfo]),
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([address.postalCode, address.city]),
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(address.region))); },
    storeAddress: function (address) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null,
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(address.company),
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([address.streetName, address.streetNumber, address.additionalStreetInfo]),
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])([address.postalCode, address.city]),
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(address.region))); },
    contactDetails: function (order) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null,
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(order.customerInfo.email),
        Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(order.customerInfo.phone))); },
}); };

var PersonalizedGreeting = function (_a) {
    var auth = _a.auth, greetingFormatter = _a.greetingFormatter;
    var getFormattedLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getFormattedLabel;
    var personalDetails = getParsedDataFromLS();
    var hasPersonalDetails = Boolean(personalDetails);
    var isLoggedIn = getLoggedInState(auth) === 'logged-in';
    var formatter = greetingFormatter || DefaultSummaryTemplates()[SummaryName.menuGreeting];
    var appearLoggedIn = isLoggedIn || hasPersonalDetails;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        appearLoggedIn ? Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { name: "user-checkmark" }) : Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { name: "user" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "myaccount-menu-button__label", "data-t": "personalized-greeting" }, formatter({ data: personalDetails, getLabel: getFormattedLabel }))));
};

var MyAccountMenu = function (_a) {
    var _b = _a.menuItems, menuItems = _b === void 0 ? [] : _b, greetingFormatter = _a.greetingFormatter, auth = _a.auth, userData = _a.userData, className = _a.className;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('myaccount-menu', className);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var loggedInState = getLoggedInState(auth);
    var triggerContent;
    if (getParsedDataFromLS()) {
        if (loggedInState === 'logged-in') {
            if (userData && isDataSuccess(userData)) {
                userData.result.personalDetails && writeUserDataToLS(userData.result.personalDetails);
            }
        }
        triggerContent = Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PersonalizedGreeting, { auth: auth, greetingFormatter: greetingFormatter });
    }
    else {
        if (loggedInState === 'logged-in') {
            if (userData && isDataLoading(userData)) {
                triggerContent = Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Loader, null);
            }
            if (userData && isDataSuccess(userData)) {
                userData.result.personalDetails && writeUserDataToLS(userData.result.personalDetails);
                triggerContent = Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PersonalizedGreeting, { auth: auth, greetingFormatter: greetingFormatter });
            }
        }
        else if (loggedInState === 'logged-out') {
            triggerContent = (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { name: "user" }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { "data-t": "logged-out-greeting", className: "myaccount-menu-button__label" }, getLabel('account.menu.greeting.loggedOut'))));
        }
        else if (loggedInState === 'loading') {
            triggerContent = Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Loader, null);
        }
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Flyout */ "s"], { "data-t": "myaccount-menu", id: "myaccount-menu", className: classes },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Flyout */ "s"].Trigger, { "data-t": "my-account-menu-button", className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('header-menu__icon myaccount-menu-button', className, 'myaccount-menu-button--link'), title: getLabel('account.menu.myAccount'), "aria-controls": "myaccount-menu" }, triggerContent),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Flyout */ "s"].Menu, null, menuItems.map(function (item) {
            var _a, _b;
            return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Flyout */ "s"].MenuItem, { key: item.label, link: (_a = item.link) === null || _a === void 0 ? void 0 : _a.href, action: (_b = item.parameters) === null || _b === void 0 ? void 0 : _b.action }, item.label));
        }))));
};
var mapStateToProps = function (state) { return ({
    auth: getAuth(state),
}); };
var MyAccountMenuWithUserData = WithUserData(MyAccountMenu);
var MyAccountMenuWrapper = function (props) {
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountMenuWithUserData, __assign({}, props, { isMyAccountEnabled: true }));
};
var MyAccountMenu$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps)(MyAccountMenuWrapper);

var AuthContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["createContext"])({});
var AuthContextConsumer = function (_a) {
    var children = _a.children;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AuthContext.Consumer, null, function (context) {
        if (!context || Object.keys(context).length === 0) {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "my-account--no-context" }, "Auth Provider missing in application.");
        }
        if (!context.enabled) {
            // TODO: instead redirect?
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "my-account--not-enabled" }, "Auth not enabled in application.");
        }
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, children);
    }));
};

function getActivePath() {
    var url = new URL(window.location.href);
    return url.pathname;
}
var getMyAccountMenuItems = function (logout, routes, intl, isUserLoggedIn, isAddressBookEnabled) {
    var _a, _b, _c, _d, _e;
    var activePath = getActivePath();
    var logoutItem = {
        label: intl.getLabel('account.menu.logOut'),
        parameters: {
            icon: 'logout',
            action: logout,
        },
        childMenuItems: [],
        link: { href: '', type: 'external' },
    };
    var loginItem = {
        label: intl.getLabel('account.action.login'),
        childMenuItems: [],
        link: { href: routes.login, type: 'external' },
    };
    function getProfileChildMenuItems() {
        var _a, _b;
        var items = [];
        if (isAddressBookEnabled) {
            items.push({
                label: intl.getLabel('account.menu.addresses'),
                link: {
                    href: (_a = routes.addressBook) !== null && _a !== void 0 ? _a : '',
                    type: 'external',
                    active: [routes.addressBook].includes(activePath),
                },
            });
        }
        items.push({
            label: intl.getLabel('account.menu.changePassword'),
            link: {
                href: (_b = routes.changePassword) !== null && _b !== void 0 ? _b : '',
                type: 'external',
                active: [routes.changePassword].includes(activePath),
            },
        });
        return items;
    }
    var userHasParsedDataFromLS = getParsedDataFromLS();
    var lastItem = logoutItem;
    if (!isUserLoggedIn && !userHasParsedDataFromLS) {
        lastItem = loginItem;
    }
    var items = [
        {
            label: intl.getLabel('account.menu.accountDetails'),
            parameters: {
                icon: 'user',
            },
            link: {
                href: (_a = routes.profile) !== null && _a !== void 0 ? _a : '',
                type: 'external',
                active: [routes.addressBook, routes.changePassword, routes.profile].includes(activePath),
            },
            childMenuItems: getProfileChildMenuItems(),
        },
        {
            label: intl.getLabel('account.menu.prescriptions'),
            parameters: {
                icon: 'frame',
            },
            link: {
                href: (_b = routes.prescriptions) !== null && _b !== void 0 ? _b : '',
                type: 'external',
                active: routes.prescriptions === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.orders'),
            parameters: {
                icon: 'orders',
            },
            link: {
                href: (_c = routes.orders) !== null && _c !== void 0 ? _c : '',
                type: 'external',
                active: routes.orders === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.subscriptions'),
            parameters: {
                icon: 'shipment-next',
            },
            link: {
                href: (_d = routes.subscriptions) !== null && _d !== void 0 ? _d : '',
                type: 'external',
                active: routes.subscriptions === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.privacy'),
            parameters: {
                icon: 'lock',
            },
            link: {
                href: (_e = routes.privacy) !== null && _e !== void 0 ? _e : '',
                type: 'external',
                active: routes.privacy === activePath,
            },
        },
        lastItem,
    ];
    var hasLink = function (item) { var _a; return ((_a = item.link) === null || _a === void 0 ? void 0 : _a.href) && item.link.href !== ''; };
    var hasAction = function (item) { var _a; return (_a = item.parameters) === null || _a === void 0 ? void 0 : _a.action; };
    return items.filter(function (item) { return hasLink(item) || hasAction(item); });
};

var elementName = 'myaccount-page-with-menu';
var PageWithMenu = function (_a) {
    var routes = _a.routes, logout = _a.logout, children = _a.children, authState = _a.authState;
    var isTabletLandscapeAndUp = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useIsAbove(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.TABLET_PORTRAIT);
    var isUserLoggedIn = isLoggedIn(authState);
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var isAddressBookEnabled = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useFeatureToggles */ "P"])().isAddressBookEnabled;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("article", { className: elementName },
        routes && isTabletLandscapeAndUp && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_layout__WEBPACK_IMPORTED_MODULE_8__[/* SubMenuLinks */ "j"], { items: getMyAccountMenuItems(logout, routes, intl, isUserLoggedIn, isAddressBookEnabled) })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: elementName + "__content" }, children)));
};
var mapStateToProps$1 = function (state) { return ({
    authState: getAuth(state),
    routes: getFormattedRoutes(state),
}); };
var dispatchProps = {
    logout: logOut,
};
var PageWithMenu$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$1, dispatchProps)(PageWithMenu);

// Strips out all falsy values so the formatter can handle it.
var sanitizeAddress = function (_a) {
    var addressTypes = _a.addressTypes, rest = __rest(_a, ["addressTypes"]);
    return Object.entries(rest).reduce(function (a, _a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        return (v ? ((a[k] = v), a) : a);
    }, {});
};

var sortAddresses = function (list) {
    return list
        .map(function (address) { return (__assign(__assign({}, address), { createdAt: address.createdAt || '0' })); })
        .sort(function (a, b) { return b.createdAt.localeCompare(a.createdAt, 'en', { usage: 'sort', numeric: true }); })
        .sort(function (a, b) { return b.addressTypes.length - a.addressTypes.length; });
};



var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sanitizeAddress: sanitizeAddress,
  sortAddresses: sortAddresses
});

var createOptInsUpdate = function (availableItems, selectedOptIns) {
    if (selectedOptIns === void 0) { selectedOptIns = []; }
    return availableItems.reduce(function (acc, curr) {
        var _a;
        return selectedOptIns.includes(curr.value)
            ? __assign(__assign({}, acc), (_a = {}, _a[curr.value] = {
                value: true,
                literalText: curr.title,
                uiType: 'checkbox',
            }, _a)) : acc;
    }, {});
};
// TODO: This is very similar to the function above which is used in create account, check if they can be merged somehow
var createOptInsUpdateForPrivacy = function (optIns) {
    if (optIns === void 0) { optIns = {}; }
    return Object.keys(optIns).reduce(function (m, optInName) {
        var _a;
        return (__assign(__assign({}, m), (_a = {}, _a[optInName] = {
            value: optIns[optInName].checked,
            uiType: 'checkbox',
            literalText: optIns[optInName].label,
        }, _a)));
    }, {});
};

var convertToLineItemDraft = function (orderLineItem, isLegacyOrderSupplierEanEnabled) {
    var custom;
    if (_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isContactLenses(orderLineItem.product) ||
        _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isDetailContactLenses(orderLineItem.product)) {
        custom = {
            eyeSide: orderLineItem.product.attributes.eyeSide,
        };
    }
    if (_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isDetailContactLensBundles(orderLineItem.product)) {
        var customValues = {
            leftLensAxis: orderLineItem.product.attributes.leftLensAxis,
            leftLensBaseCurve: orderLineItem.product.attributes.leftLensBaseCurve,
            leftLensCylinder: orderLineItem.product.attributes.leftLensCylinder,
            leftLensDiameter: orderLineItem.product.attributes.leftLensDiameter,
            leftLensName: orderLineItem.product.attributes.leftLensName,
            leftLensPower: orderLineItem.product.attributes.leftLensPower,
            leftLensSku: orderLineItem.product.attributes.leftLensSku,
            leftLensVariantSku: orderLineItem.product.attributes.leftLensVariantSku,
            rightLensAxis: orderLineItem.product.attributes.rightLensAxis,
            rightLensBaseCurve: orderLineItem.product.attributes.rightLensBaseCurve,
            rightLensCylinder: orderLineItem.product.attributes.rightLensCylinder,
            rightLensDiameter: orderLineItem.product.attributes.rightLensDiameter,
            rightLensName: orderLineItem.product.attributes.rightLensName,
            rightLensPower: orderLineItem.product.attributes.rightLensPower,
            rightLensSku: orderLineItem.product.attributes.rightLensSku,
            rightLensVariantSku: orderLineItem.product.attributes.rightLensVariantSku,
            solutionName: orderLineItem.product.attributes.solutionName,
            solutionSku: orderLineItem.product.attributes.solutionSku,
            // parse add to cart sets a default type: gv-core-components/packages/carts/src/Util/parse-add-to-cart-payload.ts
            type: 'contact-lens-bundle',
        };
        // Remove all undefined / null values
        var customData = lodash_omitBy__WEBPACK_IMPORTED_MODULE_10___default()(customValues, lodash_isNil__WEBPACK_IMPORTED_MODULE_9___default.a);
        custom = customData;
    }
    return {
        quantity: orderLineItem.quantity,
        sku: isLegacyOrderSupplierEanEnabled
            ? orderLineItem.product.attributes.supplierEAN
            : orderLineItem.product.sku,
        custom: custom,
    };
};
var convertToPrescriptionGlassesLineItemDraft = function (lineItem, isLegacyOrderSupplierEanEnabled) {
    var _a = lineItem.product.lineItemDetail, prescription = _a.prescription, bundleMainLineItem = _a.bundleMainLineItem, bundleChildLineItems = _a.bundleChildLineItems;
    return {
        prescription: prescription,
        quantity: lineItem.quantity,
        bundleMainLineItem: {
            quantity: bundleMainLineItem.quantity,
            sku: isLegacyOrderSupplierEanEnabled
                ? lineItem.product.attributes.supplierEAN
                : bundleMainLineItem.variant.sku,
            productType: bundleMainLineItem.productType,
        },
        bundleChildLineItems: bundleChildLineItems.map(function (_a) {
            var variant = _a.variant, quantity = _a.quantity, productType = _a.productType;
            return ({
                sku: variant.sku,
                productType: productType,
                quantity: quantity,
            });
        }),
    };
};
var convertLineItemsToDrafts = function (items, isLegacyOrderSupplierEanEnabled) {
    return items.reduce(function (drafts, lineItem) {
        if (_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isPrescriptionGlasses(lineItem.product)) {
            return __assign(__assign({}, drafts), { prescriptionGlassesBundleLineItems: __spread((drafts.prescriptionGlassesBundleLineItems || []), [
                    convertToPrescriptionGlassesLineItemDraft(lineItem, isLegacyOrderSupplierEanEnabled),
                ]) });
        }
        else {
            return __assign(__assign({}, drafts), { lineItems: __spread(drafts.lineItems, [
                    convertToLineItemDraft(lineItem, isLegacyOrderSupplierEanEnabled),
                ]) });
        }
    }, { lineItems: [] });
};

var formatError = function (error) {
    if (!error) {
        return '';
    }
    // TODO: remove this and parse the rules so we can use bloomreach labels to format them
    if ('policy' in error && error.policy === 'string') {
        return error.policy.split(/\*\s?/);
    }
    if ('description' in error) {
        if (typeof error.description === 'string') {
            return error.description;
        }
        if (typeof error.description === 'object' && error.description.rules) {
            return error.description.rules.map(function (r) { return r.message; });
        }
    }
    if ('message' in error) {
        return error.message;
    }
    return '';
};

var getPasswordStrengthErrorLabel = function (error) {
    var passwordErrorCodes = ['password_strength_error', 'PasswordStrengthError'];
    // We don't get error codes from the backend
    if ('message' in error && passwordErrorCodes.some(function (code) { return error.message.includes(code); })) {
        return 'account.createAccount.setPassword.errors.passwordStrength';
    }
};

var _history;
var history = function () {
    if (!_history) {
        _history = Object(history__WEBPACK_IMPORTED_MODULE_12__[/* createBrowserHistory */ "a"])();
    }
    return _history;
};

var parseAuth0StateParam = function (state) {
    var isPasswordless = false;
    var email;
    try {
        if (typeof state === 'string') {
            var statePayload = JSON.parse(state);
            if (typeof statePayload === 'object' && 'type' in statePayload && 'email' in statePayload) {
                isPasswordless = statePayload.type === 'passwordless';
                email = statePayload.email;
            }
        }
    }
    catch (_a) { }
    return {
        email: email,
        type: isPasswordless ? 'passwordless' : 'regular',
    };
};

// copied from auth0-js/src/helper/random.js
var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
function randomString(length) {
    var bytes = new Uint8Array(length);
    var result = [];
    var cryptoObj = 
    // eslint-disable-next-line @typescript-eslint/dot-notation
    'msCrypto' in window ? window['msCrypto'] : window.crypto;
    if (!cryptoObj) {
        return null;
    }
    var random = cryptoObj.getRandomValues(bytes);
    for (var a = 0; a < random.length; a++) {
        result.push(charset[random[a] % charset.length]);
    }
    return result.join('');
}

// Function needed to bypass IE11 'Invalid calling object' error
var redirect = function (route) { return window && window.location.assign(route); };



var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddressBookUtils: index,
  createOptInsUpdate: createOptInsUpdate,
  createOptInsUpdateForPrivacy: createOptInsUpdateForPrivacy,
  convertLineItemsToDrafts: convertLineItemsToDrafts,
  formatError: formatError,
  getMyAccountMenuItems: getMyAccountMenuItems,
  getPasswordStrengthErrorLabel: getPasswordStrengthErrorLabel,
  history: history,
  parseAuth0StateParam: parseAuth0StateParam,
  randomString: randomString,
  redirect: redirect
});

var OnlyOnClient = /** @class */ (function (_super) {
    __extends(OnlyOnClient, _super);
    function OnlyOnClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            onServer: true,
        };
        return _this;
    }
    OnlyOnClient.prototype.componentDidMount = function () {
        this.setState({ onServer: false });
    };
    OnlyOnClient.prototype.render = function () {
        return this.state.onServer ? this.props.serverContent : this.props.children;
    };
    OnlyOnClient.defaultProps = {
        serverContent: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LoaderScreen */ "M"], { height: 50 }),
    };
    return OnlyOnClient;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var Protected = /** @class */ (function (_super) {
    __extends(Protected, _super);
    function Protected() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.redirectOut = function () {
            var query = _this.returnPath
                ? "returnPath=" + encodeURIComponent("/" + _this.returnPath)
                : undefined;
            _this.props.goto({ route: 'login', query: query });
        };
        return _this;
    }
    Protected.prototype.componentDidMount = function () {
        this.returnPath = window.location.pathname.replace('//', '/').replace(/^\//, '');
        if (isInitialized(this.props.auth)) {
            this.props.recoverSession();
        }
        else if (isLoggedOut(this.props.auth)) {
            this.redirectOut();
        }
    };
    Protected.prototype.render = function () {
        var auth = this.props.auth;
        if (isLoggedIn(auth)) {
            return this.props.children;
        }
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LoaderScreen */ "M"], { height: 50 });
    };
    Protected.prototype.componentDidUpdate = function (prevProps) {
        if (isLoggedOut(this.props.auth)) {
            this.redirectOut();
        }
    };
    return Protected;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$2 = function (state) { return ({
    auth: getAuth(state),
}); };
var mapDispatchToProps = {
    goto: goto,
    recoverSession: recoverSession,
};
var Protected$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$2, mapDispatchToProps)(Protected);

var Callback = /** @class */ (function (_super) {
    __extends(Callback, _super);
    function Callback() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Callback.prototype.componentDidMount = function () {
        if (this.props.type === 'callback') {
            this.props.parseHash();
        }
        else {
            this.props.loggedOut();
        }
    };
    Callback.prototype.render = function () {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LoaderScreen */ "M"], { height: 50 });
    };
    return Callback;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var EmailForm = /** @class */ (function (_super) {
    __extends(EmailForm, _super);
    function EmailForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            email: {
                value: '',
                isValid: undefined,
            },
        };
        _this.setEmail = function (state) {
            _this.setState(function () { return ({
                email: {
                    value: state.value,
                    isValid: state.isValid,
                },
            }); });
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            var email = _this.state.email;
            var onSubmit = _this.props.onSubmit;
            if (email.isValid === true) {
                onSubmit(email.value);
            }
        };
        return _this;
    }
    EmailForm.prototype.render = function () {
        var email = this.state.email;
        var _a = this.props, dataT = _a.dataT, buttonLabel = _a.buttonLabel, isButtonDisabled = _a.isButtonDisabled, isButtonLoading = _a.isButtonLoading, className = _a.className, children = _a.children, emailLabel = _a.emailLabel, emailErrorLabel = _a.emailErrorLabel, renderOptIns = _a.renderOptIns;
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("form", { onSubmit: this.handleSubmit, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('email-form', className), noValidate: true, "data-t": dataT },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Email */ "h"], { "data-t": "email", required: true, label: emailLabel, errorMessage: emailErrorLabel, onChange: this.setEmail, hideAsteriskSign: true }),
            renderOptIns,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "submit", type: "submit", disabled: isButtonDisabled || !email.isValid, isLoading: isButtonLoading, caption: buttonLabel, className: "email-form__button" }),
            children));
    };
    return EmailForm;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var EmailSentConfirmation = /** @class */ (function (_super) {
    __extends(EmailSentConfirmation, _super);
    function EmailSentConfirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isEmailSent: false,
        };
        _this.replaceEmail = function (label, email) {
            return (label && label.replace('{{email}}', email)) || '';
        };
        _this.sendEmail = function () {
            _this.props.onResend({ email: _this.props.email });
            _this.setState({ isEmailSent: true });
        };
        return _this;
    }
    EmailSentConfirmation.prototype.render = function () {
        var _a = this.props, buttonCaption = _a.buttonCaption, className = _a.className, email = _a.email, firstParagraph = _a.firstParagraph, secondParagraph = _a.secondParagraph, title = _a.title;
        var error = formatError(this.props.error);
        var errorKey = typeof error === 'string' ? error : error.join(' ');
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('email-sent-confirmation', 'myaccount__section', className) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", null, title),
            error && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], { key: errorKey },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: formatError(this.props.error) }))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "email-sent-confirmation__text" }, this.replaceEmail(firstParagraph, email)),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "email-sent-confirmation__text" }, this.replaceEmail(secondParagraph, email)),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "re-send", className: "email-sent-confirmation__button", onClick: this.sendEmail, disabled: this.state.isEmailSent, caption: buttonCaption, variant: "outline" })));
    };
    return EmailSentConfirmation;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var SignUp = /** @class */ (function (_super) {
    __extends(SignUp, _super);
    function SignUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            email: '',
            selectedOptIns: [],
            signedUp: false,
        };
        _this.handleSubmit = function (email) {
            _this.setState({ email: email, signedUp: true }, function () {
                _this.handleSignup();
            });
        };
        _this.handleSignup = function () {
            var _a = _this.state, email = _a.email, selectedOptIns = _a.selectedOptIns;
            _this.props.signup({
                email: email,
                selectedOptIns: selectedOptIns.map(function (o) { return o.value; }),
                reason: 'signUp',
            });
        };
        _this.handleOptInChange = function (selectedOptIns) { return _this.setState({ selectedOptIns: selectedOptIns }); };
        return _this;
    }
    SignUp.prototype.render = function () {
        var _a = this.state, email = _a.email, selectedOptIns = _a.selectedOptIns, signedUp = _a.signedUp;
        var _b = this.props, auth = _b.auth, termsRichText = _b.termsRichText, intl = _b.intl, availableOptIns = _b.availableOptIns;
        var optIns = availableOptIns && availableOptIns.length ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* CheckboxList */ "k"], { idPrefix: "opt-in__", items: availableOptIns, selectedItems: selectedOptIns, getItemIdentifier: function (optIn) { return optIn.value; }, renderItem: function (item) { return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null, react_html_parser__WEBPACK_IMPORTED_MODULE_13___default()(item.title)); }, onChange: this.handleOptInChange })) : null;
        if (isUninitialized(auth)) {
            throw new Error("Should not render SignUp page when auth is not initialized");
        }
        var error = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(auth.signupCall)
            ? new Error(intl.getLabel('account.createAccount.signup.errors.general'))
            : undefined;
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "signup" }, signedUp ? (
        // If email is submitted and call is finished we can show confirmation screen
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(EmailSentConfirmation, { onResend: this.handleSignup, email: email, title: intl.getLabel('account.signupConfirmation.title'), firstParagraph: intl.getLabel('account.signupConfirmation.firstParagraph'), secondParagraph: intl.getLabel('account.signupConfirmation.secondParagraph'), buttonCaption: intl.getLabel('account.action.resendEmail'), error: error })) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: "signup__login-section" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "h3" }, intl.getLabel('account.hasAccount.title')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "signup__login-text" }, intl.getLabel('account.hasAccount.text')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "signup__login-button", caption: intl.getLabel('account.action.login'), variant: "outline", "data-t": "to-login", href: this.props.loginUrl })),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: "signup__signup-section" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", null, intl.getLabel('account.signup.title')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(EmailForm, { onSubmit: this.handleSubmit, buttonLabel: intl.getLabel('account.action.createAccount'), "data-t": "signup-form", emailErrorLabel: intl.getLabel('account.error.emailInvalid'), emailLabel: intl.getLabel('fields.input.email.label'), renderOptIns: optIns }, termsRichText && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "signup__terms" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* RichTextArea */ "cb"], { content: termsRichText })))))))));
    };
    return SignUp;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$3 = function (state) { return ({
    auth: getAuth(state),
    availableOptIns: getOptInsForSignup(state),
}); };
var mapDispatchToProps$1 = {
    signup: signup,
};
var SignUp$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$3, mapDispatchToProps$1)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(SignUp));

var PasswordForm = function (_a) {
    var buttonCaption = _a.buttonCaption, dataT = _a["data-t"], className = _a.className, passwordLabel = _a.passwordLabel, children = _a.children, onSubmit = _a.onSubmit;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])({
        password: {
            value: '',
        },
    }), 2), state = _b[0], setState = _b[1];
    var handleSubmit = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (event) {
        event.preventDefault();
        if (state.password.value) {
            onSubmit(state.password.value);
        }
    }, [onSubmit, state]);
    var setPassword = function (password) {
        var value = password.value, isValid = password.isValid;
        setState({
            password: {
                value: value,
                isValid: isValid,
            },
        });
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("form", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('password-form', className), "data-t": dataT, noValidate: true, onSubmit: handleSubmit },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* PasswordWithStrengthIndicator */ "s"], { label: passwordLabel, indicatorPosition: _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useIsDesktop() ? 'right' : 'bottom', value: state.password.value, onChange: setPassword }),
        children,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: buttonCaption, "data-t": "submit", type: "submit", className: "password-form__button" })));
};

var renderError = function (intl, auth) {
    if (isLoggedInPasswordless(auth) && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(auth.activateCall)) {
        var error = auth.activateCall.error;
        var passwordStrengthErrorLabel = getPasswordStrengthErrorLabel(error);
        var errorLabel = passwordStrengthErrorLabel || 'account.createAccount.setPassword.errors.general';
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel(errorLabel) })));
    }
};
var SetPassword = /** @class */ (function (_super) {
    __extends(SetPassword, _super);
    function SetPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedConsents: [],
        };
        _this.handleConsent = function (consents) {
            _this.setState({
                selectedConsents: consents,
                error: _this.areAllConsentsSelected(consents) ? undefined : _this.state.error,
            });
        };
        _this.handleSubmit = function (password) {
            var intl = _this.props.intl;
            var selectedConsents = _this.state.selectedConsents;
            if (!_this.areAllConsentsSelected(selectedConsents)) {
                _this.setState({
                    error: intl.getLabel('account.createAccount.error.consentRequired'),
                });
            }
            if (_this.isValid()) {
                var getSelectedConsentsData = selectedConsents.reduce(function (acc, consent) {
                    var _a;
                    var currentItem = _this.props.consentItems.find(function (c) { return c.value === consent.value; });
                    if (!currentItem) {
                        return acc;
                    }
                    return __assign(__assign({}, acc), (_a = {}, _a[consent.value] = {
                        literalText: currentItem.title || consent.value,
                        uiType: 'checkbox',
                    }, _a));
                }, {});
                _this.props.onSubmit({
                    password: password,
                    consents: getSelectedConsentsData,
                });
            }
        };
        _this.areAllConsentsSelected = function (consents) {
            return _this.props.consentItems.every(function (_a) {
                var value = _a.value;
                return consents.map(function (c) { return c.value; }).includes(value);
            });
        };
        _this.isValid = function () {
            var selectedConsents = _this.state.selectedConsents;
            var consentItems = _this.props.consentItems;
            return (!consentItems.length ||
                consentItems.every(function (item) { return selectedConsents.map(function (c) { return c.value; }).includes(item.value); }));
        };
        return _this;
    }
    SetPassword.prototype.componentDidMount = function () {
        SetPassword.redirectForInvalidStates(this.props);
    };
    SetPassword.prototype.componentDidUpdate = function () {
        SetPassword.redirectForInvalidStates(this.props);
    };
    SetPassword.prototype.render = function () {
        var _a = this.props, intl = _a.intl, auth = _a.auth;
        var consentItems = this.props.consentItems.map(function (c) { return (__assign(__assign({}, c), { scope: 'signup-checks' })); });
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "create-account myaccount__section" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h2 create-account__title" }, intl.getLabel('account.createAccount.title')),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "create-account__text" }, intl.getLabel('account.createAccount.text')),
            renderError(intl, auth),
            this.state.error && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], { key: this.state.error },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: this.state.error }))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PasswordForm, { "data-t": "create-account-form", passwordLabel: intl.getLabel('fields.input.password.label'), buttonCaption: intl.getLabel('account.action.createAccount'), onSubmit: this.handleSubmit }, consentItems.length > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* CheckboxList */ "k"], { idPrefix: "consent_", items: consentItems, renderItem: function (item) { return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null, react_html_parser__WEBPACK_IMPORTED_MODULE_13___default()(item.title)); }, getItemIdentifier: function (consent) { return consent.value; }, onChange: this.handleConsent, selectedItems: this.state.selectedConsents })))));
    };
    SetPassword.redirectForInvalidStates = function (props) {
        if (isLoggedIn(props.auth)) {
            props.goto({ route: 'profile' });
        }
        if (isLoggedOut(props.auth)) {
            props.goto({ route: 'login' });
        }
    };
    return SetPassword;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$4 = function (state) { return ({
    auth: getAuth(state),
}); };
var mapDispatchToProps$2 = {
    onSubmit: setPassword,
    goto: goto,
};
var SetPassword$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$4, mapDispatchToProps$2)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(SetPassword));

var MyAccountBreadcrumbs = function (_a) {
    var formattedRoutes = _a.formattedRoutes, items = _a.items;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var breadcrumbs = __spread([
        {
            name: getLabel('account.menu.home') || 'Home',
        }
    ], items.map(function (_a) {
        var name = _a.name, routeKey = _a.routeKey;
        return ({
            name: name,
            url: formattedRoutes && routeKey ? formattedRoutes[routeKey] : undefined,
        });
    }));
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount-breadcrumbs" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Breadcrumbs */ "e"], { pages: breadcrumbs })));
};
MyAccountBreadcrumbs.displayName = 'MyAccountBreadcrumbs';
var mapStateToProps$5 = function (state) { return ({
    basePath: getBasePath(state),
    formattedRoutes: getFormattedRoutes(state),
}); };
var MyAccountBreadcrumbs$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$5)(MyAccountBreadcrumbs);

function getBreadcrumbs(segments, intl) {
    return segments.map(function (segment) { return ({
        name: intl.getLabel("account.menu." + segment),
        routeKey: segment,
    }); });
}

var setInitialState = function (name) { return ({
    value: '',
    name: name,
    isValid: false,
}); };
var getErrorLabel = function (auth, getLabel) {
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(auth.changePasswordCall) && typeof auth.changePasswordCall.error === 'string') {
        var error = auth.changePasswordCall.error;
        switch (error) {
            case 'wrong_email_or_password':
                return getLabel('account.changePassword.current.error');
            case 'password_strength_error':
                return getLabel('account.changePassword.incorrect');
            default:
                return getLabel('account.changePassword.errors.general');
        }
    }
    return getLabel('account.changePassword.errors.general');
};
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentPassword: setInitialState('currentPassword'),
            newPassword: setInitialState('newPassword'),
            isRedirecting: false,
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            var auth = _this.props.auth;
            var _a = _this.state, currentPassword = _a.currentPassword, newPassword = _a.newPassword;
            if (auth.email && currentPassword.isValid === true && newPassword.isValid === true) {
                _this.props.changePassword({
                    email: auth.email,
                    currentPassword: currentPassword.value,
                    newPassword: newPassword.value,
                });
            }
        };
        return _this;
    }
    ChangePassword.prototype.render = function () {
        var _this = this;
        var getLabel = this.props.intl.getLabel;
        var _a = this.props, auth = _a.auth, className = _a.className, currentBreakpoint = _a.currentBreakpoint, rest = __rest(_a, ["auth", "className", "currentBreakpoint"]);
        var ROUTE_KEY = 'changePassword';
        var routeLabel = getLabel("account.menu." + ROUTE_KEY);
        var passwordIndicatorPosition = currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.DESKTOP ? 'right' : 'bottom';
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: getBreadcrumbs(['profile', 'changePassword'], this.props.intl) }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("form", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('change-password', className), "data-t": rest['data-t'], noValidate: true, onSubmit: this.handleSubmit },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "h4" }, getLabel('account.changePassword')),
                Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(auth.changePasswordCall) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: getErrorLabel(auth, getLabel) }))),
                this.props.isSuccess && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusIdle */ "E"])(auth.changePasswordCall) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "success", icon: "checkmark", message: getLabel('account.changePassword.success') }))),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Password */ "r"], { label: getLabel('account.currentPassword'), onChange: function (value) { return _this.setState({ currentPassword: value }); } }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* PasswordWithStrengthIndicator */ "s"], { label: getLabel('account.newPassword'), value: this.state.newPassword.value, indicatorPosition: passwordIndicatorPosition, onChange: function (value) { return _this.setState({ newPassword: value }); } }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: getLabel('account.action.changePassword'), isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(auth.changePasswordCall) || this.state.isRedirecting, "data-t": "submit", type: "submit", className: "change-password__button" }))));
    };
    return ChangePassword;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$6 = function (state) { return ({
    auth: getAuth(state),
}); };
var mapDispatchToProps$3 = {
    changePassword: changePassword,
};
var ChangePassword$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$6, mapDispatchToProps$3)(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].WithBreakpoints(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(ChangePassword)));

var renderError$1 = function (intl, auth) {
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(auth.setPasswordCall)) {
        var error = auth.setPasswordCall.error;
        var passwordStrengthErrorLabel = getPasswordStrengthErrorLabel(error);
        var errorLabel = passwordStrengthErrorLabel || 'account.resetPassword.updatePassword.errors.general';
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel(errorLabel) })));
    }
};
var elementName$1 = 'set-password';
var SetPassword$2 = /** @class */ (function (_super) {
    __extends(SetPassword, _super);
    function SetPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSubmit = function (password) {
            _this.props.updatePassword({ password: password });
        };
        return _this;
    }
    SetPassword.prototype.render = function () {
        var _a = this.props, intl = _a.intl, auth = _a.auth;
        if (!isLoggedInPasswordless(auth)) {
            return null;
        }
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(elementName$1, 'myaccount__section') },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('h2', elementName$1 + "__title") }, intl.getLabel('account.resetPassword.confirmation.title')),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: elementName$1 + "__text" }, intl.getLabel('account.resetPassword.setPassword.text')),
            renderError$1(intl, auth),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PasswordForm, { "data-t": "set-password-form", passwordLabel: intl.getLabel('fields.input.password.label'), buttonCaption: intl.getLabel('account.action.setPassword'), onSubmit: this.onSubmit })));
    };
    return SetPassword;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapDispatchToProps$4 = {
    updatePassword: updatePassword,
};
var mapStateToProps$7 = function (state) { return ({
    auth: getAuth(state),
}); };
var SetPassword$3 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$7, mapDispatchToProps$4)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(SetPassword$2));

var elementName$2 = 'submit-email-address';
var SubmitEmailAddress = /** @class */ (function (_super) {
    __extends(SubmitEmailAddress, _super);
    function SubmitEmailAddress() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            email: '',
            isEmailSubmitted: false,
        };
        _this.onHandleResend = function () {
            _this.props.resetPassword({ email: _this.state.email });
        };
        _this.onSubmit = function (email) {
            _this.setState({ email: email, isEmailSubmitted: true }, function () {
                _this.props.resetPassword({ email: email });
            });
        };
        return _this;
    }
    SubmitEmailAddress.prototype.render = function () {
        var _a = this.props, intl = _a.intl, auth = _a.auth;
        var _b = this.state, email = _b.email, isEmailSubmitted = _b.isEmailSubmitted;
        if (isUninitialized(auth)) {
            return null;
        }
        var error = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(auth.resetPasswordCall)
            ? new Error(intl.getLabel('account.resetPassword.updatePassword.errors.general'))
            : undefined;
        // If email is submitted and call is finished we can show confirmation screen
        if (isEmailSubmitted) {
            return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(EmailSentConfirmation, { onResend: this.onHandleResend, email: email, title: intl.getLabel('account.resetPassword.confirmation.title'), firstParagraph: intl.getLabel('account.resetPassword.confirmation.firstParagraph'), secondParagraph: intl.getLabel('account.resetPassword.confirmation.secondParagraph'), buttonCaption: intl.getLabel('account.action.resendEmail'), error: error }));
        }
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(elementName$2, 'myaccount__section') },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('h2', elementName$2 + "__title") }, intl.getLabel('account.resetPassword.submitEmailAddress.title')),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: elementName$2 + "__text" }, intl.getLabel('account.resetPassword.submitEmailAddress.text')),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(EmailForm, { buttonLabel: intl.getLabel('account.action.resetPassword'), "data-t": "reset-password-form", emailErrorLabel: intl.getLabel('account.error.emailInvalid'), emailLabel: intl.getLabel('fields.input.email.label'), onSubmit: this.onSubmit })));
    };
    return SubmitEmailAddress;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$8 = function (state) { return ({
    auth: getAuth(state),
}); };
var mapDispatchToProps$5 = {
    resetPassword: resetPassword,
};
var SubmitEmailAddress$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$8, mapDispatchToProps$5)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(SubmitEmailAddress));

var NonCompliantPasswordMessage = function (props) {
    var routes = props.routes;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var label = getLabel('account.login.errors.requiresPasswordChange');
    var handleClick = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
        props.resetPassword({ email: props.email || '' });
    }, [props.resetPassword, props.email]);
    /*
     * Look for the [ ] and take the part before, inside and after to create a text with
     * the link inside, like: "before" + <a>"inside"<a/> + "after"
     */
    var regex = /(.+)\[(.+)\](.+)/g;
    var linkElement = props.email ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("button", { className: "login__reset-link", onClick: handleClick, "data-t": "non-compliant-password-action" }, label.replace(regex, '$2'))) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("a", { className: "login__reset-link", href: routes ? routes.resetPassword : '#', "data-t": "non-compliant-password-action" }, label.replace(regex, '$2')));
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null, label.replace(regex, '$1')),
        linkElement,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null, label.replace(regex, '$3'))));
};
NonCompliantPasswordMessage.displayName = 'NonCompliantPasswordMessage';
var requiresPasswordChangeError = 'requiresPasswordChange';
var initialFieldState = {
    isTouched: false,
    isValid: false,
    value: '',
};
var Login = function (_a) {
    var auth = _a.auth, email = _a.email, error = _a.error, routes = _a.routes, className = _a.className, loginWithPassword = _a.loginWithPassword, createAccountRichText = _a.createAccountRichText, disableSignup = _a.disableSignup, returnPath = _a.returnPath, resetPassword = _a.resetPassword;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false), 2), hasFormValidationError = _b[0], setHasFormValidationError = _b[1];
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])({
        email: __assign({ name: 'email' }, initialFieldState),
        password: __assign({ name: 'password' }, initialFieldState),
    }), 2), loginForm = _c[0], setLoginForm = _c[1];
    var formattedError = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () {
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(auth.loginCall)) {
            var errorFromState = auth.loginCall.error;
            if ('code' in errorFromState && errorFromState.code === 'access_denied') {
                return getLabel('account.login.errors.invalidCredentials');
            }
            if ('error_description' in errorFromState) {
                return errorFromState.error_description || '';
            }
            return errorFromState.message || '';
        }
        // If this is true, it is one of the errors from the URL state parameter
        if (typeof error === 'string') {
            if (error === requiresPasswordChangeError) {
                return;
            }
            return getLabel("account.login.errors." + error);
        }
        if (hasFormValidationError) {
            return getLabel('account.login.errors.formValidation');
        }
    }, [error, auth.loginCall, getLabel, hasFormValidationError]);
    var handleSubmit = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (state) {
        var _a, _b, _c, _d;
        var formState = state.formState;
        if (((_a = formState === null || formState === void 0 ? void 0 : formState.email) === null || _a === void 0 ? void 0 : _a.isValid) && ((_b = formState === null || formState === void 0 ? void 0 : formState.password) === null || _b === void 0 ? void 0 : _b.isValid)) {
            setHasFormValidationError(false);
            loginWithPassword({
                email: formState.email.value,
                password: formState.password.value,
                returnPath: returnPath,
            });
        }
        if (!((_c = formState === null || formState === void 0 ? void 0 : formState.email) === null || _c === void 0 ? void 0 : _c.isTouched) || !((_d = formState === null || formState === void 0 ? void 0 : formState.password) === null || _d === void 0 ? void 0 : _d.isTouched)) {
            return setLoginForm({
                email: __assign(__assign({}, formState.email), { isTouched: true }),
                password: __assign(__assign({}, formState.password), { isTouched: true }),
            });
        }
        setHasFormValidationError(true);
    }, [loginWithPassword, returnPath, hasFormValidationError, setHasFormValidationError, setLoginForm]);
    var wrapperClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()('login', className);
    var isLoading = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(auth.loginCall);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: wrapperClasses },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: "login__section" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "login__section__title" }, getLabel('account.login.title')),
                !isLoading && formattedError && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], { key: formattedError },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: formattedError }))),
                error === requiresPasswordChangeError && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], { key: error },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "warning", icon: "info", className: "login__non-compliancy-alert" },
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(NonCompliantPasswordMessage, { routes: routes, resetPassword: resetPassword, email: email })))),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Form */ "j"], { onSubmit: handleSubmit, initialFormState: loginForm, name: "login", "data-t": "login-form", showErrorsOnInvalidSubmit: false },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Email */ "h"], { "data-t": "email", required: true, label: getLabel('fields.input.email.label'), errorMessage: getLabel('fields.input.email.errorMessage'), hideAsteriskSign: true }),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Password */ "r"], { "data-t": "password", required: true, label: getLabel('fields.input.password.label'), errorMessage: getLabel('fields.input.password.errorMessage'), hideAsteriskSign: true }),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Link */ "J"], { className: "login__forgot-password", label: getLabel('account.action.resetPassword'), url: routes ? routes.resetPassword : '#' }),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "submit", type: "submit", isLoading: isLoading, caption: getLabel('account.action.login'), className: "login__button" }))),
            !disableSignup && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: "login__section" },
                createAccountRichText && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* RichTextArea */ "cb"], { content: createAccountRichText }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "create-account", variant: "outline", caption: getLabel('account.action.createAccount'), className: "login__button login__button--signup", href: routes ? routes.signup : '#' }))))));
};
var mapStateToProps$9 = function (state) { return ({
    auth: getAuth(state),
    routes: getFormattedRoutes(state),
}); };
var mapDispatchToProps$6 = {
    loginWithPassword: loginWithPassword,
    resetPassword: resetPassword,
};
var Login$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$9, mapDispatchToProps$6)(Login);

var ExpiredLinkView = function (_a) {
    var onResend = _a.onResend, titleLabelKey = _a.titleLabelKey, loginUrl = _a.loginUrl, isLoading = _a.isLoading, hasError = _a.hasError;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false), 2), isEmailSent = _b[0], setIsEmailSent = _b[1];
    var error = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () {
        return hasError ? new Error(getLabel('account.createAccount.signup.errors.general')) : undefined;
    }, [hasError, getLabel]);
    var handleSubmit = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (email) {
        if ((isEmailSent && !hasError) || isLoading) {
            return;
        }
        onResend({ email: email });
        setIsEmailSent(true);
    }, [isEmailSent, hasError, isLoading, onResend]);
    var canResend = !isEmailSent || error;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "expired-link myaccount__section", "data-t": "expired-link" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", null, getLabel(titleLabelKey)),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "info", title: getLabel('account.linkExpired.title'), message: getLabel('account.linkExpired.message') }),
        error && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: formatError(error) }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(EmailForm, { onSubmit: handleSubmit, emailErrorLabel: getLabel('account.error.emailInvalid'), emailLabel: getLabel('fields.input.email.label'), buttonLabel: !canResend ? getLabel('account.action.emailSent') : getLabel('account.action.requestLink'), isButtonDisabled: !canResend, isButtonLoading: isLoading }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("a", { href: loginUrl, "data-t": "to-login", className: "expired-link__text" }, getLabel('account.action.returnToLogin'))));
};

var ExpiredLink = function (_a) {
    var targetAction = _a.targetAction;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAuth), resetPasswordCall = _b.resetPasswordCall, signupCall = _b.signupCall;
    var routes = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getFormattedRoutes);
    var loginUrl = (routes === null || routes === void 0 ? void 0 : routes.login) || '#';
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var expiredLinkProps = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () {
        if (targetAction === 'forgotPassword') {
            return {
                onResend: function (payload) {
                    dispatch(resetPassword(payload));
                },
                titleLabelKey: 'account.resetPassword.submitEmailAddress.title',
                loginUrl: loginUrl,
                isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(resetPasswordCall),
                hasError: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(resetPasswordCall),
            };
        }
        else {
            return {
                onResend: function (payload) {
                    dispatch(signup(payload));
                },
                titleLabelKey: 'account.createAccount.title',
                loginUrl: loginUrl,
                isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(signupCall),
                hasError: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(signupCall),
            };
        }
    }, [
        targetAction,
        signupCall,
        resetPasswordCall,
        _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"],
        _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"],
        loginUrl,
        resetPassword,
        signup,
    ]);
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(ExpiredLinkView, __assign({}, expiredLinkProps));
};

var useAddressBook = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var toggleModal$1 = function (state) {
        dispatch(toggleModal(state));
    };
    var toggleAddressModal = function (isOpen) {
        toggleModal$1({ isOpen: isOpen, viewMode: ViewMode.ADD });
    };
    var deleteAddress$1 = function (id) {
        dispatch(deleteAddress(id));
    };
    var editAddress$1 = function (id) {
        dispatch(editAddress(id));
    };
    var closeModal = function () {
        dispatch(toggleModal({ isOpen: false }));
    };
    return { closeModal: closeModal, toggleAddressModal: toggleAddressModal, deleteAddress: deleteAddress$1, editAddress: editAddress$1 };
};

var UNKNOWN = 'UNKNOWN';
var useAccount = function () {
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var auth = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAuth);
    var currentlyInitialized = isInitialized(auth);
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
        if (currentlyInitialized) {
            dispatch(recoverSession());
        }
    }, [currentlyInitialized]);
    if (currentlyInitialized) {
        return UNKNOWN;
    }
    // "passwordless" logins will return false here
    if (isLoggedIn(auth)) {
        return AuthState.LoggedIn;
    }
    if (isLoggedInPasswordless(auth) || isParseHashFailed(auth) || isLoggedOut(auth)) {
        return AuthState.LoggedOut;
    }
    return UNKNOWN;
};

var useAddressBookList = function (_a) {
    var skip = (_a === void 0 ? {} : _a).skip;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var state = useAccount();
    var addressBook = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddressBookList);
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
        if (!skip &&
            !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUnavailable */ "H"])(addressBook) &&
            Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(addressBook) &&
            state === AuthState.LoggedIn) {
            dispatch(fetchList());
        }
    }, [state, dispatch, addressBook]);
    if (skip || state === AuthState.LoggedOut) {
        return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* unavailableState */ "L"])();
    }
    return addressBook;
};

var Actions = function (_a) {
    var onEditClick = _a.onEditClick, onDeleteClick = _a.onDeleteClick;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "address-summary__actions" },
        onEditClick && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "address-summary__button", "data-t": "summary-edit-button", variant: "ghost", size: "custom", caption: getLabel('common.actions.edit'), onClick: onEditClick })),
        onDeleteClick && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "address-summary__button", "data-t": "summary-edit-button", size: "custom", variant: "ghost", caption: getLabel('common.actions.remove'), onClick: onDeleteClick }))));
};

var Labels = function (_a) {
    var addressTypes = _a.addressTypes;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "address-summary__labels" },
        react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
        addressTypes.map(function (addressType) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Label */ "h"], { key: addressType, className: "address-summary__label", type: "info" }, getLabel("account.addressBook.addressTypes." + addressType))); })));
};

var AddressSummary = function (_a) {
    var address = _a.address, formatter = _a.formatter, title = _a.title, className = _a.className, onDeleteClick = _a.onDeleteClick, onEditClick = _a.onEditClick, rest = __rest(_a, ["address", "formatter", "title", "className", "onDeleteClick", "onEditClick"]);
    var templates = DefaultSummaryTemplates();
    var resolvedFormatter = formatter || templates[SummaryName.addressSummary];
    var data = sanitizeAddress(address);
    var isPreferredAddress = address.addressTypes.length ? true : false;
    var hasActions = onDeleteClick || onEditClick;
    return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], __assign({ className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('address-summary', className) }, rest),
        react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "address-summary__inner" },
            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "address-summary__content" }, resolvedFormatter({ data: data }, title)),
            hasActions && react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Actions, { onDeleteClick: onDeleteClick, onEditClick: onEditClick })),
        isPreferredAddress && react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Labels, { addressTypes: address.addressTypes })));
};

var preferredAddresses = [{ value: 'billing' }, { value: 'delivery' }];
var AddAddress$1 = function (_a) {
    var addressForm = _a.addressForm, address = _a.address, onSubmit = _a.onSubmit, className = _a.className, isCallFailed = _a.isCallFailed, isCallLoading = _a.isCallLoading, isSelectVisible = _a.isSelectVisible, errorMessage = _a.errorMessage, preferredAddress = _a.preferredAddress;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(preferredAddress ? preferredAddress.map(function (value) { return ({ value: value }); }) : []), 2), selectedAddresses = _b[0], setSelectedAddresses = _b[1];
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].fieldsToFormState(address || {})), 2), formState = _c[0], setFormState = _c[1];
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        isCallFailed && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: errorMessage }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Form */ "j"], { name: "address-form", onSubmit: function (formState) {
                if (isCallLoading) {
                    return;
                }
                var state = _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].getValuesFromState(formState.formState);
                var addressTypes = selectedAddresses.reduce(function (acc, _a) {
                    var value = _a.value;
                    return __spread(acc, [value]);
                }, []);
                onSubmit(state, addressTypes);
            }, initialFormState: formState, onChange: function (state) {
                setFormState(state.formState);
            }, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('address-form', className) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("fieldset", { disabled: isCallLoading, className: "address-form__fieldset" }, addressForm)),
        isSelectVisible !== false && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* CheckboxList */ "k"], { idPrefix: "address-form_", items: preferredAddresses, renderItem: function (_a) {
                var value = _a.value;
                return getLabel("account.addressBook.preferred." + value);
            }, getItemIdentifier: function (item) { return item.value; }, onChange: setSelectedAddresses, selectedItems: selectedAddresses }))));
};

var AddAddress$2 = function (_a) {
    var onSubmit = _a.onSubmit, props = __rest(_a, ["onSubmit"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var addCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddCall);
    var isAddCallLoading = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(addCall);
    var isAddCallFailed = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(addCall);
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var errorMessage = getLabel('checkout.addressBook.newAddress.error');
    var listLength = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddressBookListLength);
    var handleSubmit = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (state, addressTypes) {
        var firstName = state.firstName, lastName = state.lastName, streetName = state.streetName, restAddress = __rest(state, ["firstName", "lastName", "streetName"]);
        dispatch(addAddress(__assign({ firstName: firstName,
            lastName: lastName,
            streetName: streetName,
            addressTypes: addressTypes }, restAddress)));
    }, []);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddAddress$1, __assign({}, props, { onSubmit: handleSubmit, isCallFailed: isAddCallFailed, isCallLoading: isAddCallLoading, isSelectVisible: !!listLength, errorMessage: errorMessage })));
};

var EditAddress = function (_a) {
    var address = _a.address, props = __rest(_a, ["address"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var editCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getEditCall);
    var isAddCallLoading = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(editCall);
    var isAddCallFailed = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(editCall);
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var errorMessage = getLabel('checkout.addressBook.newAddress.error');
    var listLength = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddressBookListLength);
    var handleSubmit = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (state, addressTypes) {
        var firstName = state.firstName, lastName = state.lastName, streetName = state.streetName, restAddress = __rest(state, ["firstName", "lastName", "streetName"]);
        dispatch(editAddressSave({
            address: __assign({ firstName: firstName,
                lastName: lastName,
                streetName: streetName,
                addressTypes: addressTypes }, restAddress),
            id: address.id,
        }));
    }, []);
    var addressTypes = address.addressTypes, addressFields = __rest(address, ["addressTypes"]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddAddress$1, __assign({}, props, { onSubmit: handleSubmit, preferredAddress: addressTypes, address: addressFields, isCallFailed: isAddCallFailed, isCallLoading: isAddCallLoading, isSelectVisible: !!listLength, errorMessage: errorMessage })));
};

var Note = function (_a) {
    var message = _a.message;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "address-modal__note" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("strong", null,
            getLabel('account.common.pleaseNote'),
            ":"),
        " ",
        message));
};
var getViewContent = function (activeView, content) { return content[activeView]; };
var AddAddressModal = function (_a) {
    var _b, _c, _d, _e;
    var addressForm = _a.addressForm, onClose = _a.onClose;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var modalState = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getModalState);
    var addCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getAddCall);
    var editCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getEditCall);
    var isLoading = getViewContent(modalState.viewMode, (_b = {},
        _b[ViewMode.ADD] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(addCall),
        _b[ViewMode.DELETE] = false,
        _b[ViewMode.EDIT] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(editCall),
        _b));
    var editedAddress = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getEditedAddress);
    var title = getViewContent(modalState.viewMode, (_c = {},
        _c[ViewMode.ADD] = getLabel('account.addressBook.addAddressLabel'),
        _c[ViewMode.DELETE] = getLabel('account.addressBook.deleteAddressLabel'),
        _c[ViewMode.EDIT] = getLabel('account.addressBook.editAddressLabel'),
        _c));
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { className: "address-modal", isOpen: modalState.isOpen, onModalClose: onClose, title: title, showIcon: true, footer: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "address-modal__buttons" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "address-modal__button", caption: getLabel('common.actions.cancel'), onClick: onClose, variant: "outline" }),
            getViewContent(modalState.viewMode, (_d = {},
                _d[ViewMode.ADD] = (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "address-modal__button", caption: getLabel('account.addressBook.saveChanges'), type: "submit", form: "address-form", isLoading: isLoading })),
                _d[ViewMode.DELETE] = (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "address-modal__button", caption: getLabel('common.actions.remove'), onClick: function () { return dispatch(deleteAddressConfirm()); } })),
                _d[ViewMode.EDIT] = (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "address-modal__button", caption: getLabel('account.addressBook.saveChanges'), type: "submit", form: "address-form", isLoading: isLoading })),
                _d))) }, getViewContent(modalState.viewMode, (_e = {},
        _e[ViewMode.ADD] = Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddAddress$2, { addressForm: addressForm }),
        _e[ViewMode.DELETE] = editedAddress && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddressSummary, { address: editedAddress }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Note, { message: getLabel('account.deleteAddress.note') }))),
        _e[ViewMode.EDIT] = editedAddress && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(EditAddress, { addressForm: addressForm, address: editedAddress }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Note, { message: getLabel('account.editAddress.note') }))),
        _e))));
};

var EmptyAddressBook = function (_a) {
    var toggleAddressModal = _a.toggleAddressModal;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var buttonLabel = getLabel('account.addressBook.buttonAddAddress');
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "empty-address-book" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { name: "address-book" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Text */ "k"], { color: "text-secondary" }, getLabel('account.addressBook.empty')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "add-address-button", caption: buttonLabel, variant: "ghost", onClick: function () {
                toggleAddressModal(true);
            } })));
};

var FailedAddressBook = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: getLabel('account.addressBook.errors.fetchFailed') });
};

var widthMap = {
    phone: ['80%', '60%', '70%', '50%'],
    default: ['50%', '30%', '40%', '20%'],
};
var Image = Object(react__WEBPACK_IMPORTED_MODULE_1__["memo"])(function (_a) {
    var isPhone = _a.isPhone;
    var widths = isPhone ? widthMap.phone : widthMap.default;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "120px" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: widths[0], height: "15px", rx: "5", fill: "currentColor", y: "0" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: widths[1], height: "15px", rx: "5", fill: "currentColor", y: "30" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: widths[2], height: "15px", rx: "5", fill: "currentColor", y: "60" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: widths[3], height: "15px", rx: "5", fill: "currentColor", y: "90" })));
});
var LoadingAddressBook = function () {
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useIsPhone();
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SkeletonLoader */ "hb"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Image, { isPhone: isPhone })));
};

var Content = function (_a) {
    var list = _a.list, toggleAddressModal = _a.toggleAddressModal, deleteAddress = _a.deleteAddress, editAddress = _a.editAddress, formatter = _a.formatter;
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUnavailable */ "H"])(list)) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(FailedAddressBook, null);
    }
    if (!list || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(list) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(list)) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LoadingAddressBook, null);
    }
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusWarning */ "J"])(list) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(list)) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(FailedAddressBook, null);
    }
    if (!list || list.result.length < 1) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(EmptyAddressBook, { toggleAddressModal: toggleAddressModal });
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, list.result.map(function (address) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddressSummary, { key: address.id, address: address, formatter: formatter, onDeleteClick: function () {
            deleteAddress(address.id);
        }, onEditClick: function () {
            editAddress(address.id);
        }, className: "address-book__address-summary" })); })));
};
var AddressBook = function (props) {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var getLabel = intl.getLabel;
    var isMobile = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useIsPhone();
    var openModal = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
        props.toggleAddressModal(true);
    }, [props.toggleAddressModal]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "address-book", "data-t": "address-book" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: getBreadcrumbs(['profile', 'addressBook'], intl) }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "address-book__header" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h3 myaccount-page-title address-book__title" }, getLabel('account.addressBook.title')),
            !isMobile && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(props.list) && !!props.list.result.length && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { size: "small", icon: "plus", variant: "outline", caption: getLabel('account.addressBook.buttonAddAddress'), onClick: openModal }))),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Content, __assign({}, props)),
        isMobile && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(props.list) && !!props.list.result.length &&
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "address-book__mobile-button", icon: "plus", variant: "outline", caption: getLabel('account.addressBook.buttonAddAddress'), onClick: openModal }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddAddressModal, { addressForm: props.addressForm, onClose: props.closeModal })));
};

var AddressBookContainer = function (_a) {
    var addressForm = _a.addressForm;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddressBook, __assign({ addressForm: addressForm, list: useAddressBookList() }, useAddressBook())));
};
var AddressBookContainer$1 = Object(react__WEBPACK_IMPORTED_MODULE_1__["memo"])(AddressBookContainer);

var PreferredStore = function (_a) {
    var callStatus = _a.callStatus, onStoreSelect = _a.onStoreSelect, onCancel = _a.onCancel, onSave = _a.onSave, disableSave = _a.disableSave;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_stores__WEBPACK_IMPORTED_MODULE_16__[/* PreferredStoreFinder */ "a"], { onStoreSelect: onStoreSelect, selected: undefined }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "preferred-store__footer" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "close-preferred-store", variant: "outline", color: "secondary", caption: getLabel('account.profile.preferredStore.cancel'), onClick: onCancel }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: getLabel('account.action.save'), isLoading: !callStatus || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(callStatus[FormName.preferredStore]), type: "button", onClick: onSave, disabled: disableSave }))));
};

var PreferredStoreSummary = function (_a) {
    var preferredStoreCode = _a.preferredStoreCode, onEdit = _a.onEdit, formatter = _a.formatter, className = _a.className;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var storesUrl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useApiConfig */ "N"])().storesUrl;
    var params = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () { return ({
        code: preferredStoreCode,
    }); }, [preferredStoreCode]);
    var _b = __read(Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Stores */ "i"].getDetailsByCode, null, storesUrl, params), 3), isLoading = _b[0], store = _b[1], error = _b[2];
    if (isLoading) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryLoader */ "nb"], null);
    }
    if (error) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { title: intl.getLabel('account.') });
    }
    if (!store) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null, intl.getLabel('account.profile.preferredStore.noStoreSelected'));
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: className, onEditClick: onEdit }, formatter({ data: store })));
};

var getAppointments = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return isLoggedIn(auth) ? auth.appointments : undefined;
});
var getAppointmentList = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAppointments, function (appointments) {
    return appointments ? appointments.list : undefined;
});
var getAppointmentListCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAppointments, function (appointments) {
    return appointments ? appointments.listCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getCancelCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAppointments, function (appointments) {
    return appointments ? appointments.cancelCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});

var pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
var parseLocalDateTime = function (input) {
    if (!pattern.test(input)) {
        throw new Error("Invalid local datetime string: " + input);
    }
    return Object(date_fns__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(input);
};

var ButtonAsLink = react__WEBPACK_IMPORTED_MODULE_1___default.a.forwardRef(function (_a, ref) {
    var caption = _a.caption, className = _a.className, onClick = _a.onClick;
    return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("button", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('button-as-link', className), onClick: onClick, ref: ref }, caption));
});
ButtonAsLink.displayName = 'ButtonAsLink';

var StoreDetailModal = function (_a) {
    var store = _a.store, onModalClose = _a.onModalClose;
    return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { isOpen: true, showIcon: true, className: "store-modal", onModalClose: onModalClose },
        react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_stores__WEBPACK_IMPORTED_MODULE_16__[/* StoreDetail */ "c"], { className: "store-detail--modal", store: store, googleMaps: {
                defaultZoom: 9,
            } })));
};

var AppointmentSummary = function (_a) {
    var type = _a.type, store = _a.store, startTime = _a.startTime, endTime = _a.endTime, className = _a.className, ariaLevel = _a["aria-level"], openCancelModal = _a.openCancelModal;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), dateTime = _b.dateTime, getLabel = _b.getLabel;
    var durationString = type.duration
        ? "(" + type.duration.amount + " " + getLabel("appointments.shortTimeUnits." + type.duration.unit.toLowerCase()) + ")"
        : '';
    var _c = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false), 2), storeDetailModalOpen = _c[0], setStoreDetailModalOpen = _c[1];
    var storeButtonRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["createRef"])();
    var onStoreDetailModalOpen = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () { return setStoreDetailModalOpen(true); }, []);
    var onStoreDetailModalClose = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
        storeButtonRef.current && storeButtonRef.current.focus();
        setStoreDetailModalOpen(false);
    }, [storeButtonRef]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('myaccount-appointment-summary', className), onDeleteClick: openCancelModal },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h4", { className: "myaccount-appointment-summary__title h6", "aria-level": ariaLevel }, getLabel('account.appointment.summary.title')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "myaccount-appointment-summary__item" },
            type.name,
            " ",
            durationString),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "myaccount-appointment-summary__item" }, dateTime.formatLongDate(parseLocalDateTime(startTime))),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "myaccount-appointment-summary__item" }, dateTime.formatTime(parseLocalDateTime(startTime)) + " - " + dateTime.formatTime(parseLocalDateTime(endTime))),
        store && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "myaccount-appointment-summary__item" }, store.storeName),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "myaccount-appointment-summary__item" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(ButtonAsLink, { ref: storeButtonRef, onClick: onStoreDetailModalOpen, caption: getLabel('account.appointment.summary.openStoreDetail') })))),
        store && storeDetailModalOpen && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(StoreDetailModal, { store: store, onModalClose: onStoreDetailModalClose }))));
};

var FooterButton = function (_a) {
    var caption = _a.caption, onClick = _a.onClick, isLoading = _a.isLoading;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { type: "submit", form: "cancellation-reason", caption: caption, className: "cancel-appointment__button", "data-t": "cancel-appointment-modal-cancel", onClick: onClick, disabled: isLoading, variant: "outline", size: "medium" }));
};
FooterButton.displayName = 'FooterButton';
var CancelAppointmentModal = /** @class */ (function (_super) {
    __extends(CancelAppointmentModal, _super);
    function CancelAppointmentModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            formState: {
                formState: {},
                formValid: true,
                formName: 'cancellation-reason',
            },
        };
        return _this;
    }
    CancelAppointmentModal.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prevProps.cancelCall) && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusIdle */ "E"])(this.props.cancelCall)) {
            this.props.onClose();
        }
    };
    CancelAppointmentModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, appointmentId = _a.appointmentId, cancelCall = _a.cancelCall, cancelAppointment = _a.cancelAppointment, onClose = _a.onClose, intl = _a.intl;
        var getLabel = intl.getLabel;
        var onCancelClick = function (state) {
            var cancellationReason = state.formState.reason && state.formState.reason.value;
            cancelAppointment({ id: appointmentId, cancellationReason: cancellationReason });
        };
        var buttonCaption = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(cancelCall)
            ? getLabel('common.loadingText')
            : getLabel('account.appointment.action.cancelAppointment');
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { showIcon: true, isOpen: true, onModalClose: onClose, title: getLabel('account.appointment.cancel.title'), footer: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(FooterButton, { caption: buttonCaption, onClick: function () { return onCancelClick(_this.state.formState); }, isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(cancelCall) }), className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'cancel-appointment') },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Form */ "j"], { name: "cancellation-reason", onBlur: function (formState) { return _this.setState({ formState: formState }); }, onSubmit: onCancelClick },
                Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(this.props.cancelCall) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", icon: "warning", message: getLabel('account.appointment.cancel.error.general') })),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "cancel-appointment__description" }, getLabel('account.appointment.cancel.description')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* TextArea */ "C"], { name: "reason", label: getLabel('account.appointment.cancel.reason.label'), placeholder: getLabel('account.appointment.cancel.reason.placeholder'), maxLength: 255, errorMessage: "" // this message will never show
                 }))));
    };
    return CancelAppointmentModal;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$a = function (state) { return ({
    cancelCall: getCancelCall(state),
}); };
var mapDispatchToProps$7 = {
    cancelAppointment: cancel,
};
var CancelAppointmentModal$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$a, mapDispatchToProps$7)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(CancelAppointmentModal));

var Appointment = function (_a) {
    var profileRoute = _a.profileRoute, bookAppointmentRoute = _a.bookAppointmentRoute, upcomingAppointment = _a.upcomingAppointment;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var openModal = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
        setIsModalOpen(true);
    }, []);
    var closeModal = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
        setIsModalOpen(false);
    }, []);
    var id = upcomingAppointment.id;
    var returnLabel = encodeURIComponent(getLabel('account.appointment.returnPath'));
    var reschedulePath = (bookAppointmentRoute.startsWith('/') ? bookAppointmentRoute : "/" + bookAppointmentRoute) + "?appointmentId=" + id + "&returnPath=" + profileRoute + "&returnLabel=" + returnLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AppointmentSummary, { className: "myaccount-profile__summary upcoming-appointment__summary", type: upcomingAppointment.appointmentType, startTime: upcomingAppointment.startTime, endTime: upcomingAppointment.endTime, store: upcomingAppointment.store, openCancelModal: openModal, "aria-level": 5 }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "upcoming-appointment__reschedule-button", caption: getLabel('account.appointment.action.reschedule'), href: reschedulePath }),
        isModalOpen && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(CancelAppointmentModal$1, { appointmentId: id, onClose: closeModal })));
};
Appointment.displayName = 'Appointment';

var FailedAppointment = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: getLabel('account.appointments.errors.fetchFailed') });
};
FailedAppointment.displayName = 'FailedAppointment';

var LoadingAppointment = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SkeletonLoader */ "hb"], null,
    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "60px" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "25%", height: "15px", rx: "5", fill: "currentColor", y: "30" })))); };
LoadingAppointment.displayName = 'LoadingAppointment';

// TODO: In the future, the book appointment path should be a route key, instead of a hardcoded path
var BOOK_APPOINTMENT_ROUTE = 'book-appointment';
var PROFILE_PATH = 'my-account/profile';
var UpcomingAppointment = /** @class */ (function (_super) {
    __extends(UpcomingAppointment, _super);
    function UpcomingAppointment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cancelButtonRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["createRef"])();
        _this.state = {
            isModalOpen: false,
        };
        return _this;
    }
    UpcomingAppointment.prototype.componentDidMount = function () {
        this.props.fetchAppointments();
    };
    UpcomingAppointment.prototype.render = function () {
        var _a = this.props, accountRoutes = _a.accountRoutes, bookAppointmentRoute = _a.bookAppointmentRoute, appointmentList = _a.appointmentList, appointmentListCall = _a.appointmentListCall;
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusIdle */ "E"])(appointmentListCall) && Array.isArray(appointmentList)) {
            var upcomingAppointment = appointmentList.find(function (a) { return a.status === 'BOOKED'; });
            if (upcomingAppointment) {
                return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Appointment, { upcomingAppointment: upcomingAppointment, profileRoute: (accountRoutes === null || accountRoutes === void 0 ? void 0 : accountRoutes.profile) || PROFILE_PATH, bookAppointmentRoute: bookAppointmentRoute || BOOK_APPOINTMENT_ROUTE }));
            }
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(NoAppointment, null);
        }
        else if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(appointmentListCall)) {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(FailedAppointment, null);
        }
        else {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LoadingAppointment, null);
        }
    };
    return UpcomingAppointment;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$b = function (state) { return ({
    appointmentList: getAppointmentList(state),
    appointmentListCall: getAppointmentListCall(state),
    accountRoutes: getFormattedRoutes(state),
}); };
var mapDispatchToProps$8 = {
    fetchAppointments: fetchList$1,
};
var UpcomingAppointment$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$b, mapDispatchToProps$8)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(UpcomingAppointment));
var NoAppointment = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null, getLabel('account.noAppointments'));
};

var getProfile = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return isLoggedIn(auth) ? auth.profile : undefined;
});
var getForms = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getProfile, function (profile) { return (profile && profile.forms) || {}; });
var getFormData = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getForms, function (forms) {
    return forms
        ? {
            personalDetails: forms.personalDetails
                ? _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].getValuesFromState(forms.personalDetails.state.formState)
                : {},
            billingAddress: forms.billingAddress
                ? _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].getValuesFromState(forms.billingAddress.state.formState)
                : {},
            preferredStore: forms.preferredStore
                ? _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].getValuesFromState(forms.preferredStore.state.formState)
                : {},
        }
        : {};
});
var getFormValidity = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getForms, function (forms) { return ({
    personalDetails: forms && forms.personalDetails ? forms.personalDetails.state.formValid : false,
    billingAddress: forms && forms.billingAddress ? forms.billingAddress.state.formValid : false,
    preferredStore: forms && forms.preferredStore ? forms.preferredStore.state.formValid : false,
}); });
var getUserData = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getProfile, function (profile) {
    return (profile && profile.userData) || undefined;
});
var getCallStatus = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getProfile, function (profile) {
    return (profile && profile.updateCalls) || undefined;
});

var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFormChange = Object(throttle_debounce__WEBPACK_IMPORTED_MODULE_15__["debounce"])(250, function (form) {
            _this.props.changeFormValue({ form: form });
        });
        _this.handleChangePreferredStore = function (store) {
            _this.handleFormChange({
                formName: FormName.preferredStore,
                formState: { code: { name: 'code', value: store.code } },
                formValid: true,
            });
        };
        _this.handleUpdateUserData = function (formName) { return function () {
            _this.props.updateUserData(formName);
        }; };
        _this.isInEditMode = function (formName) {
            var formState = _this.props.formState && _this.props.formState[formName];
            return formState ? formState.inEditMode : false;
        };
        _this.toggleEditMode = function (formName, inEditMode) {
            if (inEditMode === void 0) { inEditMode = true; }
            return function () {
                return _this.props.toggleFormEditMode({ formName: formName, inEditMode: inEditMode });
            };
        };
        _this.editPersonalDetails = _this.toggleEditMode(FormName.personalDetails);
        _this.editBillingAddress = _this.toggleEditMode(FormName.billingAddress);
        _this.editPreferredStore = _this.toggleEditMode(FormName.preferredStore);
        _this.closePreferredStore = _this.toggleEditMode(FormName.preferredStore, false);
        _this.handleSavePersonalDetails = _this.handleUpdateUserData(FormName.personalDetails);
        _this.handleSaveBillingAddress = _this.handleUpdateUserData(FormName.billingAddress);
        _this.handleSavePreferredStore = _this.handleUpdateUserData(FormName.preferredStore);
        _this.renderErrorAlert = function (formName) {
            var _a = _this.props, intl = _a.intl, callStatus = _a.callStatus;
            return (callStatus &&
                Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(callStatus[formName]) && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel('account.profile.updateProfile.errors.general') }))));
        };
        return _this;
    }
    Profile.prototype.componentDidMount = function () {
        this.props.fetchUserData();
    };
    Profile.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var _e = this.props, auth = _e.auth, bookAppointmentRoute = _e.bookAppointmentRoute, formState = _e.formState, personalDetailsForm = _e.personalDetailsForm, addressForm = _e.addressForm, addressSummary = _e.addressSummary, personalDetailsSummary = _e.personalDetailsSummary, preferredStoreSummary = _e.preferredStoreSummary, callStatus = _e.callStatus, intl = _e.intl, personalGreetingFormatter = _e.personalGreetingFormatter;
        var ROUTE_KEY = 'profile';
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        if (auth.type !== 'regular') {
            throw new Error("Can't look at the Profile page with passwordless login");
        }
        var userData = auth.profile.userData;
        var preferredStoreCode = (_d = (_c = (_b = (_a = formState === null || formState === void 0 ? void 0 : formState.preferredStore) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.formState) === null || _c === void 0 ? void 0 : _c.code) === null || _d === void 0 ? void 0 : _d.value;
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(userData)) {
            var personalDetailsData = userData.result ? userData.result.personalDetails : {};
            var openSections_1 = [0];
            var sections = [
                {
                    title: intl.getLabel('account.profile.personalDetails'),
                    body: (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "section__body" },
                        react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null, intl.getLabel('account.profile.personalDetails.intro')),
                        this.isInEditMode(FormName.personalDetails) ? (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null,
                            this.renderErrorAlert(FormName.personalDetails),
                            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Form */ "j"], { name: "personalDetails", "data-t": "personalDetails", initialFormState: formState &&
                                    formState.personalDetails &&
                                    formState.personalDetails.state &&
                                    formState.personalDetails.state.formState, onChange: this.handleFormChange }, personalDetailsForm),
                            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Email */ "h"], { disabled: true, required: true, "data-t": "email", initialState: { value: auth.email, isTouched: false }, label: intl.getLabel('checkout.contact.email'), errorMessage: intl.getLabel('checkout.contact.email.errorMessage') }),
                            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { style: { margin: '1rem 0 2rem' } },
                                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: intl.getLabel('account.action.save'), isLoading: !callStatus || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(callStatus[FormName.personalDetails]), type: "button", "data-t": "save-personal-details", onClick: this.handleSavePersonalDetails, disabled: !this.props.formValidity.personalDetails, className: "myaccount-profile__button" })))) : (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: "myaccount-profile__summary", onEditClick: this.editPersonalDetails }, personalDetailsSummary({
                            data: personalDetailsData || {},
                            email: auth.email,
                        }))))),
                },
                {
                    title: intl.getLabel('account.profile.preferredStore'),
                    body: (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "section__body preferred-store" },
                        this.renderErrorAlert(FormName.preferredStore),
                        !preferredStoreCode && !this.isInEditMode(FormName.preferredStore) && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null,
                            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null, intl.getLabel('account.profile.preferredStore.noStoreSelected')),
                            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "edit-preferred-store", className: "preferred-store__add-store myaccount-profile__button", caption: intl.getLabel('account.profile.preferredStore.addStore'), color: "secondary", onClick: this.editPreferredStore }))),
                        preferredStoreCode && !this.isInEditMode(FormName.preferredStore) && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(PreferredStoreSummary, { preferredStoreCode: preferredStoreCode, formatter: preferredStoreSummary, onEdit: this.editPreferredStore, className: "myaccount-profile__summary" })),
                        this.isInEditMode(FormName.preferredStore) && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ErrorBoundary */ "q"], null, function (error) {
                            return error ? (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: intl.getLabel('account.profile.preferredStore.errors.fetchFailed') })) : (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(PreferredStore, { callStatus: callStatus, onCancel: _this.closePreferredStore, onSave: _this.handleSavePreferredStore, disableSave: !preferredStoreCode, onStoreSelect: _this.handleChangePreferredStore }));
                        })))),
                },
            ];
            if (!auth.disableAddressEditing) {
                sections.splice(1, 0, {
                    title: intl.getLabel('account.billingAddress'),
                    body: (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "section__body" },
                        react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null, intl.getLabel('account.profile.billingAddress.intro')),
                        this.isInEditMode(FormName.billingAddress) ? (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null,
                            this.renderErrorAlert(FormName.billingAddress),
                            react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Form */ "j"], { name: "billingAddress", "data-t": "billingAddress", initialFormState: formState &&
                                    formState.billingAddress &&
                                    formState.billingAddress.state &&
                                    formState.billingAddress.state.formState, onChange: this.handleFormChange },
                                addressForm,
                                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { style: { margin: '1rem 0 2rem' } },
                                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: intl.getLabel('account.action.save'), isLoading: !callStatus || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(callStatus[FormName.billingAddress]), type: "button", "data-t": "save-billing-address", onClick: this.handleSaveBillingAddress, disabled: !this.props.formValidity.billingAddress, className: "myaccount-profile__button" }))))) : (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: "myaccount-profile__summary", onEditClick: this.editBillingAddress }, addressSummary({
                            data: userData.result.billingAddress || {},
                        }))))),
                });
            }
            if (auth.isAabEnabled) {
                sections.splice(0, 0, {
                    title: intl.getLabel('account.appointments.title'),
                    body: react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(UpcomingAppointment$1, { bookAppointmentRoute: bookAppointmentRoute }),
                });
                openSections_1.push(1);
            }
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "myaccount-profile" },
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "myaccount-profile__wrapper" },
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "welcome-message" },
                        react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("h1", { className: "h3 myaccount-page-title" }, personalGreetingFormatter({
                            data: personalDetailsData,
                            getLabel: intl.getFormattedLabel,
                        }) || intl.getLabel('account.profile.title')),
                        react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("p", null, intl.getLabel('account.profile.intro'))),
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Accordion */ "a"], null, sections.map(function (section, i) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* AccordionItem */ "b"], { key: i, id: section.title.replace(' ', '-'), label: section.title, expanded: openSections_1.includes(i) }, section.body)); })))));
        }
        else if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(userData) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(userData)) {
            return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null);
        }
        return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel('account.profile.updateProfile.errors.general') }));
    };
    return Profile;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$c = function (state) { return ({
    auth: getAuth(state),
    userData: getUserData(state),
    formState: getForms(state),
    formValidity: getFormValidity(state),
    callStatus: getCallStatus(state),
}); };
var mapDispatchToProps$9 = {
    changeFormValue: changeFormValue,
    fetchUserData: fetchUserData,
    updateUserData: updateUserData,
    toggleFormEditMode: toggleFormEditMode,
};
var Profile$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$c, mapDispatchToProps$9)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withApiConfig */ "U"])(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(Profile)));

var alreadyLoaded = function (paged) {
    return paged.pages.reduce(function (total, page) { return total + page.length; }, 0);
};

var isMixedItemsReorderAvailable = function (lineItems, isPrescriptionGlassesReorderEnabled) {
    return isPrescriptionGlassesReorderEnabled || !_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isPrescriptionBundleInArray(lineItems);
};

var DetailHeaderItem = function (_a) {
    var term = _a.term, definition = _a.definition, className = _a.className;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("dt", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('detail-header__term', className) }, term),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("dd", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('detail-header__definition', className) }, definition)));
};
var DetailHeader = function (_a) {
    var className = _a.className, children = _a.children;
    var childArray = react__WEBPACK_IMPORTED_MODULE_1__["Children"].toArray(children);
    var kids = childArray.map(function (child) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["isValidElement"])(child)
            ? Object(react__WEBPACK_IMPORTED_MODULE_1__["cloneElement"])(child, {
                className: "columns-" + childArray.length,
            })
            : child;
    });
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("dl", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('detail-header', className) }, kids);
};
DetailHeader.Item = DetailHeaderItem;

var OrderHeader = function (_a) {
    var locale = _a.locale, className = _a.className, orderDate = _a.orderDate, orderNumber = _a.orderNumber, shipmentState = _a.shipmentState, onReorder = _a.onReorder;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var state = shipmentState
        ? intl.getLabel("account.order.shipmentState." + shipmentState.toLowerCase())
        : intl.getLabel('account.order.shipmentState.undefined');
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('order-header', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader, null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { term: intl.getLabel('account.order.date.label'), definition: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DateTime */ "n"], { dateTime: orderDate, locale: locale }) }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { term: intl.getLabel('account.order.number.label'), definition: orderNumber }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { term: intl.getLabel('account.order.shipmentState.label'), definition: state })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("aside", { className: "order-header__actions" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "re-order", className: "order-header__action", caption: intl.getLabel('account.action.reOrder'), disabled: !onReorder, onClick: onReorder }))));
};

var Order = /** @class */ (function (_super) {
    __extends(Order, _super);
    function Order() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleReorder = function () {
            var _a = _this.props, locale = _a.locale, country = _a.country, currency = _a.currency, drafts = _a.drafts, onReorder = _a.onReorder;
            onReorder && onReorder({ locale: locale, currency: currency, country: country, drafts: drafts });
        };
        return _this;
    }
    Order.prototype.render = function () {
        var _a = this.props, children = _a.children, footer = _a.footer, locale = _a.locale, className = _a.className, orderDate = _a.orderDate, orderNumber = _a.orderNumber, shipmentState = _a.shipmentState, onReorder = _a.onReorder;
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryContainer */ "lb"], { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('order', className) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OrderHeader, { locale: locale, orderDate: orderDate, orderNumber: orderNumber, shipmentState: shipmentState, onReorder: onReorder && this.handleReorder, className: "order__header" }),
            children,
            footer && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order__footer" }, footer)));
    };
    return Order;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));

var LineItemQuantity = function (_a) {
    var quantity = _a.quantity, className = _a.className, isContactLensBundle = _a.isContactLensBundle;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var fieldLabel = !isContactLensBundle ? getLabel('cart.item.quantity') + ": " : null;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('line-item-quantity', className) },
        fieldLabel,
        quantity));
};

var LineItemSubtitle = function (_a) {
    var className = _a.className, subtitle = _a.subtitle;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('line-item-subtitle', className) }, subtitle));
};

var LineItemTitle = function (_a) {
    var className = _a.className, title = _a.title;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('line-item-title', className) }, title));
};

var LineItemTrackingLink = function (_a) {
    var url = _a.url, className = _a.className;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Link */ "J"], { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('line-item-tracking-link', className), openInNewWindow: true, url: url, label: intl.getLabel('account.order.trackingLink.label') }));
};

var getProductTitle = function (product, locale) {
    switch (product.attributesType) {
        case 'sunglasses':
        case 'frames':
            return product.attributes.brand;
        case 'prescriptionGlasses':
            var _a = product.attributes, brand = _a.brand, brandModelCode = _a.brandModelCode;
            return "" + brand + (brandModelCode ? " " + brandModelCode : '');
        default:
            return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* getLocalizedValue */ "q"])(product.name, locale || 'en');
    }
};

function getLensAttrLabel(intl, key) {
    var PREFIX = 'products.contactLenses';
    var opts = { hideLabelKey: true };
    return {
        power: intl.getLabel(PREFIX + ".prescription.power", opts),
        baseCurve: intl.getLabel(PREFIX + ".prescription.baseCurve", opts),
        diameter: intl.getLabel(PREFIX + ".prescription.diameter", opts),
        cylinder: intl.getLabel(PREFIX + ".prescription.cylinder", opts),
        axis: intl.getLabel(PREFIX + ".prescription.axis", opts),
        addition: intl.getLabel(PREFIX + ".prescription.addition", opts),
        left: intl.getLabel(PREFIX + ".leftEye", opts),
        right: intl.getLabel(PREFIX + ".rightEye", opts),
        both: '',
    }[key];
}
function getProductA11yLabel(intl, product, quantity) {
    var quantityLabel = intl.getLabel('cart.item.quantity');
    var a11yLabel = getProductTitle(product, intl.locale);
    if (_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isSunglasses(product)) {
        a11yLabel += " " + product.attributes.brandModel;
    }
    if (quantity) {
        a11yLabel += ", " + quantityLabel + ": " + quantity;
    }
    if (_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isContactLenses(product)) {
        var _a = product.attributes, power = _a.power, baseCurve = _a.baseCurve, diameter = _a.diameter, cylinder = _a.cylinder, axis = _a.axis, addition = _a.addition, eyeSide = _a.eyeSide;
        // prepend label with eyeSide if eyeSide is 'left' or 'right'
        if (eyeSide && getLensAttrLabel(intl, eyeSide)) {
            a11yLabel = getLensAttrLabel(intl, eyeSide) + ", " + a11yLabel;
        }
        var lensAttributes = { power: power, baseCurve: baseCurve, diameter: diameter, cylinder: cylinder, axis: axis, addition: addition };
        return Object.entries(lensAttributes).reduce(function (acc, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var label = getLensAttrLabel(intl, key);
            if (!label || !value) {
                return acc;
            }
            return acc + (", " + label + ": " + value);
        }, a11yLabel);
    }
    return a11yLabel;
}

var getProductQuantity = function (product, quantity) {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    switch (product.attributesType) {
        case 'Contact-lens-bundles':
            var _a = product.attributes, isSubscription = _a.isSubscription, months = _a.months;
            var monthLabel = months <= 1
                ? intl.getLabel('account.contactLensBundles.month')
                : intl.getLabel('account.contactLensBundles.months');
            return isSubscription
                ? intl.getLabel('account.contactLensBundles.subtitle')
                : months + " " + monthLabel;
        default:
            return quantity;
    }
};

var getProductSubtitle = function (product, locale) {
    if (locale === void 0) { locale = 'en'; }
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    switch (product.attributesType) {
        case 'Contact-lenses':
            var _a = product.attributes, packageQuantity = _a.packageQuantity, replacementFrequency = _a.replacementFrequency, eyeSide = _a.eyeSide;
            var eyeSideLabelKey = eyeSide === 'left' ? 'products.contactLenses.leftEye' : 'products.contactLenses.rightEye';
            return packageQuantity + " " + replacementFrequency.en + " " + intl.getLabel('products.unit.contactLenses') + " " + intl.getLabel('products.perBox') + ", " + intl.getLabel(eyeSideLabelKey);
        case 'Contact-lens-bundles':
            var lensType = product.attributes.lensType;
            return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* getLocalizedValue */ "q"])(lensType, locale);
        case 'Solutions':
            var volume = product.attributes.volume;
            return "" + volume + intl.getLabel('products.unit.metric.liter.milli.abbr');
    }
    if ('brandModel' in product.attributes) {
        return product.attributes.brandModel;
    }
};

var getDiscountIfDifferent = function (catalogPrice, discountPrice) {
    return catalogPrice !== discountPrice ? discountPrice : undefined;
};
var getLineItemProps = function (lineItem, includeAddOns) {
    var _a, _b, _c;
    if (_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isPrescriptionGlasses(lineItem.product)) {
        var catalogPrice = lineItem.catalogPrice, discountedPrice = lineItem.discountedPrice, totalPrice = lineItem.totalPrice, product = lineItem.product, quantity = lineItem.quantity;
        var price = product.lineItemDetail.bundleMainLineItem.price;
        var mainPrice = __assign(__assign({}, catalogPrice), { amount: includeAddOns ? catalogPrice.amount : price.value.centAmount });
        var discountPrice = includeAddOns
            ? (_a = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.amount) !== null && _a !== void 0 ? _a : discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.amount : (_b = price.discounted) === null || _b === void 0 ? void 0 : _b.value.centAmount;
        return {
            product: product,
            catalogPrice: mainPrice,
            discountPrice: getDiscountIfDifferent(catalogPrice.amount, discountPrice),
            quantity: quantity,
        };
    }
    else {
        var product = lineItem.product, catalogPrice = lineItem.catalogPrice, discountedPrice = lineItem.discountedPrice, totalPrice = lineItem.totalPrice, quantity = lineItem.quantity;
        var discountPrice = (_c = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.amount) !== null && _c !== void 0 ? _c : discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.amount;
        return {
            product: product,
            catalogPrice: catalogPrice,
            discountPrice: getDiscountIfDifferent(catalogPrice.amount, discountPrice),
            quantity: quantity,
        };
    }
};

var OrderLineItem = function (_a) {
    var staticsUrl = _a.staticsUrl, lineItem = _a.lineItem, _b = _a.includeAddOns, includeAddOns = _b === void 0 ? false : _b, trackingUrl = _a.trackingUrl, children = _a.children, className = _a.className, getItemImageUrl = _a.getItemImageUrl, priceClassName = _a.priceClassName, locale = _a.locale;
    var _c = getLineItemProps(lineItem, includeAddOns), product = _c.product, catalogPrice = _c.catalogPrice, discountPrice = _c.discountPrice, quantity = _c.quantity;
    var title = getProductTitle(product, locale);
    var subtitle = getProductSubtitle(product, locale);
    var eyeSide = product.attributes.eyeSide;
    var imagePath = getItemImageUrl
        ? getItemImageUrl(product)
        : "" + staticsUrl + product.imageId + "?w=300&bg=FFFFFF&fm=jpeg&auto=format";
    var eyeSideElement = eyeSide && eyeSide !== 'both' ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* EyeSideIndicator */ "r"], { className: "order-line-item__eyeside-indicator", side: eyeSide })) : null;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('order-line-item', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItem */ "D"], { className: "order-line-item__container" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemMedia */ "I"], { type: "image", imageUrl: imagePath, imageAlt: title, overlayElement: eyeSideElement }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemContent */ "F"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemTitle, { title: title }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-line-item__content" },
                    subtitle && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemSubtitle, { subtitle: subtitle }),
                    children && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-line-item__children" }, children)),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemQuantity, { quantity: getProductQuantity(product, quantity), isContactLensBundle: _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_20__[/* CommerceToolsApi */ "a"].isContactLensBundle(lineItem.product) }),
                trackingUrl && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null,
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemTrackingLink, { url: trackingUrl })))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemAside */ "E"], { currency: catalogPrice.currency, price: catalogPrice.amount, discountPrice: discountPrice, className: priceClassName }))));
};

var OverviewFooter = function (_a) {
    var order = _a.order, children = _a.children;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order__footer--overview" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null, intl.getLabel('common.total')),
            "\u00A0",
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "W"], { value: order.totalChargedPrice.amount, currency: order.totalChargedPrice.currency, centAmount: true })),
        children));
};
var elementName$3 = 'myaccount-order-list';
var OrderList = /** @class */ (function (_super) {
    __extends(OrderList, _super);
    function OrderList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchNextPage = function () {
            var _a = _this.props, orders = _a.orders, fetchPage = _a.fetchPage;
            if (!orders) {
                return;
            }
            var loaded = alreadyLoaded(orders);
            if (loaded >= orders.total) {
                // All pages are loaded
                return;
            }
            fetchPage({
                limit: orders.size,
                skip: loaded,
            });
        };
        _this.renderOrders = function (orders) {
            var loaded = alreadyLoaded(orders);
            var _a = _this.props, intl = _a.intl, locale = _a.locale, country = _a.country, staticsUrl = _a.staticsUrl, getItemImageUrl = _a.getItemImageUrl, getDetailsUrl = _a.getDetailsUrl, isPrescriptionGlassesReorderEnabled = _a.isPrescriptionGlassesReorderEnabled, isLegacyOrderSupplierEanEnabled = _a.isLegacyOrderSupplierEanEnabled, fetchCall = _a.fetchCall, reorderCall = _a.reorderCall, reorder = _a.reorder, _b = _a.convertOrderLineItem, convertOrderLineItem = _b === void 0 ? convertLineItemsToDrafts : _b;
            return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                orders.pages.map(function (page) {
                    return page.map(function (order) {
                        var drafts = convertOrderLineItem(order.lineItems, isLegacyOrderSupplierEanEnabled);
                        var isPGReorderAvailable = isMixedItemsReorderAvailable(order.lineItems, isPrescriptionGlassesReorderEnabled);
                        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Order, { key: order.orderNumber, locale: locale, country: country, currency: order.totalChargedPrice.currency, orderDate: order.orderDate, orderNumber: order.orderNumber, shipmentState: order.shipmentState, drafts: drafts, onReorder: isPGReorderAvailable && !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(reorderCall) ? reorder : undefined, footer: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OverviewFooter, { order: order }, getDetailsUrl && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Link */ "J"], { url: getDetailsUrl(order.orderNumber), label: intl.getLabel('account.common.viewDetails') }))) }, order.lineItems.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OrderLineItem, { key: item.product.sku, staticsUrl: staticsUrl, includeAddOns: true, lineItem: item, getItemImageUrl: getItemImageUrl, locale: locale })); })));
                    });
                }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: elementName$3 + "__pager" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ProgressBar */ "Y"], { max: orders.total, value: loaded }),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: elementName$3 + "__pager-label" }, OrderList.formatProgressLabel(intl.getLabel('account.orders.pagingStatus'), orders.total, loaded)),
                    loaded < orders.total && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "load-more", className: elementName$3 + "__pager-button", caption: intl.getLabel('account.orders.showMore'), onClick: _this.fetchNextPage, disabled: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(fetchCall), variant: "outline" })))));
        };
        return _this;
    }
    OrderList.prototype.componentDidMount = function () {
        if (!this.props.orders) {
            // Fetch first page
            this.props.fetchPage({
                limit: 5,
                skip: 0,
            });
        }
    };
    OrderList.prototype.render = function () {
        var _a = this.props, intl = _a.intl, orders = _a.orders;
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: elementName$3 }, !orders ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null)) : orders.total <= 0 ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null, intl.getLabel('account.order.noHistory.message'))) : (this.renderOrders(orders))));
    };
    OrderList.formatProgressLabel = function (label, total, loaded) {
        return label.replace('{{total}}', total.toFixed(0)).replace('{{loaded}}', loaded.toFixed(0));
    };
    return OrderList;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var OrderList$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withFeatureToggles */ "V"])(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(OrderList));

var getOrders = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return isLoggedIn(auth) ? auth.orders : undefined;
});
var getOrderHistory = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) { return (orders ? orders.history : undefined); });
var getLegacyOrderHistory = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) { return (orders ? orders.legacyHistory : undefined); });
var getOrderHistoryCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) { return (orders ? orders.historyCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])()); });
var getLegacyOrderHistoryCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) {
    return orders ? orders.legacyHistoryCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getOrderDetail = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) { return (orders ? orders.detail : undefined); });
var getOrderDetailCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) { return (orders ? orders.detailCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])()); });
var getLegacyOrderDetail = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) { return (orders ? orders.legacyDetail : undefined); });
var getLegacyOrderDetailCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) {
    return orders ? orders.legacyDetailCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getReorderCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getOrders, function (orders) { return (orders ? orders.reorderCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])()); });

var Orders = /** @class */ (function (_super) {
    __extends(Orders, _super);
    function Orders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeTabIndex: 0,
        };
        _this.onOrdersTabChange = function (activeTabIndex) {
            _this.setState({ activeTabIndex: activeTabIndex });
        };
        return _this;
    }
    Orders.prototype.getOrderListProps = function () {
        var _a = this.props, historyCall = _a.historyCall, legacyHistoryCall = _a.legacyHistoryCall, legacyOrderPages = _a.legacyOrderPages, reorder = _a.reorder, orderPages = _a.orderPages, reorderCall = _a.reorderCall, fetchPage = _a.fetchPage, fetchLegacyPage = _a.fetchLegacyPage, routes = _a.routes;
        var activeTabIndex = this.state.activeTabIndex;
        return activeTabIndex === 0
            ? {
                fetchPage: fetchPage,
                fetchCall: historyCall,
                orders: orderPages,
                reorder: reorder,
                reorderCall: reorderCall,
                getDetailsUrl: routes
                    ? function (orderNumber) { return routes.orders + "/" + orderNumber; }
                    : undefined,
            }
            : {
                fetchPage: fetchLegacyPage,
                fetchCall: legacyHistoryCall,
                orders: legacyOrderPages,
                reorder: undefined,
                reorderCall: reorderCall,
                getDetailsUrl: routes
                    ? function (orderNumber) { return routes.orders + "/legacy/" + orderNumber; }
                    : undefined,
            };
    };
    Orders.prototype.render = function () {
        var _a = this.props, intl = _a.intl, routes = _a.routes, locale = _a.locale, country = _a.country, staticsUrl = _a.staticsUrl, reorderCall = _a.reorderCall, getItemImageUrl = _a.getItemImageUrl, enableLegacyOrderHistory = _a.enableLegacyOrderHistory, convertOrderLineItem = _a.convertOrderLineItem;
        var activeTabIndex = this.state.activeTabIndex;
        var reduxProps = this.getOrderListProps();
        var ROUTE_KEY = 'orders';
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount-orders" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h3", { className: "myaccount-page-title" }, routeLabel),
            enableLegacyOrderHistory && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount-orders__tabs" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tabs */ "qb"], { onChange: this.onOrdersTabChange, activeTabIndex: activeTabIndex },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: intl.getLabel('account.order.tabs.commercetools') }),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: intl.getLabel('account.order.tabs.legacy') })))),
            Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(reorderCall) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel('account.order.reorder.errors.general') }))),
            routes ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OrderList$1, __assign({}, reduxProps, { locale: locale, country: country, staticsUrl: staticsUrl, getItemImageUrl: getItemImageUrl, convertOrderLineItem: convertOrderLineItem, key: activeTabIndex === 0 ? 'regular' : 'legacy' }))) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null))));
    };
    return Orders;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
var mapStateToProps$d = function (state) { return ({
    routes: getFormattedRoutes(state),
    orderPages: getOrderHistory(state),
    legacyOrderPages: getLegacyOrderHistory(state),
    historyCall: getOrderHistoryCall(state),
    legacyHistoryCall: getLegacyOrderHistoryCall(state),
    reorderCall: getReorderCall(state),
}); };
var mapDispatchToProps$a = {
    fetchPage: fetchPage,
    fetchLegacyPage: fetchLegacyPage,
    reorder: reorder,
};
var Orders$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$d, mapDispatchToProps$a)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(Orders));

var Item = function (_a) {
    var label = _a.label, subtitle = _a.subtitle, className = _a.className, children = _a.children;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tr", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('detail-footer__item', className) },
            label && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("th", { scope: "row" }, label),
            children && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("td", null, children)),
        subtitle && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tr", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('detail-footer__item', 'detail-footer__item--subtitle', className) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("th", { colSpan: 2 }, subtitle)))));
};
var PriceItem = function (_a) {
    var price = _a.price, prefix = _a.prefix, label = _a.label, rest = __rest(_a, ["price", "prefix", "label"]);
    return (
    // Suffix all PriceItems labels with a colon and space
    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Item, __assign({ label: label + ': ' }, rest),
        prefix,
        " ",
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "W"], { value: price.amount, currency: price.currency, centAmount: true })));
};
var DetailFooter = function (_a) {
    var subtotal = _a.subtotal, includesProductDiscount = _a.includesProductDiscount, discount = _a.discount, shipping = _a.shipping, total = _a.total;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("table", { className: "detail-footer" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tbody", null,
            !!subtotal && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PriceItem, { price: subtotal, label: intl.getLabel('common.subtotal'), subtitle: includesProductDiscount ? intl.getLabel('common.includesProductDiscount') : '' })),
            !!discount && discount.amount > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PriceItem, { prefix: "-", price: discount, label: intl.getLabel('common.additionalDiscount') })),
            shipping !== undefined && shipping.amount > 0 ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PriceItem, { price: shipping, label: intl.getLabel('common.shipping') })) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Item, { label: intl.getLabel('common.shipping') + ': ' }, intl.getLabel('common.free'))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PriceItem, { price: total, label: intl.getLabel('common.total'), className: "detail-footer__item--total" }))));
};

var OrderOfPrescriptionAttributes = [
    'power',
    'baseCurve',
    'diameter',
    'axis',
    'cylinder',
    'addition',
];
var LineItemPrescription = function (_a) {
    var prescriptionAttrs = _a.prescriptionAttrs;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "line-item__prescription" }, OrderOfPrescriptionAttributes.map(function (key) {
        var value = prescriptionAttrs[key];
        return (value &&
            (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* isString */ "B"])(value) || Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* isNumber */ "z"])(value)) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "line-item__prescription-item", key: key },
            intl.getLabel("products.contactLenses.prescription." + key + ".abbr") + ': ',
            value)));
    })));
};

var getLensParameters = function (item, eyeSide) {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var fields = item.product.attributes;
    if (!fields) {
        return [];
    }
    var paramsLabels = {
        basecurve: intl.getLabel('products.contactLenses.prescription.baseCurve'),
        basecurveAbbr: intl.getLabel('products.contactLenses.prescription.baseCurve.abbr'),
        diameter: intl.getLabel('products.contactLenses.prescription.diameter'),
        diameterAbbr: intl.getLabel('products.contactLenses.prescription.diameter.abbr'),
        power: intl.getLabel('products.contactLenses.prescription.power'),
        powerAbbr: intl.getLabel('products.contactLenses.prescription.power.abbr'),
        cylinder: intl.getLabel('products.contactLenses.prescription.cylinder'),
        cylinderAbbr: intl.getLabel('products.contactLenses.prescription.cylinder.abbr'),
        axis: intl.getLabel('products.contactLenses.prescription.axis'),
        axisAbbr: intl.getLabel('products.contactLenses.prescription.axis.abbr'),
    };
    return [
        {
            key: paramsLabels.basecurve,
            keyAbbr: paramsLabels.basecurveAbbr,
            value: fields[eyeSide + "LensBaseCurve"],
        },
        {
            key: paramsLabels.diameter,
            keyAbbr: paramsLabels.diameterAbbr,
            value: fields[eyeSide + "LensDiameter"],
        },
        {
            key: paramsLabels.power,
            keyAbbr: paramsLabels.powerAbbr,
            value: fields[eyeSide + "LensPower"],
        },
        {
            key: paramsLabels.cylinder,
            keyAbbr: paramsLabels.cylinderAbbr,
            value: fields[eyeSide + "LensCylinder"],
        },
        {
            key: paramsLabels.axis,
            keyAbbr: paramsLabels.axisAbbr,
            value: fields[eyeSide + "LensAxis"],
        },
    ];
};
var getBundleConfiguration = function (item, locale) {
    var product = item.product;
    var name = product.name[locale];
    var lensType = product.attributes.lensType[locale];
    var months = product.attributes.months;
    var isSubscription = product.attributes.isSubscription;
    var fixedDiscount = product.attributes.fixedDiscount || 0;
    var leftItemName = product.attributes.leftLensName;
    var rightItemName = product.attributes.rightLensName;
    var solutionName = product.attributes.solutionName;
    return {
        item: {
            name: name,
            lensType: lensType,
            months: months,
            isSubscription: isSubscription,
            fixedDiscount: fixedDiscount,
        },
        leftEye: {
            name: leftItemName,
            parameters: getLensParameters(item, 'left'),
        },
        rightEye: {
            name: rightItemName,
            parameters: getLensParameters(item, 'right'),
        },
        solution: {
            name: solutionName,
        },
    };
};
var getDiscountDescription = function (fixedDiscount, intl) {
    var discountLabel = intl.getLabel('products.includingCareDiscount');
    return fixedDiscount ? discountLabel + " " + fixedDiscount * 100 + "%" : '';
};
var getDeliveryDescription = function (bundleConfiguration, intl) {
    var duration = bundleConfiguration.item.months;
    if (bundleConfiguration.item.isSubscription) {
        return intl.getLabel('products.shipment.method.monthly');
    }
    else {
        return duration > 1
            ? duration + " " + intl.getLabel('products.months')
            : duration + " " + intl.getLabel('products.month');
    }
};
var toFixed = function (key, value) {
    var ommitedKeys = ['As', 'Axis'];
    return ommitedKeys.includes(key) ? value.toString() : value.toFixed(2);
};
var formatLensAttr = function (key, value) {
    if (key === 'Str') {
        return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* withPlusSign */ "O"])(toFixed(key, value));
    }
    return toFixed(key, value);
};
var BundleItem = function (_a) {
    var item = _a.item, locale = _a.locale, getItemImageUrl = _a.getItemImageUrl, currentBreakpoint = _a.currentBreakpoint;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var isMobile = currentBreakpoint === _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName.PHONE;
    var bundleConfiguration = getBundleConfiguration(item, locale);
    var currency = item.catalogPrice.currency;
    var price = item.catalogPrice.amount;
    var discountPrice = item.discountedPrice ? item.discountedPrice.amount : undefined;
    var bundleImageUrl = getItemImageUrl && getItemImageUrl(item.product);
    var bundleImageAlt = bundleConfiguration.item.name;
    var solutionImageUrl = getItemImageUrl && getItemImageUrl(item.product, 'Solutions');
    var solutionImageAlt = bundleConfiguration.solution.name;
    var priceClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()('bundle-item__price', {
        'bundle-item__price--strikethrough': typeof discountPrice === 'number',
    });
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__box bundle-item__bundle" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("figure", { className: "bundle-item__product-image" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("img", { className: "bundle-item__image", src: bundleImageUrl, alt: bundleImageAlt })),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__main" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", { className: "bundle-item__title" }, bundleConfiguration.item.name),
                !isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__children" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null, bundleConfiguration.item.lensType),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null, getDeliveryDescription(bundleConfiguration, intl)),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null, getDiscountDescription(bundleConfiguration.item.fixedDiscount, intl))))),
            isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__children" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null, bundleConfiguration.item.lensType),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null, getDeliveryDescription(bundleConfiguration, intl)),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null, getDiscountDescription(bundleConfiguration.item.fixedDiscount, intl)))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("aside", { className: "bundle-item__prices" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: priceClassNames },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "W"], { value: price, currency: currency })),
                discountPrice && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "bundle-item__price" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "W"], { value: discountPrice, currency: currency }))))),
        bundleConfiguration.leftEye.name ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__box bundle-item__lens" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("figure", { className: "bundle-item__product-image bundle-item__lens-icon" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { name: "left-eye", width: 48, height: 48 }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", { className: "bundle-item__eye-label" }, intl.getLabel('products.contactLenses.leftEye'))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__main bundle-item__lens-details" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", { className: "bundle-item__title bundle-item__title--lens" }, bundleConfiguration.leftEye.name),
                !isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__children" }, bundleConfiguration.leftEye.parameters.map(function (param) {
                    return param.value !== undefined ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { key: param.key, className: "bundle-item__lens-param" },
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-name" }, param.key),
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
                })))),
            isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__children" }, bundleConfiguration.leftEye.parameters.map(function (param) {
                return param.value !== undefined ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { key: param.key, className: "bundle-item__lens-param" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-name" }, param.key),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
            }))))) : null,
        bundleConfiguration.rightEye.name ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__box bundle-item__lens" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("figure", { className: "bundle-item__product-image bundle-item__lens-icon" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { name: "right-eye", width: 48, height: 48 }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", { className: "bundle-item__eye-label" }, intl.getLabel('products.contactLenses.rightEye'))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__main bundle-item__lens-details" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", { className: "bundle-item__title bundle-item__title--lens" }, bundleConfiguration.rightEye.name),
                !isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__children" }, bundleConfiguration.rightEye.parameters.map(function (param) {
                    return param.value !== undefined ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { key: param.key, className: "bundle-item__lens-param" },
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-name" }, param.key),
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
                })))),
            isMobile && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__children" }, bundleConfiguration.rightEye.parameters.map(function (param) {
                return param.value !== undefined ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { key: param.key, className: "bundle-item__lens-param" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-name" }, param.key),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
            }))))) : null,
        bundleConfiguration.solution.name ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__box bundle-item__solution" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("figure", { className: "bundle-item__product-image bundle-item__product-image--solution" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("img", { className: "bundle-item__image", src: solutionImageUrl, alt: solutionImageAlt })),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "bundle-item__main bundle-item__solution-details" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", { className: "bundle-item__title bundle-item__title--solution" }, bundleConfiguration.solution.name)))) : null));
};
var BundleItem$1 = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].WithBreakpoints(BundleItem);

var baseClassName = 'prescription-glasses-line-item';
var PrescriptionGlassesLineItem = function (_a) {
    var orderProps = __rest(_a, []);
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), currency = _b.currency, getLabel = _b.getLabel;
    var lineItemDetail = orderProps.lineItem.product.lineItemDetail;
    var _c = getLineItemProps(orderProps.lineItem, true), catalogPrice = _c.catalogPrice, discountPrice = _c.discountPrice;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: baseClassName },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OrderLineItem, __assign({}, orderProps, { priceClassName: baseClassName + "__frame-price" })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: baseClassName + "__info-container" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Block, { column: true },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(BlockHeadline, null, getLabel('account.order.labels.prescriptionDetails')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemGlassesPrescription */ "H"], { prescription: lineItemDetail.prescription })),
            !!(lineItemDetail === null || lineItemDetail === void 0 ? void 0 : lineItemDetail.bundleChildLineItems.length) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Block, { column: true },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(BlockHeadline, null, getLabel('account.order.labels.yourAddOns')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null, lineItemDetail === null || lineItemDetail === void 0 ? void 0 : lineItemDetail.bundleChildLineItems.map(function (item) {
                    var _a;
                    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* PrescriptionGlassesBundleChildItem */ "V"], { key: item.productId, currency: currency, originalPrice: item.price.value.centAmount, discountedPrice: (_a = item.price.discounted) === null || _a === void 0 ? void 0 : _a.value.centAmount, label: getLabel("cart.lineItem.glasses.bundleItem." + item.productType), priceIsZeroLabel: getLabel('cart.lineItem.glasses.isIncluded', {
                            hideLabelKey: true,
                        }), value: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* getLocalizedValue */ "q"])(item.name, orderProps.locale || 'en') }));
                })))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Block, null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(BlockHeadline, { inline: true }, getLabel('account.order.labels.productPrice')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemAside */ "E"], { currency: catalogPrice.currency, price: catalogPrice.amount, discountPrice: discountPrice, className: baseClassName + "__total-price" })))));
};
var BlockHeadline = function (_a) {
    var _b;
    var children = _a.children, inline = _a.inline;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([
            baseClassName + "__headline",
            (_b = {},
                _b[baseClassName + "__headline--block"] = !inline,
                _b[baseClassName + "__headline--inline"] = inline,
                _b),
        ]) }, children));
};
var Block = function (_a) {
    var _b;
    var children = _a.children, column = _a.column;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([
            baseClassName + "__block",
            (_b = {},
                _b[baseClassName + "__block--column"] = column,
                _b),
        ]) }, children));
};

var SelectableLineItem = function (_a) {
    var lineItem = _a.lineItem, getItemImageUrl = _a.getItemImageUrl, staticsUrl = _a.staticsUrl, locale = _a.locale, _b = _a.isSelectable, isSelectable = _b === void 0 ? true : _b, onSelectionChange = _a.onSelectionChange, isSelected = _a.isSelected;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var product = lineItem.product;
    var name = product.name, sku = product.sku;
    var eyeSideForId = _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isDetailContactLenses(product) && product.attributes.eyeSide
        ? " - " + product.attributes.eyeSide
        : '';
    var id = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* getLocalizedValue */ "q"])(name, 'en') + " - " + sku + eyeSideForId;
    var a11yLabel = getProductA11yLabel(intl, product);
    var renderLineItem = function (product) {
        switch (true) {
            case _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isDetailContactLensBundles(product):
                return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(BundleItem$1, { key: product.sku, item: lineItem, locale: locale, getItemImageUrl: getItemImageUrl }));
            case _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isPrescriptionGlasses(product):
                return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionGlassesLineItem, { key: lineItem.product.sku, staticsUrl: staticsUrl, lineItem: lineItem, getItemImageUrl: getItemImageUrl, locale: locale }));
            default:
                return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OrderLineItem, { key: lineItem.product.sku, staticsUrl: staticsUrl, lineItem: lineItem, getItemImageUrl: getItemImageUrl, locale: locale }, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isDetailContactLenses(product) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemPrescription, { prescriptionAttrs: product.attributes }))));
        }
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "selectable-line-item" },
        isSelectable && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("label", { htmlFor: id, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([
                'selectable-line-item__checkbox',
                {
                    'selectable-line-item__checkbox--prescription-glasses': _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].isPrescriptionGlasses(product),
                },
            ]) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Checkbox */ "c"], { id: id, "aria-label": a11yLabel, value: lineItem, onChange: onSelectionChange, checked: isSelected }))),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "selectable-line-item__content" }, renderLineItem(product))));
};

var AddressSummaryRenderer = function (_a) {
    var address = _a.address, formatter = _a.formatter;
    return formatter(address);
};
var ContactDetailsSummaryRenderer = function (_a) {
    var order = _a.order, formatter = _a.formatter;
    return formatter(order);
};
var hasProductDiscount = function (order) {
    return order.lineItems.some(function (item) { return item.hasOwnProperty('discountedPrice'); });
};
var OrderDetail = /** @class */ (function (_super) {
    __extends(OrderDetail, _super);
    function OrderDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.onSelectionChange = function (_a) {
            var checked = _a.checked, lineItem = _a.value;
            var current = _this.state.selectedItems;
            if (!current) {
                // This should not really occur as we're seeding the selected set with all lineitem sku on first load
                return;
            }
            var selectedItems = new Set(current);
            if (checked) {
                selectedItems.add(_this.getProductIdentifier(lineItem));
            }
            else {
                selectedItems.delete(_this.getProductIdentifier(lineItem));
            }
            _this.setState({ selectedItems: selectedItems });
        };
        _this.isSelected = function (sku) {
            return _this.state.selectedItems ? _this.state.selectedItems.has(sku) : false;
        };
        _this.onReorder = function (_a) {
            var _b;
            var drafts = _a.drafts, rest = __rest(_a, ["drafts"]);
            var prescriptionGlassesBundleLineItems = (_b = drafts.prescriptionGlassesBundleLineItems) === null || _b === void 0 ? void 0 : _b.filter(function (draft) { return _this.isSelected(draft.bundleMainLineItem.sku); });
            return _this.props.reorder(__assign(__assign({}, rest), { drafts: {
                    lineItems: drafts.lineItems.filter(function (draft) { return _this.isSelected(draft.sku); }),
                    prescriptionGlassesBundleLineItems: (prescriptionGlassesBundleLineItems === null || prescriptionGlassesBundleLineItems === void 0 ? void 0 : prescriptionGlassesBundleLineItems.length) ? prescriptionGlassesBundleLineItems
                        : undefined,
                } }));
        };
        return _this;
    }
    OrderDetail.prototype.componentDidMount = function () {
        var _a = this.props, orderNumber = _a.orderNumber, fetchDetail = _a.fetchDetail, fetchLegacyDetail = _a.fetchLegacyDetail, isLegacy = _a.isLegacy;
        isLegacy ? fetchLegacyDetail({ orderNumber: orderNumber }) : fetchDetail({ orderNumber: orderNumber });
    };
    OrderDetail.prototype.getOrderDetail = function () {
        var _a = this.props, isLegacy = _a.isLegacy, legacyDetail = _a.legacyDetail, detail = _a.detail;
        return isLegacy ? legacyDetail : detail;
    };
    OrderDetail.prototype.getDetailCall = function () {
        var _a = this.props, isLegacy = _a.isLegacy, legacyDetailCall = _a.legacyDetailCall, detailCall = _a.detailCall;
        return isLegacy ? legacyDetailCall : detailCall;
    };
    OrderDetail.prototype.getProductIdentifier = function (item) {
        var isLegacyOrderSupplierEanEnabled = this.props.isLegacyOrderSupplierEanEnabled;
        return isLegacyOrderSupplierEanEnabled ? item.product.attributes.supplierEAN : item.product.sku;
    };
    OrderDetail.prototype.render = function () {
        var _this = this;
        var _a = this.props, staticsUrl = _a.staticsUrl, locale = _a.locale, country = _a.country, getItemImageUrl = _a.getItemImageUrl, isLegacy = _a.isLegacy, isPrescriptionGlassesReorderEnabled = _a.isPrescriptionGlassesReorderEnabled, intl = _a.intl, isLegacyOrderSupplierEanEnabled = _a.isLegacyOrderSupplierEanEnabled;
        var detail = this.getOrderDetail();
        var detailCall = this.getDetailCall();
        if (detail && detail.orderNumber === this.props.orderNumber) {
            var isReorderAvailable_1 = isMixedItemsReorderAvailable(detail.lineItems, isPrescriptionGlassesReorderEnabled) &&
                !isLegacy;
            var drafts = convertLineItemsToDrafts(detail.lineItems, isLegacyOrderSupplierEanEnabled);
            return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-detail" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Image */ "y"]
                // TODO: Fetch correct image
                , { 
                    // TODO: Fetch correct image
                    url: "https://unsplash.it/800/425?image=156", cover: true, lazyLoadingOptions: { q: '50', auto: '50' }, className: "myaccount-hero" }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: [
                        { name: intl.getLabel('account.menu.orders'), routeKey: 'orders' },
                        { name: intl.getLabel('common.order') + " " + detail.orderNumber },
                    ] }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h3", { className: "myaccount-page-title order-detail__title" }, intl.getLabel('account.menu.orders')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Order, { className: "order-details__order", locale: locale, country: country, currency: detail.totalChargedPrice.currency, drafts: drafts, onReorder: isReorderAvailable_1 ? this.onReorder : undefined, footer: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailFooter, { subtotal: detail.totalProductsPrice, includesProductDiscount: hasProductDiscount(detail), discount: detail.totalAdditionalDiscount, shipping: detail.shippingPrice, total: detail.totalChargedPrice }), orderDate: detail.orderDate, orderNumber: detail.orderNumber, shipmentState: detail.shipmentState }, detail.lineItems.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SelectableLineItem, { key: item.product.sku, lineItem: item, staticsUrl: staticsUrl, locale: locale, isSelectable: isReorderAvailable_1, getItemImageUrl: getItemImageUrl, onSelectionChange: _this.onSelectionChange, isSelected: _this.isSelected(_this.getProductIdentifier(item)) })); })),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-details__summary order-details__summary--contact" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h4", { className: "order-details__section-title" }, intl.getLabel('checkout.completed.contactDetails.title')),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], null,
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(ContactDetailsSummaryRenderer, { order: detail, formatter: this.props.contactDetailsFormatter }))),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-details__summary order-details__summary--delivery" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h4", { className: "order-details__section-title" }, intl.getLabel('checkout.shipment.title')),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], null,
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-details__summary order-details__summary--delivery-method" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", null, intl.getLabel('checkout.shipment.method.title')),
                            Object(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryItem */ "mb"])(intl.getLabel("checkout.shipment.method." + detail.shippingInfo.deliveryMethod)))),
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: "order-details__addresses" },
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-details__delivery-address" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", null, intl.getLabel('checkout.shipment.address')),
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddressSummaryRenderer, { address: detail.shippingAddress, formatter: detail.shippingInfo &&
                                    detail.shippingInfo.deliveryMethod &&
                                    detail.shippingInfo.deliveryMethod === 'pick-up'
                                    ? this.props.storeAddressFormatter
                                    : this.props.addressFormatter })),
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "order-details__billing-address" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h5", null, intl.getLabel('checkout.billingAddress')),
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddressSummaryRenderer, { address: detail.billingAddress, formatter: this.props.addressFormatter }))))));
        }
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(detailCall) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusIdle */ "E"])(detailCall)) {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null);
        }
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(detailCall) || !detail) {
            return (
            // TODO: Find out what design should look like
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: intl.getLabel('checkout.errors.general.message') }));
        }
    };
    OrderDetail.getDerivedStateFromProps = function (props, state) {
        if (!state.selectedItems && props.detail) {
            return {
                selectedItems: new Set(props.detail.lineItems.map(function (item) {
                    return props.isLegacyOrderSupplierEanEnabled
                        ? item.product.attributes.supplierEAN
                        : item.product.sku;
                })),
            };
        }
        return null;
    };
    return OrderDetail;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$e = function (state) { return ({
    detailCall: getOrderDetailCall(state),
    detail: getOrderDetail(state),
    legacyDetailCall: getLegacyOrderDetailCall(state),
    legacyDetail: getLegacyOrderDetail(state),
}); };
var mapDispatchToProps$b = {
    fetchDetail: fetchDetail,
    fetchLegacyDetail: fetchLegacyDetail,
    reorder: reorder,
};
var OrderDetail$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$e, mapDispatchToProps$b)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withFeatureToggles */ "V"])(OrderDetail)));

var NoPrescription = function (_a) {
    var bookAppointmentRoute = _a.bookAppointmentRoute;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: "no-prescription" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null, getLabel('account.noPrescription.message')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: getLabel('stores.actions.selectStore'), href: "/" + bookAppointmentRoute })));
};

var PrescriptionInfoBar = function (_a) {
    var storeName = _a.storeName, expiryDate = _a.expiryDate, className = _a.className;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, locale = _b.locale;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('prescription-infobar', className) },
        storeName && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "prescription-infobar__store-name" }, storeName),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Label */ "h"], { type: "neutral", className: "prescription-infobar__label" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null,
                getLabel('account.prescription.expiryDate'),
                ": "),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DateTime */ "n"], { dateTime: expiryDate, locale: locale }))));
};

function getEyePrescriptionData(prescription, eye) {
    return Object.entries(prescription[eye]).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (value ? __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)) : acc);
    }, {
        power: '',
        baseCurve: '',
        diameter: '',
        cylinder: '',
        axis: '',
        addition: '',
    });
}

var PrescriptionKey;
(function (PrescriptionKey) {
    PrescriptionKey["Power"] = "power";
    PrescriptionKey["Axis"] = "axis";
    PrescriptionKey["Cylinder"] = "cylinder";
    PrescriptionKey["Addition"] = "addition";
    PrescriptionKey["BaseCurve"] = "baseCurve";
    PrescriptionKey["Diameter"] = "diameter";
})(PrescriptionKey || (PrescriptionKey = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get PrescriptionKey () { return PrescriptionKey; }
});

var EyeSide;
(function (EyeSide) {
    EyeSide["Right"] = "rightEye";
    EyeSide["Left"] = "leftEye";
})(EyeSide || (EyeSide = {}));
var EYE_SIDES = [EyeSide.Right, EyeSide.Left];
var dataOrDash = function (prescription, eye, key) {
    return prescription[eye][key] || '-';
};
var CLASS_PREFIX = 'prescription-table';
var TableMobile = function (_a) {
    var keys = _a.keys, prescription = _a.prescription, labelFormatter = _a.labelFormatter, className = _a.className, ariaLabel = _a["aria-label"];
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()(CLASS_PREFIX + " " + CLASS_PREFIX + "--mobile " + CLASS_PREFIX + "--cols-3", className);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("table", { className: classes, "aria-label": ariaLabel },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("thead", null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tr", null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("td", null, ''),
                EYE_SIDES.map(function (eyeSide) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("th", { key: "header-" + eyeSide, scope: "col" }, getLabel("products.contactLenses." + eyeSide))); }))),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tbody", null, keys.map(function (key) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tr", { key: key },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("th", { scope: "row" }, labelFormatter(key)),
            EYE_SIDES.map(function (eyeSide) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("td", { key: "cell-" + eyeSide + "-" + key }, dataOrDash(prescription, eyeSide, key))); }))); }))));
};
var TableDesktop = function (_a) {
    var keys = _a.keys, prescription = _a.prescription, labelFormatter = _a.labelFormatter, className = _a.className, ariaLabel = _a["aria-label"];
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()(CLASS_PREFIX + " " + CLASS_PREFIX + "--desktop " + CLASS_PREFIX + "--cols-" + (keys.length + 1), className);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("table", { className: classes, "aria-label": ariaLabel },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("thead", null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tr", null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("td", null, '' /* Add empty string for the top cell above the header column */),
                keys.map(function (label) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("th", { key: label, scope: "col" }, labelFormatter(label))); }))),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tbody", null, EYE_SIDES.map(function (eyeSide) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("tr", { key: "row-" + eyeSide },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("th", { scope: "row" }, getLabel("products.contactLenses." + eyeSide)),
            keys.map(function (key) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("td", { key: key }, dataOrDash(prescription, eyeSide, key))); }))); }))));
};
var PrescriptionTable = function (props) {
    var prescription = props.prescription;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var BreakpointName = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].BreakpointName, useBreakpoint = _grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* MediaQuery */ "P"].useBreakpoint;
    var breakpoint = useBreakpoint();
    var isMobile = breakpoint === BreakpointName.PHONE || breakpoint === BreakpointName.TABLET_PORTRAIT;
    var keys = [
        PrescriptionKey.Power,
        PrescriptionKey.BaseCurve,
        PrescriptionKey.Diameter,
        PrescriptionKey.Cylinder,
        PrescriptionKey.Axis,
        PrescriptionKey.Addition,
    ];
    var getAbbreviatedLabel = function (propertyName) {
        return getLabel("products.contactLenses.prescription." + propertyName + ".abbr");
    };
    var tableProps = {
        keys: keys,
        prescription: prescription,
        labelFormatter: getAbbreviatedLabel,
        className: props.className,
        'aria-label': props['aria-label'],
    };
    return isMobile ? Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(TableMobile, __assign({}, tableProps)) : Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(TableDesktop, __assign({}, tableProps));
};

var PrescriptionTableContainer = function (_a) {
    var _b;
    var prescription = _a.prescription, name = _a.name;
    var eyeData = (_b = {},
        _b[EyeSide.Right] = getEyePrescriptionData(prescription, EyeSide.Right),
        _b[EyeSide.Left] = getEyePrescriptionData(prescription, EyeSide.Left),
        _b);
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionTable, { prescription: eyeData, "aria-label": name });
};

var Prescription = function (_a) {
    var prescription = _a.prescription;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, dateTime = _b.dateTime;
    var name = prescription.name || prescription.storeName;
    var expiryDate = prescription.expiryDate, recommendedNextEyeTestDate = prescription.recommendedNextEyeTestDate;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        recommendedNextEyeTestDate &&
            isRecommendedEyeTestDue(recommendedNextEyeTestDate, expiryDate) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "info", message: getFormattedLabel('account.prescription.eyeTestDue', {
                labelData: {
                    date: dateTime.formatShortDate(new Date(expiryDate)),
                },
                parseLink: false,
            }), icon: "info" })),
        isPrescriptionExpired(expiryDate) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "warning", message: getLabel('account.prescription.prescriptionExpired'), icon: "warning" })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "h6" }, name),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionInfoBar, { storeName: prescription.storeName, expiryDate: prescription.expiryDate }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionTableContainer, { name: name, prescription: prescription }))));
};
function isRecommendedEyeTestDue(eyeTestDate, expiryDate, todayDate) {
    if (todayDate === void 0) { todayDate = new Date(); }
    if (!eyeTestDate) {
        return false;
    }
    var dateEyeTestDate = new Date(eyeTestDate);
    var dateExpiryDate = new Date(expiryDate);
    if (Object(date_fns__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(dateEyeTestDate, dateExpiryDate)) {
        return false;
    }
    return Object(date_fns__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(todayDate, { start: dateEyeTestDate, end: dateExpiryDate });
}
function isPrescriptionExpired(expiryDate, todayDate) {
    if (todayDate === void 0) { todayDate = new Date(); }
    return Object(date_fns__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(todayDate, new Date(expiryDate));
}

var getPrescriptions = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) { return (isLoggedIn(auth) ? auth.prescriptions : undefined); });
var getPrescriptionList = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getPrescriptions, function (prescriptions) {
    return prescriptions ? prescriptions.list : undefined;
});
var getPrescriptionListCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getPrescriptions, function (prescriptions) {
    return prescriptions ? prescriptions.listCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});

// TODO: In the future, the book appointment path should be a route key, instead of a hardcoded path
var BOOK_APPOINTMENT_ROUTE$1 = 'book-appointment';
var PrescriptionList = /** @class */ (function (_super) {
    __extends(PrescriptionList, _super);
    function PrescriptionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrescriptionList.prototype.componentDidMount = function () {
        this.props.fetchList();
    };
    PrescriptionList.prototype.render = function () {
        var _a = this.props, list = _a.list, listCall = _a.listCall, getLabel = _a.intl.getLabel, bookAppointmentRoute = _a.bookAppointmentRoute;
        var ROUTE_KEY = 'prescriptions';
        var routeLabel = getLabel("account.menu." + ROUTE_KEY);
        var LABEL_PREFIX = 'account.prescription';
        if (Array.isArray(list)) {
            return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "prescription-list" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h3 myaccount-page-title prescription-list__title" }, getLabel(LABEL_PREFIX + ".title")),
                list.length > 0 ? (list.map(function (item) { return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Prescription, { key: item.id, prescription: item }); })) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(NoPrescription, { bookAppointmentRoute: bookAppointmentRoute || BOOK_APPOINTMENT_ROUTE$1 }))));
        }
        else if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(listCall) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusIdle */ "E"])(listCall)) {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null);
        }
        else {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: getLabel('account.prescriptions.errors.general') });
        }
    };
    return PrescriptionList;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$f = function (state) { return ({
    listCall: getPrescriptionListCall(state),
    list: getPrescriptionList(state),
}); };
var mapDispatchToProps$c = {
    fetchList: fetchList$2,
};
var PrescriptionList$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$f, mapDispatchToProps$c)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(PrescriptionList));

var getPrivacy = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) { return (isLoggedIn(auth) ? auth.privacy : undefined); });
var getChangedOptIns = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getPrivacy, function (privacy) { return (privacy ? privacy.changedOptIns : {}); });
var getOptInsOnServer = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getPrivacy, function (privacy) {
    return privacy ? privacy.optInsOnServer : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
});
var getUpdateOptInsCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getPrivacy, function (privacy) {
    return privacy ? privacy.updateOptInsCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});

var Privacy = /** @class */ (function (_super) {
    __extends(Privacy, _super);
    function Privacy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOptInChange = function (selectedOptIns) {
            var optIns = _this.props.availableOptIns.reduce(function (selected, optIn) {
                var _a;
                return __assign(__assign({}, selected), (_a = {}, _a[optIn.value] = {
                    checked: selectedOptIns && selectedOptIns.some(function (o) { return o.value === optIn.value; }),
                    label: optIn.title || optIn.value,
                }, _a));
            }, {});
            _this.props.toggleOptIns(optIns);
        };
        _this.handleSave = function () {
            _this.props.updateOptIns();
        };
        return _this;
    }
    Privacy.prototype.componentDidMount = function () {
        this.props.fetchOptIns();
    };
    Privacy.prototype.render = function () {
        var _a = this.props, intl = _a.intl, availableOptIns = _a.availableOptIns, changedOptIns = _a.changedOptIns, optInsOnServer = _a.optInsOnServer, updateOptInsCall = _a.updateOptInsCall;
        var ROUTE_KEY = 'privacy';
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(optInsOnServer) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(optInsOnServer)) {
            return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null);
        }
        else if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(optInsOnServer) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusWarning */ "J"])(optInsOnServer)) {
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel('account.privacy.fetchOptins.errors.general') })));
        }
        else {
            return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: "privacy" },
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("h1", { className: "h3 myaccount-page-title" }, intl.getLabel('account.privacy.title')),
                Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(updateOptInsCall) && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
                    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel('account.privacy.updateOptins.errors.general') }))),
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* CheckboxList */ "k"], { items: availableOptIns, idPrefix: "__opt-in_", renderItem: function (item) { return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", { className: "privacy__opt-in-text" }, react_html_parser__WEBPACK_IMPORTED_MODULE_13___default()(item.title))); }, renderTrailingItem: function (item) {
                        return item.tooltip && (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tooltip */ "sb"], { message: item.tooltip, id: item.title, className: "privacy__opt-in-tooltip" }));
                    }, getItemIdentifier: function (item) { return item.value; }, selectedItems: Privacy.getSelectedItems(optInsOnServer, changedOptIns, availableOptIns), onChange: this.onOptInChange }),
                react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { size: "medium", className: "privacy__save-button", caption: intl.getLabel('account.action.save'), disabled: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(updateOptInsCall), "data-t": "save-consent", onClick: this.handleSave })));
        }
    };
    Privacy.getSelectedItems = function (server, client, availableOptIns) {
        var selectedKeys = [];
        if (Object.keys(client).length) {
            // Take selected values from form state when not empty
            selectedKeys = Object.keys(client).reduce(function (selected, optInName) {
                if (!client[optInName].checked) {
                    return selected;
                }
                return __spread(selected, [optInName]);
            }, []);
        }
        else {
            // Otherwise take selected values from server state
            selectedKeys = Object.entries(server.result.optinValues)
                .filter(function (_a) {
                var _b = __read(_a, 2), _ = _b[0], value = _b[1];
                return value;
            })
                .map(function (_a) {
                var _b = __read(_a, 1), name = _b[0];
                return name;
            });
        }
        return availableOptIns.filter(function (o) { return selectedKeys.includes(o.value); });
    };
    return Privacy;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$g = function (state) { return ({
    availableOptIns: getOptIns(state),
    changedOptIns: getChangedOptIns(state),
    optInsOnServer: getOptInsOnServer(state),
    updateOptInsCall: getUpdateOptInsCall(state),
}); };
var mapDispatchToProps$d = {
    fetchOptIns: fetchOptIns,
    updateOptIns: updateOptIns,
    toggleOptIns: toggleOptIns,
};
var Privacy$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$g, mapDispatchToProps$d)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(Privacy));

var getSubscriptions = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getAuth, function (auth) {
    return isLoggedIn(auth) ? auth.subscriptions : undefined;
});
var getSubscriptionDetail = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscription) {
    return subscription ? subscription.detail : undefined;
});
var getSubscriptionForm = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscription) { return subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionForm; });
var getSubscriptionDetailCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscription) {
    return subscription ? subscription.detailCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getPauseCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscription) {
    return subscription ? subscription.pauseCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getQuantityCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscription) {
    return subscription ? subscription.quantityCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getProductDataCall = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscription) {
    return subscription ? subscription.productDataCall : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])();
});
var getProductData = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscription) {
    return subscription ? subscription.productData : {};
});
var getSubscriptionList = Object(reselect__WEBPACK_IMPORTED_MODULE_5__[/* createSelector */ "a"])(getSubscriptions, function (subscriptions) {
    return subscriptions ? subscriptions.list : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])();
});

var TotalPrice = function (_a) {
    var label = _a.label, totalPrice = _a.totalPrice;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("b", null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null,
            label,
            " "),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "W"], { value: totalPrice.amount, currency: totalPrice.currency })));
};
var SubscriptionHeader = function (_a) {
    var expiryDate = _a.expiryDate, totalPrice = _a.totalPrice, className = _a.className, deliveryFrequency = _a.deliveryFrequency, disabled = _a.disabled, nextDelivery = _a.nextDelivery, status = _a.status;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, locale = _b.locale;
    var isExpired = status === 'EXPIRED';
    var deliveryFrequencyLabel = getDeliveryFrequencyLabel(deliveryFrequency, getLabel);
    var durationDefinition = isExpired
        ? // Duration is fixed for IE + UK, which is the scope for now
            "2 " + getLabel('common.duration.years') + " - " + getLabel("account.subscription.status.expired")
        : "2 " + getLabel('common.duration.years');
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('subscription-header subscription__summary', className, {
            'subscription-header--disabled': disabled,
        }) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader, { className: "subscription-header__info" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { term: getLabel('account.subscription.length') + ': ', definition: durationDefinition }),
            deliveryFrequency && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { term: getLabel('account.subscription.deliveryFrequency') + ': ', definition: deliveryFrequencyLabel })),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { term: getLabel('account.subscription.nextDelivery') + ': ', definition: nextDelivery ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DateTime */ "n"], { dateTime: new Date(nextDelivery.date), locale: locale })) : (getLabel('account.subscription.nextDelivery.unavailable')) }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { term: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(TotalPrice, { label: getLabel('common.total') + ': ', totalPrice: totalPrice }), definition: getLabel('common.frequency.perMonth') })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], { className: "subscription-header__horizontal-rule" }),
        !isExpired && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Label */ "h"], { type: "neutral" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
                getLabel("account.subscription.expiryDate") + ': ',
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DateTime */ "n"], { dateTime: expiryDate, locale: locale }))))));
};
function getDeliveryFrequencyLabel(label, getLabel) {
    if (!label) {
        return undefined;
    }
    switch (label) {
        case 'ANNUALLY':
            return getLabel('common.frequency.yearly');
        case 'BI_WEEKLY':
            return getLabel('common.frequency.biweekly');
        default:
            return getLabel("common.frequency." + label.toLowerCase());
    }
}

var getProductSubtitle$1 = function (product) {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    if (_grandvision_commercetools__WEBPACK_IMPORTED_MODULE_20__[/* CommerceToolsApi */ "a"].isLenses(product)) {
        var packageQuantity = product.packageQuantity, replacementFrequency = product.replacementFrequency;
        var frequencyLabelKey = intl.getLabel("common.frequency." + replacementFrequency.toLowerCase());
        // Todo: add eyeside in a later story
        return packageQuantity + " " + frequencyLabelKey + " " + intl.getLabel('products.unit.contactLenses') + " " + intl.getLabel('products.perBox');
    }
    else {
        return product.brandModel;
    }
};
var SubscriptionLineItem = function (_a) {
    var product = _a.product, getItemImageUrl = _a.getItemImageUrl, staticsUrl = _a.staticsUrl, quantity = _a.quantity, eyeSide = _a.eyeSide;
    var brand = product.brand, images = product.images;
    var subtitle = getProductSubtitle$1(product);
    var imagePath = getItemImageUrl
        ? getItemImageUrl(product)
        : "" + staticsUrl + images.primary.url + "?w=300&bg=FFFFFF&fm=jpeg";
    var eyeSideElement = eyeSide && eyeSide !== 'both' ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* EyeSideIndicator */ "r"], { className: "subscription-line-item__eyeside-indicator", side: eyeSide })) : null;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-line-item" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItem */ "D"], { className: "subscription-line-item__container" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemMedia */ "I"], { type: "image", imageUrl: imagePath, imageAlt: brand, overlayElement: eyeSideElement }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemContent */ "F"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemTitle, { title: brand }),
                subtitle && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemSubtitle, { subtitle: subtitle }),
                _grandvision_commercetools__WEBPACK_IMPORTED_MODULE_20__[/* CommerceToolsApi */ "a"].isLenses(product) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemPrescription, { prescriptionAttrs: product.lensProperties })),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemQuantity, { quantity: quantity })))));
};

var SubscriptionLineItemFailed = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SkeletonLoader */ "hb"], { animate: false, className: "subscription-line-item-failed" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "subscription-line-item-failed__image" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "100%", height: "100%", rx: "5", fill: "currentColor" })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "subscription-line-item-failed__text" }, getLabel('account.subscription.product.failed'))));
};

var SubscriptionLineItemLoader = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SkeletonLoader */ "hb"], null,
    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "30%", height: "100%", rx: "5", fill: "currentColor" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor", x: "35%" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor", x: "35%", y: "30" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("rect", { width: "25%", height: "15px", rx: "5", fill: "currentColor", x: "35%", y: "60" })))); };

var ChangeQuantityModal = function (_a) {
    var className = _a.className, onCancel = _a.onCancel, onEditQuantity = _a.onEditQuantity, maxQuantity = _a.maxQuantity, isLoading = _a.isLoading, errorMessage = _a.errorMessage, totalPricePerInstallment = _a.totalPricePerInstallment;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var quantityRange = Array.from({ length: maxQuantity }, function (_, i) { return i + 1; });
    var formattedQuantities = quantityRange.reduce(function (acc, quantity) {
        var _a;
        var quantityLabel = quantity === 1 ? intl.getLabel('products.box') : intl.getLabel('products.boxes');
        return __assign(__assign({}, acc), (_a = {}, _a[quantity + " " + quantityLabel] = quantity, _a));
    }, {});
    var initialOptionKey = Object.keys(formattedQuantities)[0];
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(formattedQuantities[initialOptionKey]), 2), quantity = _b[0], setQuantity = _b[1];
    var onSelectChange = function (quantity) {
        setQuantity(quantity);
    };
    var handleSubmit = function () {
        onEditQuantity(quantity);
    };
    var buttonCaption = isLoading
        ? intl.getLabel('common.loadingText')
        : intl.getLabel('account.action.changeQuantity');
    var footerButton = (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: buttonCaption, className: "edit-subscription__button", "data-t": "edit-subscription-modal-confirm", disabled: isLoading, onClick: handleSubmit }));
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { showIcon: true, isOpen: true, onModalClose: onCancel, title: intl.getLabel('account.editSubscription.title'), footer: footerButton, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('edit-subscription', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "info", icon: "information-circle", message: intl.getLabel('account.editSubscription.info') }),
        errorMessage && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", icon: "warning", message: errorMessage }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Select */ "A"], { id: "edit-quantity-select", name: "edit-quantity-select", className: "edit-subscription__select", options: formattedQuantities, initialState: { value: initialOptionKey }, onChange: onSelectChange, label: intl.getLabel('account.editSubscription.select.label') }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null,
            intl.getLabel('account.editSubscription.newPrice'),
            ' ',
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("b", null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "W"], { value: totalPricePerInstallment.amount * quantity, currency: totalPricePerInstallment.currency })))));
};

var PauseSubscriptionModal = function (_a) {
    var className = _a.className, pauseDurationOptions = _a.pauseDurationOptions, onCancel = _a.onCancel, onPause = _a.onPause, isLoading = _a.isLoading, errorMessage = _a.errorMessage;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])();
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(pauseDurationOptions[0]), 2), selection = _b[0], setSelection = _b[1];
    var formattedDurations = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () {
        return pauseDurationOptions.reduce(function (acc, option) {
            var _a;
            var durationLabelKey = option.amount === 1 ? option.unit.slice(0, -1) : option.unit;
            var durationLabel = option.amount + " " + intl.getLabel("common.duration." + durationLabelKey.toLowerCase());
            return __assign(__assign({}, acc), (_a = {}, _a[durationLabel] = option, _a));
        }, {});
    }, [pauseDurationOptions]);
    var onSelectChange = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function (duration) {
        setSelection(duration);
    }, []);
    var handlePause = Object(react__WEBPACK_IMPORTED_MODULE_1__["useCallback"])(function () {
        if (selection) {
            onPause(selection);
        }
    }, [selection]);
    var buttonCaption = isLoading
        ? intl.getLabel('common.loadingText')
        : intl.getLabel('account.pauseSubscription.actions.pause');
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { showIcon: true, isOpen: true, onModalClose: onCancel, "aria-label": intl.getLabel('account.pauseSubscription.title'), className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('pause-subscription', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "pause-subscription__title h4" }, intl.getLabel('account.pauseSubscription.title')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "pause-subscription__description" }, intl.getLabel('account.pauseSubscription.description')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "info", icon: "information-circle", message: intl.getLabel('account.pauseSubscription.info') }),
        errorMessage && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", icon: "warning", message: errorMessage }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Select */ "A"], { id: "pause-duration-select", name: "pause-duration-select", className: "pause-subscription__select", options: formattedDurations, onChange: onSelectChange, label: intl.getLabel('account.pauseSubscription.select.label') }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "pause-subscription__buttons" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: buttonCaption, className: "pause-subscription__button", "data-t": "pause-subscription-modal-confirm", onClick: handlePause, disabled: isLoading }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: intl.getLabel('common.actions.cancel'), className: "pause-subscription__button", "data-t": "pause-subscription-modal-cancel", onClick: onCancel, variant: "outline" }))));
};

var getEyeSide = function (application) {
    if (!application.length) {
        return {};
    }
    if (application.length > 2) {
        return {
            eyeSide: 'both',
        };
    }
    else if (application.includes('LEFT_EYE')) {
        return {
            eyeSide: 'left',
        };
    }
    else {
        return {
            eyeSide: 'right',
        };
    }
};
var CurrentPlan = /** @class */ (function (_super) {
    __extends(CurrentPlan, _super);
    function CurrentPlan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pauseButtonRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["createRef"])();
        _this.editButtonRef = Object(react__WEBPACK_IMPORTED_MODULE_1__["createRef"])();
        _this.state = {
            activeModal: undefined,
        };
        _this.handleTopUp = function () {
            var _a = _this.props, subscription = _a.subscription, intl = _a.intl;
            var lineItemDrafts = subscription.lineItems.map(function (item) { return ({
                sku: item.productId,
                quantity: item.quantity,
                custom: __assign({}, getEyeSide(item.application)),
            }); });
            if (_this.props.reorder) {
                _this.props.reorder({
                    drafts: {
                        lineItems: lineItemDrafts,
                    },
                    currency: intl.currency,
                    country: intl.country,
                    locale: intl.locale,
                });
            }
        };
        _this.openQuantityModal = function () {
            _this.setState({ activeModal: 'quantity' });
        };
        _this.openPauseModal = function () {
            _this.setState({ activeModal: 'pause' });
        };
        _this.focusModalTrigger = function (focusRef) {
            focusRef.current && focusRef.current.focus();
        };
        _this.closeModal = function () {
            var focusRef = _this.state.activeModal === 'pause' ? _this.pauseButtonRef : _this.editButtonRef;
            _this.setState({ activeModal: undefined });
            _this.focusModalTrigger(focusRef);
        };
        _this.handlePause = function (duration) {
            _this.props.pause(duration);
        };
        _this.handleEdit = function (quantity) {
            _this.props.quantity({ quantity: quantity });
        };
        return _this;
    }
    CurrentPlan.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Close modal if pause or quantity call went from loading to idle
        if ((Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prevProps.pauseCall) && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusIdle */ "E"])(this.props.pauseCall)) ||
            (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prevProps.quantityCall) && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusIdle */ "E"])(this.props.quantityCall))) {
            this.closeModal();
        }
        // Pause error
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prevProps.pauseCall) && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(this.props.pauseCall)) {
            this.setState({ pauseError: this.props.intl.getLabel('account.subscription.pause.error') });
        }
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(prevProps.pauseCall) && prevState.activeModal && !this.state.activeModal) {
            this.setState({ pauseError: undefined });
        }
        // Quantity error
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prevProps.quantityCall) && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(this.props.quantityCall)) {
            this.setState({
                quantityError: this.props.intl.getLabel('account.subscription.quantity.error'),
            });
        }
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(prevProps.quantityCall) && prevState.activeModal && !this.state.activeModal) {
            this.setState({ quantityError: undefined });
        }
    };
    CurrentPlan.prototype.render = function () {
        var _a = this.props, subscription = _a.subscription, className = _a.className, intl = _a.intl, productData = _a.productData, staticsUrl = _a.staticsUrl, reorderCall = _a.reorderCall, pauseCall = _a.pauseCall, quantityCall = _a.quantityCall, getItemImageUrl = _a.getItemImageUrl;
        var nextDelivery = subscription.deliveries.find(function (d) { return d.status !== 'DELIVERED'; });
        var price = subscription.billing.totalPricePerInstallment;
        var hasQuantityPending = subscription.pendingChanges.includes('quantity');
        var hasPausePending = subscription.pendingChanges.includes('pause');
        var isSubscriptionDisabled = ['EXPIRED', 'CANCELLED', 'ON_HOLD'].some(function (s) { return s === subscription.status; });
        var renderLineItem = function (lineItem) {
            var data = productData[lineItem.productId];
            var eyeSide = getEyeSide(lineItem.application).eyeSide;
            if (!data || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(data)) {
                return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionLineItemLoader, null);
            }
            if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(data)) {
                return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionLineItemFailed, null);
            }
            if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(data)) {
                return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionLineItem, { product: data.result, staticsUrl: staticsUrl, quantity: lineItem.quantity, getItemImageUrl: getItemImageUrl, eyeSide: eyeSide }));
            }
        };
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('current-plan', className) },
            renderStatusAlert(subscription.status, intl),
            renderPendingChangesAlert(subscription.pendingChanges, intl),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionHeader, { nextDelivery: nextDelivery, expiryDate: subscription.expiryDate, totalPrice: price, status: subscription.status, disabled: isSubscriptionDisabled, className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('current-plan__summary'), deliveryFrequency: subscription.deliveryFrequency }),
            Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(reorderCall) && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* ScrollIntoView */ "db"], null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: intl.getLabel('account.order.topup.errors.general') }))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryContainer */ "lb"], { className: "current-plan__summary" }, subscription.lineItems.map(function (lineItem, index) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], { key: lineItem.productId + "-" + index },
                !!index && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
                renderLineItem(lineItem))); })),
            subscription.topUpAllowed && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { "data-t": "top-up-description", className: "current-plan__topup-description" }, intl.getLabel('account.subscription.topUp.description', { hideLabelKey: true }))),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "current-plan__buttons" },
                subscription.topUpAllowed && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "top-up", className: "current-plan__button", caption: intl.getLabel('account.subscription.action.topUp'), onClick: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(reorderCall) ? undefined : this.handleTopUp, disabled: isSubscriptionDisabled })),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "edit-subscription", btnRef: this.editButtonRef, className: "current-plan__button", caption: intl.getLabel('account.subscription.action.edit'), onClick: this.openQuantityModal, variant: "outline", disabled: !subscription.quantityChangeable || hasQuantityPending || isSubscriptionDisabled })),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
            subscription.pauseOptions.length === 0 && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "info", message: intl.getLabel('account.subscription.pause.noBudget') })),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { "data-t": "pause-subscription", className: "current-plan__pause-button", caption: intl.getLabel('account.subscription.action.pause'), onClick: this.openPauseModal, btnRef: this.pauseButtonRef, variant: "outline", disabled: subscription.pauseOptions.length === 0 || hasPausePending || isSubscriptionDisabled }),
            this.state.activeModal === 'pause' && subscription.pauseOptions.length > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PauseSubscriptionModal, { onCancel: this.closeModal, pauseDurationOptions: subscription.pauseOptions, onPause: this.handlePause, isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(pauseCall), errorMessage: this.state.pauseError })),
            this.state.activeModal === 'quantity' && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(ChangeQuantityModal, { onCancel: this.closeModal, maxQuantity: 3, onEditQuantity: this.handleEdit, isLoading: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(quantityCall), errorMessage: this.state.quantityError, totalPricePerInstallment: subscription.billing.totalPricePerInstallment }))));
    };
    return CurrentPlan;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$h = function (state) { return ({
    reorderCall: getReorderCall(state),
    pauseCall: getPauseCall(state),
    productData: getProductData(state),
    productDataCall: getProductDataCall(state),
    quantityCall: getQuantityCall(state),
}); };
var mapDispatchToProps$e = {
    reorder: reorder,
    pause: pause,
    quantity: quantity,
};
var CurrentPlan$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$h, mapDispatchToProps$e)(Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(CurrentPlan));
function renderPendingChangesAlert(pendingChanges, intl) {
    if (pendingChanges.length < 1) {
        return;
    }
    if (pendingChanges.length > 1) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { key: "multiple", type: "info", message: intl.getLabel("account.subscription.pauseAndQuantity.processing") }));
    }
    var type = pendingChanges[0];
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { key: type, type: "info", message: intl.getLabel("account.subscription." + type + ".processing") }));
}
function renderStatusAlert(status, intl) {
    var message;
    switch (status) {
        case 'CANCELLED':
        case 'EXPIRED':
        case 'PAUSED':
            message = intl.getLabel("account.subscription." + status.toLowerCase());
            break;
        case 'ON_HOLD':
            message = intl.getLabel("account.subscription.onHold");
            break;
    }
    return message && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: message });
}

var DeliveryAddressesSummary = function (_a) {
    var addressSummary = _a.addressSummary, handleEditClick = _a.handleEditClick, isSubscriptionHasOneAddressEnabled = _a.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _a.isSubscriptionUpdateAddressEnabled, subscription = _a.subscription;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var deliveryAddress = subscription.deliveryAddress, billingAddress = subscription.billingAddress;
    var addressLabel = isSubscriptionHasOneAddressEnabled
        ? getLabel('account.billingAndDeliveryAddress')
        : getLabel('account.deliveryAddress');
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([
            'subscription-deliveries__addresses-summary',
            {
                'subscription-deliveries__addresses-summary--two-addresses': !isSubscriptionHasOneAddressEnabled,
            },
        ]), onEditClick: isSubscriptionHasOneAddressEnabled && isSubscriptionUpdateAddressEnabled
            ? handleEditClick
            : undefined },
        addressSummary({ data: deliveryAddress }, addressLabel),
        !isSubscriptionHasOneAddressEnabled &&
            (billingAddress ? (addressSummary({ data: billingAddress }, getLabel('account.billingAddress'))) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Heading */ "f"], { component: "span", variant: "subheading2" }, getLabel('account.billingAddress')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", null, getLabel('account.sameAddress')))))));
};

var DeliveryAddressForm = function (_a) {
    var billingAddressForm = _a.billingAddressForm, subscriptionForm = _a.subscriptionForm, onChange = _a.onChange, onSave = _a.onSave, onCancel = _a.onCancel;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var isLoading = (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.saveFormCall.status) === 'loading';
    var isError = (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.saveFormCall.status) === 'failed';
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Form */ "j"], { name: "billingAddress", "data-t": "billingAddress", className: "subscription-deliveries__form", initialFormState: subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.state, onChange: function (_a) {
            var formState = _a.formState;
            onChange(formState);
        }, onSubmit: function (_a) {
            var formState = _a.formState;
            onSave(formState);
        } },
        isError && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", message: getLabel('account.subscription.detail.saveFailed') })),
        billingAddressForm,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "subscription-deliveries__note" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("strong", null,
                getLabel('account.common.pleaseNote'),
                ":"),
            ' ',
            getLabel('account.subscription.detail.note')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-deliveries__button-block" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: getLabel('account.action.save'), className: "subscription-deliveries__button", isLoading: isLoading, type: "submit", "data-t": "save-delivery-address" }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: getLabel('common.actions.cancel'), className: "subscription-deliveries__button", onClick: onCancel, variant: "outline" }))));
};

var InfoModal = function (_a) {
    var isOpen = _a.isOpen, onModalClose = _a.onModalClose, title = _a.title, message = _a.message, okLabel = _a.okLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "Q"], { isOpen: isOpen, onModalClose: onModalClose, title: title, showIcon: true, footer: Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { caption: okLabel, onClick: onModalClose })) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { style: { margin: '1rem 0' } }, message)));
};

var Delivery = function (_a) {
    var addressSummary = _a.addressSummary, billingAddressForm = _a.billingAddressForm, subscriptionForm = _a.subscriptionForm, isSubscriptionHasOneAddressEnabled = _a.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _a.isSubscriptionUpdateAddressEnabled, subscription = _a.subscription, onChange = _a.onChange, onCancel = _a.onCancel, onSave = _a.onSave, onEditModeChange = _a.onEditModeChange, onModalClose = _a.onModalClose;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, locale = _b.locale;
    var sortedDeliveries = subscription.deliveries.sort(function (l, r) {
        return r.date.localeCompare(l.date, 'en', { numeric: true, usage: 'sort' });
    });
    var getRow = function (rowIndex) { return sortedDeliveries[rowIndex]; };
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-deliveries" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "h4" }, getLabel('account.subscription.detail.deliveryDetails')),
        (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.isInEditMode) ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DeliveryAddressForm, { billingAddressForm: billingAddressForm, onChange: onChange, onSave: onSave, onCancel: onCancel, subscriptionForm: subscriptionForm })) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DeliveryAddressesSummary, { addressSummary: addressSummary, subscription: subscription, isSubscriptionHasOneAddressEnabled: isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled: isSubscriptionUpdateAddressEnabled, handleEditClick: function () {
                onEditModeChange(true);
            } })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"], { "aria-level": 2, caption: getLabel('account.subscription.detail.deliveryHistory'), numberOfRows: sortedDeliveries.length },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "date", header: getLabel('common.date') }, function (rowIndex) { return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DateTime */ "n"], { locale: locale, dateTime: getRow(rowIndex).date }); }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "id", header: getLabel('account.subscription.detail.deliveryHistory.orderNumber') }, function (rowIndex) { return getRow(rowIndex).reference || getLabel('common.notAvailable'); }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "boxes_per_eye_side", header: getLabel('account.subscription.detail.deliveryHistory.boxesPerEyeSide') }, function (rowIndex) { return getRow(rowIndex).boxesPerEyeSide || getLabel('common.notAvailable'); }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "status", header: getLabel('account.subscription.detail.delivery.status') }, function (rowIndex) {
                return getLabel("account.subscription.detail.delivery.status." + getRow(rowIndex).status.toLowerCase());
            })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(InfoModal, { isOpen: !!(subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.isModalOpen), onModalClose: onModalClose, title: getLabel('account.subscription.detail.infoModal.title'), message: getLabel('account.subscription.detail.infoModal.message'), okLabel: getLabel('common.actions.ok') })));
};

/*
 * We can assume that `installments` is already sorted in the backend by date from old to new
 * i.e. [yesterday, today, tomorrow]

 * Reverse the new array so that it's sorted from new to old (i.e. [tomorrow, today, yesterday],
 * rendering from top to bottom).
 */
var prepareInstallmentsList = function (list) {
    return list.sort(function (a, b) { return b.date.localeCompare(a.date, 'en', { usage: 'sort', numeric: true }); });
};
var Payments = function (_a) {
    var className = _a.className, subscription = _a.subscription, paymentDetailsSummary = _a.paymentDetailsSummary;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, locale = _b.locale;
    var installments = subscription.installments;
    var LABEL_PREFIX = 'account.subscription.detail.paymentOverview';
    var reversedInstallements = prepareInstallmentsList(installments);
    var getRow = function (rowIndex) { return reversedInstallements[rowIndex]; };
    if (reversedInstallements.length > 0) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('subscription-payments', className) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "h4" }, getLabel('account.subscription.paymentDetails')),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Summary */ "kb"], { className: "subscription-payments__payment-details" }, paymentDetailsSummary({
                getLabel: getLabel,
                data: subscription.paymentMethod,
            })),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"], { "aria-level": 2, caption: getLabel(LABEL_PREFIX + ".title"), numberOfRows: reversedInstallements.length },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "date", header: getLabel('common.date') }, function (rowIndex) { return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DateTime */ "n"], { locale: locale, dateTime: getRow(rowIndex).date }); }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "provider", header: getLabel('common.payment.provider') }, function (rowIndex) {
                    var paymentMethodKey = getRow(rowIndex)
                        .paymentMethod.toLowerCase()
                        .replace(' ', '');
                    return getLabel("common.payment.method." + paymentMethodKey);
                }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "amount", header: getLabel('common.amount') }, function (rowIndex) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Price */ "W"], { value: getRow(rowIndex).totalPrice.amount, currency: getRow(rowIndex).totalPrice.currency })); }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* DataTable */ "m"].Col, { id: "status", header: getLabel('common.status') }, function (rowIndex) {
                    var status = getRow(rowIndex).status.toLowerCase();
                    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("span", { className: "status--" + status }, getLabel("common.status." + status)));
                }))));
    }
    else {
        console.error("Payment installments expected for Subscription ID:" + subscription.id + " but none were found.");
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: LABEL_PREFIX + ".error" })));
    }
};

var SubscriptionDetail = /** @class */ (function (_super) {
    __extends(SubscriptionDetail, _super);
    function SubscriptionDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeTabIndex: 0,
        };
        _this.setIndex = function (index) { return _this.setState({ activeTabIndex: index }); };
        return _this;
    }
    SubscriptionDetail.prototype.componentDidMount = function () {
        var _a = this.props, subscriptionId = _a.subscriptionId, fetchDetail = _a.fetchDetail;
        fetchDetail({ subscriptionId: subscriptionId });
    };
    SubscriptionDetail.prototype.render = function () {
        var _a = this.props, addressSummary = _a.addressSummary, billingAddressForm = _a.billingAddressForm, detail = _a.detail, detailCall = _a.detailCall, getLabel = _a.intl.getLabel, subscriptionForm = _a.subscriptionForm, isSubscriptionHasOneAddressEnabled = _a.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _a.isSubscriptionUpdateAddressEnabled, paymentDetailsSummary = _a.paymentDetailsSummary, staticsUrl = _a.staticsUrl, subscriptionId = _a.subscriptionId, updateSubscriptionAddress = _a.updateSubscriptionAddress, saveSubscriptionAddress = _a.saveSubscriptionAddress, resetSubscriptionAddress = _a.resetSubscriptionAddress, setSubscriptionFormIsEditMode = _a.setSubscriptionFormIsEditMode, setSubscriptionFormIsModalOpen = _a.setSubscriptionFormIsModalOpen;
        var activeTabIndex = this.state.activeTabIndex;
        var ROUTE_KEY = 'subscriptions';
        var routeLabel = getLabel("account.menu." + ROUTE_KEY);
        var LABEL_PREFIX = 'account.subscription.details';
        if (detail && detail.id === subscriptionId) {
            return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-details" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h3 myaccount-page-title subscription-details__title" }, getLabel(LABEL_PREFIX + ".title")),
                detail.custom && detail.custom.membershipId && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "subscription-details__membership-id" }, getLabel(LABEL_PREFIX + ".membership.id") + ": " + detail.custom.membershipId)),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-details__tabs" },
                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tabs */ "qb"], { onChange: this.setIndex, activeTabIndex: activeTabIndex },
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: getLabel(LABEL_PREFIX + ".tabs.currentPlan") }),
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: getLabel(LABEL_PREFIX + ".tabs.deliveryDetails") }),
                        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: getLabel(LABEL_PREFIX + ".tabs.paymentDetails") }))),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-details__body" },
                    activeTabIndex === 0 && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(CurrentPlan$1, { subscription: detail, staticsUrl: staticsUrl, className: "subscription-details__tab" })),
                    activeTabIndex === 1 && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Delivery, { addressSummary: addressSummary, billingAddressForm: billingAddressForm, subscriptionForm: subscriptionForm, onChange: updateSubscriptionAddress, onCancel: resetSubscriptionAddress, onSave: saveSubscriptionAddress, onEditModeChange: setSubscriptionFormIsEditMode, onModalClose: function () {
                            setSubscriptionFormIsModalOpen(false);
                        }, isSubscriptionHasOneAddressEnabled: isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled: isSubscriptionUpdateAddressEnabled, subscription: detail })),
                    activeTabIndex === 2 && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Payments, { subscription: detail, paymentDetailsSummary: paymentDetailsSummary, className: "subscription-payments__tab" })))));
        }
        else if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(detailCall)) {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null);
        }
        else {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: getLabel('account.subscriptions.errors.general') });
        }
    };
    return SubscriptionDetail;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var WrappedWithIntl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(SubscriptionDetail);
var mapStateToProps$i = function (state) { return ({
    detailCall: getSubscriptionDetailCall(state),
    detail: getSubscriptionDetail(state),
    subscriptionForm: getSubscriptionForm(state),
}); };
var mapDispatchToProps$f = {
    fetchDetail: fetchDetail$1,
    updateSubscriptionAddress: updateSubscriptionAddress,
    saveSubscriptionAddress: saveSubscriptionAddress,
    resetSubscriptionAddress: resetSubscriptionAddress,
    setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode,
    setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen,
};
var SubscriptionDetail$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$i, mapDispatchToProps$f)(WrappedWithIntl);

var PrescriptionDetails = function (_a) {
    var className = _a.className, labels = _a.labels, prescription = _a.prescription;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('prescription-details', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Heading */ "f"], { variant: "smallest" }, labels.title),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionTable, { prescription: prescription })));
};

var Side;
(function (Side) {
    Side["Right"] = "rightLens";
    Side["Left"] = "leftLens";
})(Side || (Side = {}));
var toTablePrescription = function (prescription) {
    var format = function (key, value) {
        if (value === 0)
            return '';
        switch (key) {
            case PrescriptionKey.Axis:
                return value + "\u00B0";
            case PrescriptionKey.Addition:
            case PrescriptionKey.Power:
                return "" + (value > 0 ? '+' : '') + value;
            default:
                return "" + value;
        }
    };
    var formatKeys = function (lens) {
        var _a;
        return Object.keys(lens).reduce(function (acc, key) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[key] = format(key, lens[key]), _a)));
        }, (_a = {},
            _a[PrescriptionKey.Power] = '',
            _a[PrescriptionKey.Axis] = '',
            _a[PrescriptionKey.Cylinder] = '',
            _a[PrescriptionKey.Addition] = '',
            _a[PrescriptionKey.BaseCurve] = '',
            _a[PrescriptionKey.Diameter] = '',
            _a));
    };
    return {
        rightEye: formatKeys(prescription[Side.Right]),
        leftEye: formatKeys(prescription[Side.Left]),
    };
};
var PrescriptionDetailsContainer = function (_a) {
    var className = _a.className, prescription = _a.prescription;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () { return ({
        title: getLabel('account.subscription.details.currentPlan.prescription'),
    }); }, [getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionDetails, { className: className, labels: labels, prescription: toTablePrescription(prescription) }));
};

var SubscriptionHeader$1 = function (_a) {
    var className = _a.className, items = _a.items;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader, { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('subscription-header', className) }, items.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(DetailHeader.Item, { key: item.term, term: item.term, definition: item.definition })); })));
};

var SubscriptionLineItem$1 = function (_a) {
    var className = _a.className, name = _a.name, imagePath = _a.imagePath, eyeSide = _a.eyeSide, properties = _a.properties;
    var eyeSideElement = eyeSide && eyeSide !== 'both' ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* EyeSideIndicator */ "r"], { className: "subscription-line-item__eyeside-indicator", side: eyeSide })) : null;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItem */ "D"], { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('subscription-line-item', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemMedia */ "I"], { type: "image", imageUrl: imagePath, imageAlt: name, overlayElement: eyeSideElement }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* LineItemContent */ "F"], { className: "subscription-line-item__content" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemTitle, { title: name }), properties === null || properties === void 0 ? void 0 :
            properties.map(function (property, index) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(LineItemSubtitle, { key: index, subtitle: property })); }))));
};

var SubscriptionLineItemContainer = function () {
    var lineItem = {
        name: 'Product Name',
        imagePath: 'https://static-grandvision.imgix.net/io-whitelabel/iwear_fresh_30_front.jpg?w=300&bg=FFFFFF&fm=jpeg',
        eyeSide: 'left',
        properties: ['Monthly lenses', '2 boxes, 3 lenses per box, per eye'],
    };
    return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionLineItem$1, __assign({}, lineItem));
};

var CurrentPlan$2 = function (_a) {
    var className = _a.className, headerItems = _a.headerItems, prescription = _a.prescription, products = _a.products;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* SummaryContainer */ "lb"], { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('current-plan', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionHeader$1, { items: headerItems }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionDetailsContainer, { prescription: prescription }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
        products.map(function (product, index) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], { key: index },
            index > 0 && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionLineItemContainer, null))); })));
};

var LABEL_PREFIX = 'account.subscription.details.currentPlan';
var CurrentPlanContainer = function (_a) {
    var className = _a.className;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var headerItems = [
        {
            term: getLabel(LABEL_PREFIX + ".term.payment"),
            definition: '€ 14,99 per month',
        },
        {
            term: getLabel(LABEL_PREFIX + ".term.status"),
            definition: getLabel(LABEL_PREFIX + ".definition.status.ongoing"),
        },
        {
            term: getLabel(LABEL_PREFIX + ".term.deliveryFrequency"),
            definition: getLabel(LABEL_PREFIX + ".definition.deliveryFrequency.monthly"),
        },
    ];
    var prescription = {
        leftLens: {
            power: 9.0,
            axis: 10,
            cylinder: 0.75,
            addition: 1,
            pupillaryDistance: 61.7,
            baseCurve: 8.5,
            diameter: 14.3,
        },
        rightLens: {
            power: 8.0,
            axis: 11,
            cylinder: 0.73,
            addition: 0,
            pupillaryDistance: 64.0,
            baseCurve: 8.2,
            diameter: 13.85,
        },
    };
    var products = [{}, {}];
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(CurrentPlan$2, { className: className, headerItems: headerItems, prescription: prescription, products: products }));
};

var SubscriptionDetail$2 = function (_a) {
    var className = _a.className, tabLabels = _a.tabLabels;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('subscription-details__tabs', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tabs */ "qb"], { activeTabIndex: 0 },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: tabLabels.currentPlan }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: tabLabels.deliveryDetails }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Tab */ "pb"], { label: tabLabels.paymentDetails })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-details__body" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(CurrentPlanContainer, { className: "subscription-details__tab" }))));
};

var ROUTE_KEY = 'subscriptions';
var LABEL_PREFIX$1 = 'account.subscription.details';
var SubscriptionDetailContainer = function (_a) {
    var className = _a.className;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])().getLabel;
    var routeLabel = getLabel("account.menu." + ROUTE_KEY);
    var tabLabels = {
        currentPlan: getLabel(LABEL_PREFIX$1 + ".tabs.currentPlan"),
        deliveryDetails: getLabel(LABEL_PREFIX$1 + ".tabs.deliveryDetails"),
        paymentDetails: getLabel(LABEL_PREFIX$1 + ".tabs.paymentDetails"),
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('subscription-details', className) },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h3 myaccount-page-title subscription-details__title" }, getLabel(LABEL_PREFIX$1 + ".title")),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionDetail$2, { tabLabels: tabLabels })));
};

var BenefitsList = function (_a) {
    var items = _a.items, className = _a.className;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("ul", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('benefits-list', className) }, items.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("li", { className: "benefits-list__item", key: item.title },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { name: item.iconName, className: "benefits-list__icon" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "benefits-list__title" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("strong", null, item.title)),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "benefits-list__subtitle" }, item.subtitle))); })));
};

/*
 * This is hardcoded content for VisionExpress UK and IE.
 * In the future, this content should come from Bloomreach instead.
 */
var hardCodedUspList = [
    'Free solutions for monthly lenses',
    'Manage your subscription online',
    'Free trials of the latest products',
    'Free replacement lenses',
];
var hardCodedBenefitsList = [
    {
        iconName: 'eye-test',
        title: 'Free annual eye test',
        subtitle: 'Including free retinal photography',
    },
    {
        iconName: 'discount-bubble',
        title: '50% off',
        subtitle: 'Glasses and prescription and non-prescription sunglasses',
    },
    {
        iconName: 'truck',
        title: 'Free home delivery',
        subtitle: "Never be left out of your lenses, we'll deliver them to your door",
    },
    {
        iconName: 'business',
        title: 'Free service',
        subtitle: 'Free expert aftercare service',
    },
];
var NoSubscriptions = function () {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _a.getLabel, hasLabel = _a.hasLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "no-subscriptions" },
        hasLabel('account.noSubscriptions.help') && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "no-subscriptions__help" }, react_html_parser__WEBPACK_IMPORTED_MODULE_13___default()(getLabel('account.noSubscriptions.help')))),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "no-subscriptions__description" }, getLabel('account.noSubscriptions.description')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "h4" }, getLabel('account.noSubscriptions.benefits.title')),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(BenefitsList, { className: "no-subscriptions__benefits-list", items: hardCodedBenefitsList })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* List */ "K"], { className: "no-subscriptions__checkmark-list", type: "checkmark", items: hardCodedUspList }))));
};

var SubscriptionList = /** @class */ (function (_super) {
    __extends(SubscriptionList, _super);
    function SubscriptionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriptionList.prototype.componentDidMount = function () {
        this.props.fetchList();
    };
    SubscriptionList.prototype.componentDidUpdate = function (prevProps) {
        var prevList = prevProps.list;
        var _a = this.props, goto = _a.goto, list = _a.list, routes = _a.routes;
        var route = !!routes && !!routes.subscriptions ? routes.subscriptions : 'subscriptions';
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(prevList) && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(list) && !!list.result.length) {
            goto({ path: route + "/" + list.result[0].id });
        }
    };
    SubscriptionList.prototype.render = function () {
        var _a = this.props, intl = _a.intl, list = _a.list;
        var ROUTE_KEY = 'subscriptions';
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(list) || Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(list)) {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null);
        }
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(list)) {
            var subscriptionsList = list.result;
            return !!subscriptionsList.length ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null)) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "subscription-list" },
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h3 myaccount-page-title subscription-list__title" }, intl.getLabel('account.subscription.list.title')),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(NoSubscriptions, null)));
        }
        else {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: intl.getLabel('account.subscriptions.errors.general') });
        }
    };
    return SubscriptionList;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var WrappedWithIntl$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* withIntl */ "W"])(SubscriptionList);
var mapStateToProps$j = function (state) { return ({
    list: getSubscriptionList(state),
    routes: getFormattedRoutes(state),
}); };
var mapDispatchToProps$g = {
    fetchList: fetchList$3,
    goto: goto,
};
var SubscriptionList$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$j, mapDispatchToProps$g)(WrappedWithIntl$1);

var BenefitsList$1 = function (_a) {
    var items = _a.items, className = _a.className;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("ul", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('benefits-list', className) }, items.map(function (item) { return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("li", { className: "benefits-list__item", key: item.title },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "b"], { width: 40, height: 40, name: item.iconName, className: "benefits-list__icon" }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "benefits-list__title" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("strong", null, item.title)),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "benefits-list__subtitle" }, item.subtitle))); })));
};

var NoSubscriptions$1 = function (_a) {
    var subscriptionContactLensProductsUrl = _a.subscriptionContactLensProductsUrl, _b = _a.benefitsList, benefitsList = _b === void 0 ? [] : _b, items = _a.items, labels = _a.labels, showHelp = _a.showHelp;
    var title = labels.title, help = labels.help, description = labels.description, button = labels.button;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountBreadcrumbs$1, { items: items }),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h3 myaccount-page-title subscription-list__title" }, title),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "no-subscriptions" },
            showHelp && Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "no-subscriptions__help" }, help),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", { className: "no-subscriptions__description" }, description),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "no-subscriptions__action-button", variant: "solid", color: "primary", caption: button, href: subscriptionContactLensProductsUrl }),
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("section", null,
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(BenefitsList$1, { className: "no-subscriptions__benefits-list", items: benefitsList }),
                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_14__[/* Hr */ "g"], null)))));
};

var SubscriptionListContainer = function (_a) {
    var subscriptionContactLensProductsUrl = _a.subscriptionContactLensProductsUrl, benefitsList = _a.benefitsList;
    var _b;
    var _c = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _c.getLabel, hasLabel = _c.hasLabel;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var fetchList = react__WEBPACK_IMPORTED_MODULE_1___default.a.useCallback(function () { return dispatch(fetchList$3()); }, [dispatch]);
    var list = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getSubscriptionList);
    var routes = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getFormattedRoutes);
    var route = !!routes && routes.subscriptions ? routes.subscriptions : 'subscriptions';
    var routeLabel = getLabel("account.menu.subscriptions");
    var items = [{ name: routeLabel }];
    var labels = {
        title: getLabel('account.subscription.list.title'),
        help: react_html_parser__WEBPACK_IMPORTED_MODULE_13___default()(getLabel('account.noSubscriptions.help')),
        description: getLabel('account.noSubscriptions.description'),
        button: getLabel('account.subscription.action.noSubscriptions'),
    };
    react__WEBPACK_IMPORTED_MODULE_1___default.a.useEffect(function () {
        if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusUninit */ "I"])(list) && !Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(list)) {
            fetchList();
        }
    }, [list, fetchList]);
    // @TODO see if we can take care of this outside of the component, to prevent
    // forcing a reload
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(list) && !!((_b = list === null || list === void 0 ? void 0 : list.result) === null || _b === void 0 ? void 0 : _b.length)) {
        dispatch(goto({ path: route + "/" + list.result[0].id }));
        return null;
    }
    if (Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(list)) {
        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", title: getLabel('account.subscriptions.errors.general') });
    }
    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusLoading */ "F"])(list) ? (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null)) : (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(NoSubscriptions$1, { items: items, labels: labels, subscriptionContactLensProductsUrl: subscriptionContactLensProductsUrl, benefitsList: benefitsList, showHelp: hasLabel('account.noSubscriptions.help') }));
};

var UnlinkView = function (_a) {
    var viewType = _a.viewType, unlinkedItemId = _a.unlinkedItemId, unlinkType = _a.unlinkType;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var titleLabel = viewType === 'success' ? "account." + unlinkType + ".success.title" : "account." + unlinkType + ".title";
    if (!viewType) {
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null);
    }
    else {
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "unlink-view", "data-t": "unlink-view" },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h1", { className: "h3 myaccount-page-title unlink-view__title" }, getLabel(titleLabel)),
            viewType === 'success' && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null, getFormattedLabel("account." + unlinkType + ".success.message", {
                labelData: { unlinkedItemId: unlinkedItemId },
                parseLink: true,
            }))),
            viewType === 'failed' && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Alert */ "c"], { type: "error", icon: "alert-circle", title: getLabel("account." + unlinkType + ".error.title"), message: getFormattedLabel("account." + unlinkType + ".error.message", {
                    labelData: { unlinkedItemId: unlinkedItemId },
                }) }))));
    }
};

var UnlinkAppointmentContainer = function (_a) {
    var isSuccessPage = _a.isSuccessPage, _b = _a.appointmentId, appointmentId = _b === void 0 ? '' : _b, appointmentToken = _a.appointmentToken;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var unlinkAppointmentCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getUnlinkAppointmentCall);
    var viewType = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () {
        if (isSuccessPage) {
            return 'success';
        }
        else {
            return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(unlinkAppointmentCall) ? 'failed' : undefined;
        }
    }, [isSuccessPage, unlinkAppointmentCall]);
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
        if (!isSuccessPage) {
            if (appointmentToken) {
                dispatch(unlinkAppointment({ appointmentToken: appointmentToken, appointmentId: appointmentId }));
            }
            else {
                dispatch(unlinkAppointmentFailed(new Error('Cannot unlink an appointment without an appointmentToken')));
            }
        }
    }, [isSuccessPage, appointmentToken, unlinkAppointment]);
    return (react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(UnlinkView, { viewType: viewType, unlinkedItemId: appointmentId, unlinkType: "unlinkAppointment" }));
};
var UnlinkAppointmentContainer$1 = react__WEBPACK_IMPORTED_MODULE_1___default.a.memo(UnlinkAppointmentContainer);

var UnlinkOrderContainer = function (_a) {
    var isSuccessPage = _a.isSuccessPage, _b = _a.orderNumber, orderNumber = _b === void 0 ? '' : _b, orderToken = _a.orderToken;
    var dispatch = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useDispatch */ "O"])();
    var unlinkOrderCall = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useSelector */ "R"])(getUnlinkOrderCall);
    var viewType = Object(react__WEBPACK_IMPORTED_MODULE_1__["useMemo"])(function () {
        if (isSuccessPage) {
            return 'success';
        }
        else {
            return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusFailed */ "D"])(unlinkOrderCall) ? 'failed' : undefined;
        }
    }, [isSuccessPage, unlinkOrderCall]);
    Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
        if (!isSuccessPage) {
            if (orderToken) {
                dispatch(unlinkOrder({ orderToken: orderToken, orderNumber: orderNumber }));
            }
            else {
                dispatch(unlinkOrderFailed(new Error('Cannot unlink an order without an orderToken')));
            }
        }
    }, [isSuccessPage, orderToken, unlinkOrder]);
    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(UnlinkView, { viewType: viewType, unlinkedItemId: orderNumber, unlinkType: "unlinkOrder" });
};
var UnlinkOrderContainer$1 = react__WEBPACK_IMPORTED_MODULE_1___default.a.memo(UnlinkOrderContainer);

var MyAccountRoot = /** @class */ (function (_super) {
    __extends(MyAccountRoot, _super);
    function MyAccountRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            reverseRouteLookup: {},
            currentRoute: _this.props.initialRoute.replace(/\/$/, ''),
        };
        _this.onNavigate = function (location) {
            var _a = __read(location.pathname.match('([^/]+)/?$'), 1), newRoute = _a[0];
            if (!newRoute || !_this.state.reverseRouteLookup) {
                return;
            }
            if (newRoute in _this.state.reverseRouteLookup) {
                _this.setState({ currentRoute: newRoute });
            }
        };
        return _this;
    }
    MyAccountRoot.getDerivedStateFromProps = function (props) {
        return {
            reverseRouteLookup: props.routes
                ? Object.entries(props.routes).reduce(function (reverse, _a) {
                    var _b;
                    var _c = __read(_a, 2), name = _c[0], route = _c[1];
                    return (__assign(__assign({}, reverse), (_b = {}, _b[route.toLowerCase()] = name, _b)));
                }, {})
                : {},
        };
    };
    MyAccountRoot.prototype.componentDidMount = function () {
        this.unregisterHistory = history().listen(this.onNavigate);
    };
    MyAccountRoot.prototype.render = function () {
        var _a, _b;
        var _c = this.props, authState = _c.authState, locale = _c.locale, country = _c.country, formattedRoutes = _c.formattedRoutes, staticsUrl = _c.staticsUrl, benefitsList = _c.benefitsList, subscriptionContactLensProductsUrl = _c.subscriptionContactLensProductsUrl, getOrderLineItemImageUrl = _c.getOrderLineItemImageUrl, _d = _c.isAddressBookEnabled, isAddressBookEnabled = _d === void 0 ? false : _d, _e = _c.isSubscriptionsV2Enabled, isSubscriptionsV2Enabled = _e === void 0 ? false : _e, isSubscriptionHasOneAddressEnabled = _c.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _c.isSubscriptionUpdateAddressEnabled, bookAppointmentRoute = _c.bookAppointmentRoute, convertOrderLineItem = _c.convertOrderLineItem;
        if (isUninitialized(authState)) {
            return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Loader */ "L"], null), { isProtected: false, center: true });
        }
        var currentRoute = this.state.currentRoute.toLowerCase();
        switch (currentRoute) {
            // First match special routes
            case 'callback':
            case 'logged-out':
                return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Callback, { type: currentRoute, parseHash: this.props.parseHash, loggedOut: this.props.loggedOut }));
            default:
                // These are the standard routes
                var activeRoute = this.state.reverseRouteLookup[currentRoute];
                switch (activeRoute) {
                    default:
                        if (currentRoute &&
                            this.props.routes &&
                            currentRoute.startsWith(this.props.routes.orders)) {
                            // orderNumber is number but we don't parse it because it has leading 0's
                            var _f = __read(/\/([0-9]+)\/?$/.exec(currentRoute) || [], 2), orderNumber = _f[1];
                            var isLegacyOrder = currentRoute.includes('legacy');
                            if (orderNumber) {
                                var formatters = MyAccountRoot.collectOrderTemplates(this.props.children);
                                return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null,
                                    Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OrderDetail$1, { staticsUrl: staticsUrl, locale: locale, country: country, orderNumber: orderNumber, addressFormatter: formatters.address, storeAddressFormatter: formatters.storeAddress, contactDetailsFormatter: formatters.contactDetails, getItemImageUrl: getOrderLineItemImageUrl, isLegacy: isLegacyOrder })), { isProtected: true });
                            }
                        }
                        else if (currentRoute &&
                            this.props.routes &&
                            this.props.routes.subscriptions &&
                            currentRoute.startsWith(this.props.routes.subscriptions)) {
                            /**
                             * subscriptionId is a string that can have an uppercase ID, so need the
                             * non-lowercase version of currentRoute here
                             */
                            var _g = __read(/\/(\w+)\/?$/.exec(this.state.currentRoute) || [], 2), subscriptionId = _g[1];
                            var _h = MyAccountRoot.collectSubscriptionTemplates(this.props.children), addressSummary_1 = _h.addressSummary, billingAddress_1 = _h.billingAddress, paymentDetailsSummary = _h.paymentDetailsSummary;
                            var subscriptionBillingAddress = MyAccountRoot.collectSubscriptionFormTemplate(this.props.children);
                            return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null, isSubscriptionsV2Enabled ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionDetailContainer, null)) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionDetail$1, { addressSummary: addressSummary_1, billingAddressForm: subscriptionBillingAddress || billingAddress_1, isSubscriptionHasOneAddressEnabled: isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled: isSubscriptionUpdateAddressEnabled, paymentDetailsSummary: paymentDetailsSummary, staticsUrl: staticsUrl, subscriptionId: subscriptionId }))), { isProtected: true });
                        }
                        else if (currentRoute && ((_a = this.props.routes) === null || _a === void 0 ? void 0 : _a.unlinkOrder) &&
                            currentRoute.startsWith(this.props.routes.unlinkOrder)) {
                            var isSuccessPage = currentRoute.includes('/success');
                            var query_1 = window ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].parse(window.location.search) : undefined;
                            return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper" },
                                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(UnlinkOrderContainer$1, { isSuccessPage: isSuccessPage, orderToken: query_1 && query_1.orderToken
                                        ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('query.orderToken', query_1.orderToken)
                                        : undefined, orderNumber: query_1 && query_1.orderNumber
                                        ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('query.orderNumber', query_1.orderNumber)
                                        : undefined })), {
                                isProtected: false,
                                center: true,
                            });
                        }
                        else if (currentRoute && ((_b = this.props.routes) === null || _b === void 0 ? void 0 : _b.unlinkAppointment) &&
                            currentRoute.startsWith(this.props.routes.unlinkAppointment)) {
                            var isSuccessPage = currentRoute.includes('/success');
                            var query_2 = window ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].parse(window.location.search) : undefined;
                            return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper" },
                                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(UnlinkAppointmentContainer$1, { isSuccessPage: isSuccessPage, appointmentToken: query_2 && query_2.appointmentToken
                                        ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('query.appointmentToken', query_2.appointmentToken)
                                        : undefined, appointmentId: query_2 && query_2.appointmentId
                                        ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('query.appointmentId', query_2.appointmentId)
                                        : undefined })), {
                                isProtected: false,
                                center: true,
                            });
                        }
                        break;
                    case 'createAccount':
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SetPassword$1, { consentItems: this.props.consentItems })), { isProtected: false, center: true });
                    case 'linkExpired':
                        var query = window ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].parse(window.location.search, true) : undefined;
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(ExpiredLink, { targetAction: query === null || query === void 0 ? void 0 : query.targetAction }), { isProtected: false, center: true });
                    case 'resetPassword':
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubmitEmailAddress$1, null)), {
                            isProtected: false,
                            center: true,
                        });
                    case 'setPassword':
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SetPassword$3, null)), {
                            isProtected: false,
                            center: true,
                        });
                    case 'changePassword':
                        var changePasswordResult = _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].parse(window.location.search).changePasswordResult;
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null,
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper" },
                                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(ChangePassword$1, { isSuccess: changePasswordResult === 'success' }))), {
                            isProtected: true,
                        });
                    case 'signup':
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper--double" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SignUp$1, { loginUrl: (formattedRoutes && formattedRoutes.login) || '#' })), { isProtected: false, center: true });
                    case 'login':
                        var _j = window && _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].parse(window.location.search), returnPath = _j.returnPath, error = _j.error, email = _j.email;
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "myaccount__form-wrapper--double" },
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Login$1, { returnPath: returnPath
                                    ? encodeURIComponent(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('returnPath', returnPath))
                                    : undefined, createAccountRichText: this.props.createAccountRichText, error: error ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('error', error) : undefined, email: email ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('email', email) : undefined })), { isProtected: false, center: true });
                    case 'prescriptions':
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null,
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PrescriptionList$1, { bookAppointmentRoute: bookAppointmentRoute })));
                    case 'privacy':
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null,
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Privacy$1, null)), { isProtected: true });
                    case 'profile':
                        var _k = MyAccountRoot.collectProfileTemplates(this.props.children), personalDetails = _k.personalDetails, personalDetailsSummary = _k.personalDetailsSummary, billingAddress = _k.billingAddress, addressSummary = _k.addressSummary, preferredStoreSummary = _k.preferredStoreSummary, personalGreeting = _k.personalGreeting;
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null,
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Profile$1, { personalDetailsForm: personalDetails, personalDetailsSummary: personalDetailsSummary, addressForm: billingAddress, addressSummary: addressSummary, preferredStoreSummary: preferredStoreSummary, personalGreetingFormatter: personalGreeting, bookAppointmentRoute: bookAppointmentRoute })), { isProtected: true });
                    case 'addressBook':
                        if (isAddressBookEnabled) {
                            var billingAddress_2 = MyAccountRoot.collectAddressBookTemplates(this.props.children).billingAddress;
                            return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null,
                                Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AddressBookContainer$1, { addressForm: billingAddress_2 })), { isProtected: true });
                        }
                        else {
                            var formattedRoutes_1 = this.props.formattedRoutes;
                            formattedRoutes_1 && (window === null || window === void 0 ? void 0 : window.location.assign(formattedRoutes_1.profile));
                        }
                    case 'orders':
                        // TODO: replace this with proper locale
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null,
                            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Orders$1, { staticsUrl: staticsUrl, locale: locale, country: country, getItemImageUrl: getOrderLineItemImageUrl, enableLegacyOrderHistory: authState.enableLegacyOrderHistory, convertOrderLineItem: convertOrderLineItem })), { isProtected: true });
                    case 'subscriptions':
                        return MyAccountRoot.renderSubroute(Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(PageWithMenu$1, null, isSubscriptionsV2Enabled ? (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionListContainer, { subscriptionContactLensProductsUrl: subscriptionContactLensProductsUrl, benefitsList: benefitsList })) : (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(SubscriptionList$1, null))), { isProtected: true });
                }
        }
        if (currentRoute in this.state.reverseRouteLookup) {
            return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h3", null,
                currentRoute,
                " has not been implemented yet");
        }
        // TODO: this is really a 404 but we can't return that here anymore
        return null;
    };
    MyAccountRoot.prototype.componentWillUnmount = function () {
        this.unregisterHistory();
    };
    /**
     * Custom form fields
     */
    MyAccountRoot.PersonalDetailsFields = function (_) { return null; };
    MyAccountRoot.AddressFields = function (_) { return null; };
    /**
     * Custom summary formatters
     */
    MyAccountRoot.PersonalDetailsSummary = function (_) { return null; };
    MyAccountRoot.AddressSummary = function (_) { return null; };
    MyAccountRoot.PreferredStoreSummary = function (_) { return null; };
    MyAccountRoot.PaymentDetailsSummary = function (_) { return null; };
    MyAccountRoot.PersonalGreeting = function (_) { return null; };
    MyAccountRoot.OrderAddressFormatter = function (_) { return null; };
    MyAccountRoot.OrderContactDetailsFormatter = function (_) { return null; };
    MyAccountRoot.renderSubroute = function (component, options) {
        if (options === void 0) { options = { isProtected: true }; }
        var wrappedComponent = (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('myaccount-root', { 'myaccount-root--center': options.center }) },
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "site-container" }, component)));
        return options.isProtected ? Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(Protected$1, null, wrappedComponent) : wrappedComponent;
    };
    MyAccountRoot.collectProfileTemplates = function (children) {
        var templates = __assign(__assign({}, DefaultFormTemplates()), DefaultSummaryTemplates());
        react__WEBPACK_IMPORTED_MODULE_1__["Children"].forEach(children, function (child) {
            if (!Object(react__WEBPACK_IMPORTED_MODULE_1__["isValidElement"])(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.PersonalDetailsFields:
                    templates[FormName.personalDetails] = child.props.children;
                    break;
                case MyAccountRoot.PersonalDetailsSummary:
                    templates[SummaryName.personalDetailsSummary] = child.props.children;
                    break;
                case MyAccountRoot.AddressFields:
                    if (child.props.type !== 'subscription') {
                        templates[FormName.billingAddress] = child.props.children;
                    }
                    break;
                case MyAccountRoot.AddressSummary:
                    templates[SummaryName.addressSummary] = child.props.children;
                    break;
                case MyAccountRoot.PreferredStoreSummary:
                    templates[SummaryName.preferredStoreSummary] = child.props.children;
                    break;
                case MyAccountRoot.PersonalGreeting:
                    templates[SummaryName.personalGreeting] = child.props.children;
            }
        });
        return templates;
    };
    MyAccountRoot.collectAddressBookTemplates = function (children) {
        var templates = __assign(__assign({}, DefaultFormTemplates()), DefaultSummaryTemplates());
        react__WEBPACK_IMPORTED_MODULE_1__["Children"].forEach(children, function (child) {
            if (!Object(react__WEBPACK_IMPORTED_MODULE_1__["isValidElement"])(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.AddressFields:
                    if (child.props.type !== 'subscription') {
                        templates[FormName.billingAddress] = child.props.children;
                    }
                    break;
                case MyAccountRoot.AddressSummary:
                    templates[SummaryName.addressSummary] = child.props.children;
                    break;
            }
        });
        return templates;
    };
    MyAccountRoot.collectSubscriptionFormTemplate = function (children) {
        var subscribtionBillingAddress = null;
        react__WEBPACK_IMPORTED_MODULE_1__["Children"].forEach(children, function (child) {
            if (!Object(react__WEBPACK_IMPORTED_MODULE_1__["isValidElement"])(child)) {
                return;
            }
            if (child.type === MyAccountRoot.AddressFields && child.props.type === 'subscription') {
                subscribtionBillingAddress = child.props.children;
            }
        });
        return subscribtionBillingAddress;
    };
    MyAccountRoot.collectSubscriptionTemplates = function (children) {
        var templates = __assign(__assign({}, DefaultFormTemplates()), DefaultSummaryTemplates());
        react__WEBPACK_IMPORTED_MODULE_1__["Children"].forEach(children, function (child) {
            if (!Object(react__WEBPACK_IMPORTED_MODULE_1__["isValidElement"])(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.AddressSummary:
                    templates.addressSummary = child.props.children;
                    break;
                case MyAccountRoot.PaymentDetailsSummary:
                    templates.paymentDetailsSummary = child.props.children;
                    break;
                case MyAccountRoot.AddressFields:
                    if (child.props.type !== 'subscription') {
                        templates.billingAddress = child.props.children;
                    }
                    break;
            }
        });
        return templates;
    };
    MyAccountRoot.collectOrderTemplates = function (children) {
        var templates = __assign({}, DefaultOrderTemplates());
        react__WEBPACK_IMPORTED_MODULE_1__["Children"].forEach(children, function (child) {
            if (!Object(react__WEBPACK_IMPORTED_MODULE_1__["isValidElement"])(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.OrderAddressFormatter:
                    templates.address = child.props.children;
                    break;
                case MyAccountRoot.OrderContactDetailsFormatter:
                    templates.contactDetails = child.props.children;
                    break;
            }
        });
        return templates;
    };
    return MyAccountRoot;
}(react__WEBPACK_IMPORTED_MODULE_1__["Component"]));
var mapStateToProps$k = function (state) {
    return {
        authState: getAuth(state),
        formattedRoutes: getFormattedRoutes(state),
        routes: getRoutes(state),
    };
};
var mapDispatchToProps$h = {
    signup: signup,
    onResend: signup,
    loginWithPassword: loginWithPassword,
    parseHash: parseHash,
    loggedOut: loggedOut,
};
var MyAccountRootConnected = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$k, mapDispatchToProps$h)(MyAccountRoot);
var MyAccountRootConnectedClientOnly = function (props) {
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(OnlyOnClient, null,
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountRootConnected, __assign({}, props))));
};
// We need to export this way to make the static properties
// available to the outside on ConnectedMyAccountRoot. TypeScript won't understand otherwise.
var MyAccountRootConnectedClientOnlyWithContext = /** @class */ (function (_super) {
    __extends(MyAccountRootConnectedClientOnlyWithContext, _super);
    function MyAccountRootConnectedClientOnlyWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyAccountRootConnectedClientOnlyWithContext.prototype.render = function () {
        return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AuthContextConsumer, null,
            Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(MyAccountRootConnectedClientOnly, __assign({}, this.props))));
    };
    /**
     * This can be used to change the personal detail form content on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PersonalDetailsFields = MyAccountRoot.PersonalDetailsFields;
    /**
     * This can be used to change the address fields on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.AddressFields = MyAccountRoot.AddressFields;
    /**
     * This can be used to change to personal details summary on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PersonalDetailsSummary = MyAccountRoot.PersonalDetailsSummary;
    /**
     * This can be used to change the address summary on the profile page and the subscription detail page
     */
    MyAccountRootConnectedClientOnlyWithContext.AddressSummary = MyAccountRoot.AddressSummary;
    /**
     * This can be used to change the preferred store summary on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PreferredStoreSummary = MyAccountRoot.PreferredStoreSummary;
    /**
     * This can be used to change the payment details summary on the subscription detail page
     */
    MyAccountRootConnectedClientOnlyWithContext.PaymentDetailsSummary = MyAccountRoot.PaymentDetailsSummary;
    /**
     * This can be used to change the address summary on the order details page
     */
    MyAccountRootConnectedClientOnlyWithContext.OrderAddressFormatter = MyAccountRoot.OrderAddressFormatter;
    /**
     * This can be used to change the contact details summary on the order details page
     */
    MyAccountRootConnectedClientOnlyWithContext.OrderContactDetailsFormatter = MyAccountRoot.OrderContactDetailsFormatter;
    /**
     * This can be used to customize the personal greeting on top of the Profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PersonalGreeting = MyAccountRoot.PersonalGreeting;
    return MyAccountRootConnectedClientOnlyWithContext;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));

var LoggedIn = function (_a) {
    var auth = _a.auth, disableContinue = _a.disableContinue, onLogoutClick = _a.onLogoutClick, onContinueClick = _a.onContinueClick;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    return (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("div", { className: "logged-in__container" },
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("h2", { className: "checkout-step__title logged-in__title" }, getLabel('account.alreadyLoggedIn.title')),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])("p", null, getFormattedLabel('account.alreadyLoggedIn.text', {
            labelData: { email: auth.email },
        })),
        !disableContinue && (Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "logged-in__button logged-in__button-continue", "data-t": "continue", caption: getLabel('common.actions.continue'), onClick: onContinueClick })),
        Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* Button */ "f"], { className: "logged-in__button logged-in__button-logout", "data-t": "logout", caption: getLabel('account.action.logout'), onClick: onLogoutClick, variant: "outline" })));
};
var mapStateToProps$l = function (state) { return ({
    auth: getAuth(state),
}); };
var mapDispatchToProps$i = {
    onLogoutClick: logOut,
};
var LoggedIn$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(mapStateToProps$l, mapDispatchToProps$i)(LoggedIn);

var AuthProvider = /** @class */ (function (_super) {
    __extends(AuthProvider, _super);
    function AuthProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthProvider.prototype.componentDidMount = function () {
        if (this.props.enabled) {
            this.props.init(this.props.settings);
        }
    };
    AuthProvider.prototype.render = function () {
        var _a = this.props, children = _a.children, enabled = _a.enabled;
        var context = { enabled: enabled };
        return Object(react__WEBPACK_IMPORTED_MODULE_1__["createElement"])(AuthContext.Provider, { value: context }, children);
    };
    return AuthProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]));
var mapDispatchToProps$j = {
    init: init,
};
var AuthProvider$1 = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* connect */ "u"])(null, mapDispatchToProps$j)(AuthProvider);

var initialState = {
    list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])(),
    pendingListChanges: {},
    calls: {
        add: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
        edit: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    },
    modalState: {
        isOpen: false,
        viewMode: ViewMode.ADD,
    },
};
var getList = function (list) {
    return Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(list) ? list.result : [];
};
var pushNewAddress = function (prevList, newAddress) {
    if (newAddress.addressTypes.length) {
        prevList = prevList.map(function (item) {
            if (item.addressTypes.length) {
                var addressTypes = item.addressTypes.filter(function (addressType) { return !newAddress.addressTypes.includes(addressType); });
                return __assign(__assign({}, item), { addressTypes: addressTypes });
            }
            return item;
        });
    }
    return sortAddresses(__spread(prevList, [newAddress]));
};
var addressBookReducer = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* reducer */ "B"])(initialState, 
/**
 * Fetch address book
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchList, function (state) { return (__assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchListFailed, function (state, action) { return (__assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchListSuccess, function (state, action) { return (__assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(sortAddresses(action.payload)) })); }), 
/**
 * Toggle modal
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(toggleModal, function (state, _a) {
    var payload = _a.payload;
    return (__assign(__assign({}, state), { modalState: __assign(__assign({}, state.modalState), payload), calls: __assign({}, initialState.calls) }));
}), 
/**
 * Add address
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addAddress, function (state) { return (__assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { add: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() }) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addAddressFailed, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { add: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(error) }) }));
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(addAddressSuccess, function (state, _a) {
    var newAddress = _a.payload;
    var prevList = getList(state.list);
    var newAddresses = pushNewAddress(prevList, newAddress);
    return __assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { add: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() }), list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(newAddresses), modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
}), 
/**
 * Delete address
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(deleteAddress, function (state, _a) {
    var _b;
    var id = _a.payload;
    var prevList = getList(state.list);
    var removedItem = prevList.find(function (item) { return item.id === id; });
    return __assign(__assign({}, state), { pendingListChanges: (_b = {}, _b[id] = removedItem, _b), currentlyEditingId: id, modalState: {
            isOpen: true,
            viewMode: ViewMode.DELETE,
        } });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(deleteAddressConfirm, function (state) {
    var prevList = getList(state.list);
    return __assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(__spread(prevList.filter(function (item) { return item.id !== state.currentlyEditingId; }))), currentlyEditingId: undefined, modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(deleteAddressSuccess, function (state, _a) {
    var id = _a.payload;
    var _b = state.pendingListChanges, _c = id, pendingItem = _b[_c], restPendingChanges = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
    return __assign(__assign({}, state), { pendingListChanges: restPendingChanges });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(deleteAddressFailed, function (state, _a) {
    var id = _a.id;
    if (id) {
        var prevList = getList(state.list);
        var _b = state.pendingListChanges, _c = id, pendingItem = _b[_c], restPendingChanges = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
        return __assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(sortAddresses(__spread(prevList, [pendingItem]))), pendingListChanges: restPendingChanges });
    }
    else {
        return __assign(__assign({}, state), { modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
    }
}), 
/**
 * Edit address
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(editAddress, function (state, _a) {
    var _b;
    var id = _a.payload;
    var prevList = getList(state.list);
    var editedItem = prevList.find(function (item) { return item.id === id; });
    return __assign(__assign({}, state), { pendingListChanges: (_b = {}, _b[id] = editedItem, _b), currentlyEditingId: id, modalState: {
            isOpen: true,
            viewMode: ViewMode.EDIT,
        } });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(editAddressSave, function (state) {
    return __assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { edit: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() }) });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(editAddressSuccess, function (state, _a) {
    var editedFields = _a.payload;
    var prevList = getList(state.list).filter(function (item) { return item.id !== state.currentlyEditingId; });
    var editedAddress = __assign(__assign({}, state.pendingListChanges[state.currentlyEditingId || 0]), editedFields);
    var newAddresses = pushNewAddress(prevList, editedAddress);
    return __assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(newAddresses), calls: __assign(__assign({}, state.calls), { edit: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() }), modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
}), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(editAddressFailed, function (state, _a) {
    var error = _a.error;
    return __assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { edit: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(error) }), modalState: state.modalState });
}));

var initialState$1 = {
    listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    cancelCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
};
var appointmentsReducer = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* reducer */ "B"])(initialState$1, 
/**
 * fetchList
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchList$1, function (state) { return (__assign(__assign({}, state), { listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchListFailed$1, function (state, action) { return (__assign(__assign({}, state), { listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(fetchListSuccess$1, function (state, action) { return (__assign(__assign({}, state), { listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), list: action.payload })); }), 
/**
 * cancel
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(cancel, function (state) { return (__assign(__assign({}, state), { cancelCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(cancelFailed, function (state, action) { return (__assign(__assign({}, state), { cancelCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) })); }), _grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* actions */ "r"].on(cancelSuccess, function (state) { return (__assign(__assign({}, state), { cancelCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() })); }));

var initialState$2 = {
    historyCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    legacyHistoryCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    legacyDetailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    reorderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
};
function ordersReducer(state, action) {
    if (state === void 0) { state = initialState$2; }
    switch (action.type) {
        case FETCH_PAGE:
            return __assign(__assign({}, state), { historyCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case FETCH_PAGE_FAILED:
            return __assign(__assign({}, state), { historyCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case FETCH_PAGE_SUCCESS: {
            var currentPages = state.history ? state.history.pages : [];
            return __assign(__assign({}, state), { historyCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), history: {
                    total: action.payload.total,
                    pages: __spread(currentPages, [action.payload.page]),
                    size: action.payload.limit,
                } });
        }
        case FETCH_LEGACY_PAGE:
            return __assign(__assign({}, state), { legacyHistoryCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case FETCH_LEGACY_PAGE_FAILED:
            return __assign(__assign({}, state), { legacyHistoryCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case FETCH_LEGACY_PAGE_SUCCESS: {
            var currentPages = state.legacyHistory ? state.legacyHistory.pages : [];
            return __assign(__assign({}, state), { legacyHistoryCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), legacyHistory: {
                    total: action.payload.total,
                    pages: __spread(currentPages, [action.payload.page]),
                    size: action.payload.limit,
                } });
        }
        case FETCH_DETAIL:
            var detail = state.detail;
            /* Reset detail data when it's for a different order. We still want to re-fetch
             * the order because it might have been updated since the last fetch.
             * We can still display the old data until the new data is fetched though
             * so we will just replace it when the call succeeds but until then we leave the old data
             */
            if (detail && detail.orderNumber !== action.payload.orderNumber) {
                detail = undefined;
            }
            return __assign(__assign({}, state), { detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(), detail: detail });
        case FETCH_DETAIL_FAILED:
            return __assign(__assign({}, state), { detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error), detail: undefined });
        case FETCH_DETAIL_SUCCESS:
            return __assign(__assign({}, state), { detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), detail: action.payload });
        case FETCH_LEGACY_DETAIL:
            var legacyDetail = state.legacyDetail;
            /* Reset detail data when it's for a different order. We still want to re-fetch
             * the order because it might have been updated since the last fetch.
             * We can still display the old data until the new data is fetched though
             * so we will just replace it when the call succeeds but until then we leave the old data
             */
            if (legacyDetail && legacyDetail.orderNumber !== action.payload.orderNumber) {
                legacyDetail = undefined;
            }
            return __assign(__assign({}, state), { legacyDetailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(), legacyDetail: legacyDetail });
        case FETCH_LEGACY_DETAIL_FAILED:
            return __assign(__assign({}, state), { legacyDetailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error), legacyDetail: undefined });
        case FETCH_LEGACY_DETAIL_SUCCESS:
            return __assign(__assign({}, state), { legacyDetailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), legacyDetail: action.payload });
        case REORDER:
            return __assign(__assign({}, state), { reorderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case REORDER_FAILED:
            return __assign(__assign({}, state), { reorderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case REORDER_SUCCESS:
            return __assign(__assign({}, state), { reorderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        default:
            return state;
    }
}

var initialState$3 = {
    listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
};
function prescriptionsReducer(state, action) {
    if (state === void 0) { state = initialState$3; }
    switch (action.type) {
        case FETCH_LIST:
            return __assign(__assign({}, state), { listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case FETCH_LIST_FAILED:
            return __assign(__assign({}, state), { listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case FETCH_LIST_SUCCESS: {
            return __assign(__assign({}, state), { listCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), list: action.payload });
        }
        default:
            return state;
    }
}

var initialState$4 = {
    optInsOnServer: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])(),
    changedOptIns: {},
    updateOptInsCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
};
function privacyReducer(state, action) {
    if (state === void 0) { state = initialState$4; }
    switch (action.type) {
        case FETCH_OPT_INS:
            return __assign(__assign({}, state), { optInsOnServer: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case FETCH_OPT_INS_SUCCESS:
            return __assign(__assign({}, state), { optInsOnServer: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(action.payload) });
        case FETCH_OPT_INS_FAILED:
            return __assign(__assign({}, state), { optInsOnServer: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case TOGGLE_OPT_INS:
            return __assign(__assign({}, state), { changedOptIns: __assign(__assign({}, state.changedOptIns), action.payload) });
        case UPDATE_OPT_INS:
            return __assign(__assign({}, state), { updateOptInsCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case UPDATE_OPT_INS_SUCCESS:
            return __assign(__assign({}, state), { updateOptInsCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case UPDATE_OPT_INS_FAILED:
            return __assign(__assign({}, state), { updateOptInsCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
    }
    return state;
}

var initialState$5 = {
    forms: {},
    userData: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])(),
    updateCalls: {
        personalDetails: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
        billingAddress: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
        preferredStore: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    },
};
function profileReducer(state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initialState$5; }
    switch (action.type) {
        case CHANGE_FORM_VALUE:
            if (!isProfileForm(action.payload.form.formName)) {
                return state;
            }
            return __assign(__assign({}, state), { forms: __assign(__assign({}, state.forms), (_a = {}, _a[action.payload.form.formName] = __assign(__assign({}, state.forms[action.payload.form.formName]), { state: action.payload.form }), _a)) });
        case TOGGLE_FORM_EDIT_MODE:
            var initialFormState = state.forms[action.payload.formName];
            var internalState = initialFormState
                ? initialFormState.state
                : {
                    formState: {},
                    formValid: false,
                    formName: action.payload.formName,
                };
            var internalFormState = {
                state: internalState,
                inEditMode: action.payload.inEditMode,
            };
            return __assign(__assign({}, state), { forms: __assign(__assign({}, state.forms), (_b = {}, _b[action.payload.formName] = internalFormState, _b)) });
        case FETCH_USER_DATA:
            return __assign(__assign({}, state), { userData: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case FETCH_USER_DATA_FAILED:
            return __assign(__assign({}, state), { userData: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case FETCH_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(action.payload) });
        case UPDATE_USER_DATA:
            return __assign(__assign({}, state), { updateCalls: __assign(__assign({}, state.updateCalls), (_c = {}, _c[action.payload] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(), _c)) });
        case UPDATE_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(action.payload.server), updateCalls: __assign(__assign({}, state.updateCalls), (_d = {}, _d[action.payload.formName] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), _d)), forms: __assign(__assign({}, state.forms), (_e = {}, _e[action.payload.formName] = __assign(__assign({}, state.forms[action.payload.formName]), { inEditMode: false }), _e)) });
        case UPDATE_USER_DATA_FAILED:
            return __assign(__assign({}, state), { updateCalls: __assign(__assign({}, state.updateCalls), (_f = {}, _f[action.payload.formName] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.payload.error), _f)) });
    }
    return state;
}

var initialState$6 = {
    detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    pauseCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    quantityCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    productDataCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
    productData: {},
    subscriptionForm: {
        state: {},
        saveFormCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
        isInEditMode: false,
        isModalOpen: false,
    },
    list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* uninitState */ "M"])(),
};
var getFormState = function (address) {
    if (address === void 0) { address = {}; }
    var streetName = address.streetName, addressLine1 = address.addressLine1, addressLine2 = address.addressLine2, addressLine3 = address.addressLine3, additionalStreetInfo = address.additionalStreetInfo, additionalAddressInfo = address.additionalAddressInfo, county = address.county, region = address.region, rest = __rest(address, ["streetName", "addressLine1", "addressLine2", "addressLine3", "additionalStreetInfo", "additionalAddressInfo", "county", "region"]);
    var mappedAddress = __assign(__assign({}, rest), { streetName: streetName || addressLine1 || '', additionalStreetInfo: additionalStreetInfo || addressLine2 || '', additionalAddressInfo: additionalAddressInfo || addressLine3 || '', region: region || county || '' });
    return _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].fieldsToFormState(mappedAddress);
};
function subscriptionsReducer(state, action) {
    if (state === void 0) { state = initialState$6; }
    var _a, _b;
    switch (action.type) {
        case FETCH_DETAIL$1:
            var detail = state.detail;
            /* Reset detail data when it's for a different subscription. We still want to re-fetch
             * the subscription because it might have been updated since the last fetch.
             * We can still display the old data until the new data is fetched though
             * so we will just replace it when the call succeeds but until then we leave the old data
             */
            if (detail && detail.id !== action.payload.subscriptionId) {
                detail = undefined;
            }
            return __assign(__assign({}, state), { detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(), detail: detail });
        case FETCH_DETAIL_FAILED$1:
            return __assign(__assign({}, state), { detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error), detail: undefined });
        case FETCH_DETAIL_SUCCESS$1:
            return __assign(__assign({}, state), { detailCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), detail: action.payload, subscriptionForm: __assign(__assign({}, state.subscriptionForm), { state: getFormState(action.payload.deliveryAddress) }) });
        case SUBSCRIPTION_ADDRESS_UPDATE:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { state: action.payload }) });
        case SUBSCRIPTION_ADDRESS_RESET:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, initialState$6.subscriptionForm), { state: getFormState((_a = state.detail) === null || _a === void 0 ? void 0 : _a.deliveryAddress) }) });
        case SUBSCRIPTION_ADDRESS_SAVE:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { saveFormCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() }) });
        case SUBSCRIPTION_ADDRESS_SAVE_SUCCESS:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, initialState$6.subscriptionForm), { state: getFormState((_b = state.detail) === null || _b === void 0 ? void 0 : _b.deliveryAddress), isModalOpen: true }) });
        case SUBSCRIPTION_ADDRESS_SAVE_FAILED:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { saveFormCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) }) });
        case SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { isInEditMode: action.payload }) });
        case SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { isModalOpen: action.payload }) });
        case PAUSE:
            return __assign(__assign({}, state), { pauseCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case PAUSE_FAILED:
            return __assign(__assign({}, state), { pauseCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case PAUSE_SUCCESS:
            return __assign(__assign({}, state), { pauseCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case QUANTITY:
            return __assign(__assign({}, state), { quantityCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case QUANTITY_FAILED:
            return __assign(__assign({}, state), { quantityCall: 'reason' in action.payload ? Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() : Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.payload) });
        case QUANTITY_SUCCESS:
            return __assign(__assign({}, state), { quantityCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case FETCH_PRODUCT_DATA:
            return __assign(__assign({}, state), { productDataCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(), productData: __assign(__assign({}, state.productData), action.payload.productIds.reduce(function (acc, id) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[id] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])(), _a)));
                }, {})) });
        case FETCH_PRODUCT_DATA_FAILED:
            var _c = action.payload, error = _c.error, productData = _c.productData;
            return __assign(__assign({}, state), { productDataCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(error), productData: __assign(__assign({}, state.productData), productData) });
        case FETCH_PRODUCT_DATA_SUCCESS:
            return __assign(__assign({}, state), { productDataCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), productData: __assign(__assign({}, state.productData), action.payload.productData) });
        case FETCH_LIST$1:
            return __assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case FETCH_LIST_SUCCESS$1:
            return __assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(action.payload) });
        case FETCH_LIST_FAILED$1:
            return __assign(__assign({}, state), { list: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        default:
            return state;
    }
}

var initialState$7 = {
    state: AuthState.Uninitialized,
};
function fail(union) {
    throw new Error("Should also account for " + union);
}
// this is to set the global state of auth package (store)
function reducer (state, action) {
    if (state === void 0) { state = initialState$7; }
    switch (action.type) {
        case INIT:
            var _a = action.payload, apiUrl = _a.apiUrl, domain = _a.domain, clientId = _a.clientId, customDomain = _a.customDomain, routes = _a.routes, basePath = _a.basePath, checkoutRoute = _a.checkoutRoute, _b = _a.optIns, optIns = _b === void 0 ? [] : _b, _c = _a.enableLegacyOrderHistory, enableLegacyOrderHistory = _c === void 0 ? false : _c, _d = _a.putPrescriptionTokensOnCart, putPrescriptionTokensOnCart = _d === void 0 ? false : _d, _e = _a.isAabEnabled, isAabEnabled = _e === void 0 ? false : _e, _f = _a.disableAddressEditing, disableAddressEditing = _f === void 0 ? false : _f;
            return {
                state: AuthState.Initialized,
                apiUrl: apiUrl,
                domain: domain,
                clientId: clientId,
                customDomain: customDomain,
                routing: {
                    basePath: basePath,
                    routes: routes,
                    checkoutRoute: checkoutRoute,
                },
                optIns: optIns,
                loginCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
                signupCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
                unlinkAppointmentCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
                unlinkOrderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
                resetPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(),
                enableLegacyOrderHistory: enableLegacyOrderHistory,
                putPrescriptionTokensOnCart: putPrescriptionTokensOnCart,
                isAabEnabled: isAabEnabled,
                disableAddressEditing: disableAddressEditing,
            };
        case SET_PASSWORD:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can only dispatch " + SET_PASSWORD + " when user is logged in with passwordless flow");
            }
            return __assign(__assign({}, state), { activateCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case SET_PASSWORD_FAILED:
            var error = action.error;
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can only dispatch " + SET_PASSWORD_FAILED + " when user is logged in with passwordless flow");
            }
            return __assign(__assign({}, state), { activateCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(error) });
        case SET_PASSWORD_SUCCESS:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can only dispatch " + SET_PASSWORD_SUCCESS + " when user is logged in with passwordless flow");
            }
            return __assign(__assign({}, state), { activateCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), hasActivatedAccount: true });
        case SIGNUP:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { signupCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case SIGNUP_SUCCESS:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { signupCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case SIGNUP_FAILED:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { signupCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case RESET_PASSWORD:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { resetPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case RESET_PASSWORD_SUCCESS:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { resetPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case RESET_PASSWORD_FAILED:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { resetPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case UPDATE_PASSWORD:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { setPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case UPDATE_PASSWORD_FAILED:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { setPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case UPDATE_PASSWORD_SUCCESS:
            if (!isLoggedInPasswordless(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { setPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case CHANGE_PASSWORD:
            if (!isLoggedIn(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { changePasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case CHANGE_PASSWORD_FAILED:
            if (!isLoggedIn(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { changePasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case CHANGE_PASSWORD_SUCCESS:
            if (!isLoggedIn(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            /**
             * We don't want to set this call from loading state back to idle state because we want to keep the submit button
             * in loading state. The finished call will trigger a redirect which will refresh the page and also reset this
             * part of the Redux store, since it's not persisted.
             */
            return state;
        case LOGIN:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions auth is initialized");
            }
            return __assign(__assign({}, state), { loginCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case LOGIN_FAILED:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { loginCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case PARSE_HASH_SUCCEEDED:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            switch (action.payload.type) {
                default:
                    return fail(action.payload);
                case 'regular':
                    return __assign(__assign({}, state), { state: AuthState.LoggedIn, userId: action.payload.id, email: action.payload.email, type: 'regular', loginCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), privacy: privacyReducer(undefined, action), profile: profileReducer(undefined, action), orders: ordersReducer(undefined, action), subscriptions: subscriptionsReducer(undefined, action), prescriptions: prescriptionsReducer(undefined, action), appointments: appointmentsReducer(undefined, action), addressBook: addressBookReducer(undefined, action), changePasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
                case 'passwordless':
                    return __assign(__assign({}, state), { state: AuthState.LoggedIn, userId: action.payload.id, email: action.payload.email, type: 'passwordless', loginCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), hasActivatedAccount: action.payload.hasActivatedAccount, activateCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])(), setPasswordCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
            }
        case PARSE_HASH_FAILED:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { state: AuthState.ParseHashFailed, error: action.payload.error, email: action.payload.email });
        case RECOVER_SESSION_FAILED:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            if (isLoggedIn(state) || isLoggedInPasswordless(state)) {
                // We don't care session recovery has failed if we're logged in anyway
                return state;
            }
            return __assign(__assign({}, state), { state: AuthState.LoggedOut, error: action.error });
        case unlinkAppointment.type:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { unlinkAppointmentCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case unlinkAppointmentSuccess.type:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { unlinkAppointmentCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case unlinkAppointmentFailed.type:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { unlinkAppointmentCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
        case unlinkOrder.type:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { unlinkOrderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* loadingState */ "y"])() });
        case unlinkOrderSuccess.type:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { unlinkOrderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* idleState */ "w"])() });
        case unlinkOrderFailed.type:
            if (isUninitialized(state)) {
                throw new Error("Can't run actions before auth is initialized");
            }
            return __assign(__assign({}, state), { unlinkOrderCall: Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(action.error) });
    }
    if (isLoggedIn(state)) {
        return __assign(__assign({}, state), { profile: profileReducer(state.profile, action), privacy: privacyReducer(state.privacy, action), orders: ordersReducer(state.orders, action), subscriptions: subscriptionsReducer(state.subscriptions, action), prescriptions: prescriptionsReducer(state.prescriptions, action), appointments: appointmentsReducer(state.appointments, action), addressBook: addressBookReducer(state.addressBook, action) });
    }
    return state;
}

/**
 * This module wraps the official Auth0 auth0-js client library.
 *
 * Basically it's just a bunch of calls converted to promises with a token renewal
 * channel that publishes a renewal event when the token is about to expire.
 *
 * API Documentation can be found here: https://auth0.github.io/auth0.js
 * The source is here: https://github.com/auth0/auth0.js
 *
 */
var webAuth;
var authOptions;
var dbConnection = 'Username-Password-Authentication';
/**
 * Some assertions that provide a clear error message when you've forgot to call init before other operations
 */
var assertInit = {
    isInitialized: function () {
        if (!webAuth) {
            return new Error("WebAuth hasn't been initialized. Make sure you call `init` before any other operations.");
        }
    },
    throwIfUninitialized: function () {
        var error = assertInit.isInitialized();
        if (error !== undefined) {
            throw error;
        }
    },
    rejectIfUninitialized: function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                error = assertInit.isInitialized();
                if (error) {
                    return [2 /*return*/, Promise.reject(error)];
                }
                return [2 /*return*/, new Promise(callback)];
            });
        });
    },
};
/**
 * If the token is about to expire a RenewalRequired action will be published on this channel.
 * Refreshing the token is up to the consumer. A call to `checkSession` will get a fresh token.
 */
var renewalRequired = Object(redux_saga__WEBPACK_IMPORTED_MODULE_24__[/* channel */ "c"])(redux_saga__WEBPACK_IMPORTED_MODULE_24__[/* buffers */ "b"].none());
var renewalTimeoutToken;
function scheduleRenewal(expiresIn) {
    window.clearTimeout(renewalTimeoutToken);
    renewalTimeoutToken = window.setTimeout(function () {
        renewalRequired.put({
            type: '@@auth/RENEWAL_REQUIRED',
        });
    }, expiresIn * 1000 - 5000); // Request renewal 5s before it expires
}
/**
 * Creates a new WebAuth instance. Should be called at least once
 */
function init$1(options) {
    authOptions = options;
    webAuth = new auth0_js__WEBPACK_IMPORTED_MODULE_23__[/* WebAuth */ "a"](authOptions);
}
/**
 * Wraps WebAuth.checkSession, see: https://auth0.github.io/auth0.js/global.html#checkSession
 *
 * It can be used to keep a session alive or continue on open one (say, after a page refresh)
 * Will also schedule a renewal event, see the `renewalRequired` channel at the top of the module
 */
function checkSession(options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    webAuth.checkSession(options, function (err, authResult) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        if (!authResult) {
                            reject(new Error("Failed to checkSession, authResult was null"));
                            return;
                        }
                        if (authResult.expiresIn) {
                            scheduleRenewal(authResult.expiresIn);
                        }
                        resolve(authResult);
                    });
                })];
        });
    });
}
/**
 * Wraps webAuth.crossOriginAuthentication, see: https://auth0.github.io/auth0.js/global.html#login
 * (search for cross-origin-authentication to find the correct type of login)
 *
 * Logs in the user with username and password using the cross origin authentication flow
 */
function crossOriginAuthentication(email, password, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    webAuth.login(__assign(__assign({}, options), { username: email, realm: dbConnection, password: password, 
                        // @ts-ignore (types of auth0-js package are not complete
                        responseType: 'token id_token', state: JSON.stringify({ email: email }) }), function (err, result) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        resolve(result);
                    });
                })];
        });
    });
}
/**
 * Wraps WebAuth.parseHash, see: https://auth0.github.io/auth0.js/global.html#parseHash
 *
 * This function should be called on the returnUri (ie, the page that auth0 sends the user back to)
 * Will also schedule a renewal event, see the `renewalRequired` channel at the top of the module
 */
function parseHash$1(options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    var callback = function (err, authResult) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        if (!authResult) {
                            reject(new Error("Failed to parseHash, authResult was '" + authResult + "'"));
                            return;
                        }
                        if (authResult.expiresIn) {
                            scheduleRenewal(authResult.expiresIn);
                        }
                        resolve(authResult);
                    };
                    if (options) {
                        webAuth.parseHash(options, callback);
                    }
                    else {
                        webAuth.parseHash(callback);
                    }
                })];
        });
    });
}
/**
 * Wraps WebAuth.client.userInfo, see: https://auth0.github.io/auth0.js/global.html#userInfo
 */
function userInfo(accessToken) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!accessToken) {
                throw new Error('accessToken needs to be non-empty');
            }
            return [2 /*return*/, assertInit.rejectIfUninitialized(function (resolve, reject) {
                    webAuth.client.userInfo(accessToken, function (err, userResult) {
                        if (err) {
                            reject(err);
                            return;
                        }
                        resolve(userResult);
                    });
                })];
        });
    });
}
/**
 * Wraps WebAuth.logout, see: https://auth0.github.io/auth0.js/global.html#logout
 */
function logout(returnTo) {
    assertInit.throwIfUninitialized();
    window.clearTimeout(renewalTimeoutToken);
    // Redirects out
    webAuth.logout({
        returnTo: returnTo,
    });
}

var audience = 'fake_https://api.local:3080/';
var tokenCache = {};
var createTokenKey = function (audience, scopes) { return audience + "::" + scopes; };
var cacheToken = function (accessToken) {
    var token = jwt_decode__WEBPACK_IMPORTED_MODULE_22___default()(accessToken);
    var tokenKey = createTokenKey(Array.isArray(token.aud) ? token.aud.join(' ') : token.aud, token.scope);
    var timeoutToken = ejectTokenFromCache(tokenKey, token.exp);
    tokenCache[tokenKey] = {
        token: accessToken,
        clearTimeoutToken: timeoutToken,
    };
};
var ejectTokenFromCache = function (tokenKey, expiresIn) {
    return window.setTimeout(function () {
        if (tokenKey in tokenCache) {
            delete tokenCache[tokenKey];
        }
    }, expiresIn * 1000 - 5000);
};
var getToken = function () {
    var scopes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        scopes[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var scopeString, tokenKey, authResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    scopeString = scopes.join(' ');
                    tokenKey = createTokenKey(audience, scopeString);
                    if (tokenKey in tokenCache) {
                        return [2 /*return*/, tokenCache[tokenKey].token];
                    }
                    return [4 /*yield*/, checkSession({
                            audience: audience,
                            scope: scopeString,
                            responseType: 'token',
                        })];
                case 1:
                    authResult = _a.sent();
                    if (!authResult.accessToken) {
                        throw new Error("Did not receive accessToken from Auth0");
                    }
                    if (!authResult.expiresIn) {
                        throw new Error("Did not receive accessToken expiry, received '" + authResult.expiresIn + "'");
                    }
                    cacheToken(authResult.accessToken);
                    return [2 /*return*/, authResult.accessToken];
            }
        });
    });
};

function onFetchAddressBook() {
    var authState, customerId, accessToken, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!!isLoggedIn(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed(new Error('User needs to be logged in to fetch addresses')))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                customerId = authState.userId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                accessToken = _a.sent();
                _a.label = 5;
            case 5:
                _a.trys.push([5, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Addresses.list, authState.apiUrl, { customerId: customerId, accessToken: accessToken })];
            case 6:
                result = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListSuccess(result))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed(err_1))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onAddAddress(action) {
    var authState, customerId, accessToken, newAddress, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!!isLoggedIn(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(addAddressFailed(new Error('User needs to be logged in to add an address to the address book')))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                customerId = authState.userId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                accessToken = _a.sent();
                _a.label = 5;
            case 5:
                _a.trys.push([5, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Addresses.create, authState.apiUrl, {
                        customerId: customerId,
                        accessToken: accessToken,
                        address: action.payload,
                    })];
            case 6:
                newAddress = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(addAddressSuccess(newAddress))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(addAddressFailed(err_2))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onDeleteAddress(action) {
    var authState, customerId, accessToken, addressId, cancel, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!!isLoggedIn(authState)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].failed, 'account.addressBook.delete.authFailed')];
            case 2:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(deleteAddressFailed(new Error('User needs to be logged in to add an address to the address book')))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                customerId = authState.userId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 5:
                accessToken = _a.sent();
                addressId = action.payload;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* race */ "g"])({
                        cancel: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(toggleModal.type),
                        confirm: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(deleteAddressConfirm.type),
                    })];
            case 6:
                cancel = (_a.sent()).cancel;
                if (cancel) {
                    return [2 /*return*/];
                }
                _a.label = 7;
            case 7:
                _a.trys.push([7, 11, , 14]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Addresses.deleteAddress, authState.apiUrl, {
                        customerId: customerId,
                        accessToken: accessToken,
                        addressId: addressId,
                    })];
            case 8:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.addressBook.delete.success')];
            case 9:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(deleteAddressSuccess(addressId))];
            case 10:
                _a.sent();
                return [3 /*break*/, 14];
            case 11:
                err_3 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].failed, 'account.addressBook.delete.failed')];
            case 12:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(deleteAddressFailed(err_3, addressId))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function onEditAddress(action) {
    var authState, customerId, accessToken, _a, editedAddress, id, err_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _b.sent();
                if (!!isLoggedIn(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(editAddressFailed(new Error('User needs to be logged in to edit an address in the address book')))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3:
                customerId = authState.userId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                accessToken = _b.sent();
                _a = action.payload, editedAddress = _a.address, id = _a.id;
                _b.label = 5;
            case 5:
                _b.trys.push([5, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Addresses.edit, authState.apiUrl, {
                        customerId: customerId,
                        accessToken: accessToken,
                        address: editedAddress,
                        id: id,
                    })];
            case 6:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(editAddressSuccess(editedAddress))];
            case 7:
                _b.sent();
                return [3 /*break*/, 10];
            case 8:
                err_4 = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(editAddressFailed(err_4))];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
var addressBookSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(fetchList.type, onFetchAddressBook),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(addAddress.type, onAddAddress),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(deleteAddress.type, onDeleteAddress),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(editAddressSave.type, onEditAddress),
];

function onFetchList() {
    var locale, auth, token, appointments, apiConfig_1, slicedAppointments, storeCodes, getStore_1, stores_1, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale)];
            case 1:
                locale = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 2:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$1(new Error("Can't fetch appointments when user isn't logged-in")))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                _a.trys.push([4, 12, , 14]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 5:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Appointments */ "a"].list, auth.apiUrl, token, locale)];
            case 6:
                appointments = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 7:
                apiConfig_1 = _a.sent();
                if (!!apiConfig_1) return [3 /*break*/, 9];
                /**
                 * At this point we won't be able to get detailed store name information. Since this is crucial information
                 * for an appointment, we'll bail out here and not show the appointment(s) at all.
                 */
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$1(new Error('Stores API is unreachable')))];
            case 8:
                /**
                 * At this point we won't be able to get detailed store name information. Since this is crucial information
                 * for an appointment, we'll bail out here and not show the appointment(s) at all.
                 */
                _a.sent();
                return [2 /*return*/];
            case 9:
                slicedAppointments = appointments.slice(0, 10);
                storeCodes = Array.from(new Set(slicedAppointments.map(function (appointment) { return appointment.store.code; })));
                getStore_1 = function (code) {
                    return Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Stores */ "i"].getDetailsByCode, apiConfig_1.storesUrl, { code: code }, apiConfig_1.apiKey);
                };
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* all */ "a"])(storeCodes.reduce(function (acc, code) {
                        var _a;
                        return (__assign(__assign({}, acc), (_a = {}, _a[code] = getStore_1(code), _a)));
                    }, {}))
                    // Weave in the correct store name from Stores API into each appointment if available
                ];
            case 10:
                stores_1 = _a.sent();
                result = slicedAppointments.map(function (appointment) { return (__assign(__assign({}, appointment), { store: stores_1[appointment.store.code] })); });
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListSuccess$1(result))];
            case 11:
                _a.sent();
                return [3 /*break*/, 14];
            case 12:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$1(__assign({}, err_1)))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function onCancel(action) {
    var auth, token, cancellationReason, requestBody, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(cancelFailed(new Error("Can't cancel an appointment when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 7, , 9]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                token = _a.sent();
                cancellationReason = action.payload.cancellationReason;
                requestBody = { cancellationReason: cancellationReason };
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Appointments */ "a"].cancel, auth.apiUrl, action.payload.id, token, requestBody)];
            case 5:
                response = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(cancelSuccess(response))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(cancelFailed(__assign({}, err_2)))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function onCancelSuccess() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchList$1())];
            case 1:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.appointment.cancel.success.toast')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var appointmentsSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(fetchList$1.type, onFetchList),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(cancel.type, onCancel),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(cancelSuccess.type, onCancelSuccess),
];

var getCustomerUri = function (apiUrl, customerId) {
    return apiUrl + "/customers/customer/" + encodeURIComponent(customerId);
};
var getAccountUri = function (apiUrl) { return apiUrl + "/customers/account"; };
var unwrapResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var result, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!!response.ok) return [3 /*break*/, 5];
                result = '';
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, response.text()];
            case 2:
                result = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 4: throw new Error("Got non OK response from server: " + response.status + " " + response.statusText + ": " + result);
            case 5: return [2 /*return*/, response.json()];
        }
    });
}); };
var baseOptions = {
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-cache',
};
var optIns = {
    fetch: function (apiUrl, customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getToken()];
                    case 1:
                        accessToken = _b.sent();
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getCustomerUri(apiUrl, customerId) + "/optins", __assign(__assign({}, baseOptions), { method: 'GET', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }) }))];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
    update: function (apiUrl, customerId, optinUpdates) {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getToken()];
                    case 1:
                        accessToken = _b.sent();
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getCustomerUri(apiUrl, customerId) + "/optins", __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }), body: JSON.stringify({
                                    optinUpdates: optinUpdates,
                                }) }))];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
};
var account = {
    signup: function (apiUrl, loginRedirectUrl, emailAddress, additionalAccountData, reason) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, personalDetails, _b, optins, optInsUpdate, additionalData, locale, stateParams, body, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = additionalAccountData.personalDetails, personalDetails = _a === void 0 ? {} : _a, _b = additionalAccountData.optins, optins = _b === void 0 ? {} : _b;
                        optInsUpdate = Object.keys(optins).length > 0 ? optins : undefined;
                        additionalData = { personalDetails: personalDetails, optins: optInsUpdate };
                        locale = _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* LocaleUtils */ "c"].getLocaleFromCookie();
                        stateParams = { targetAction: 'signUp' };
                        body = __assign({ loginRedirectUrl: loginRedirectUrl,
                            emailAddress: emailAddress, state: JSON.stringify(stateParams), reason: reason }, additionalData);
                        body = locale ? __assign(__assign({}, body), { locale: locale }) : body;
                        _c = unwrapResponse;
                        return [4 /*yield*/, fetch(getAccountUri(apiUrl) + "/create", __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    'Content-Type': 'application/json',
                                    Accept: 'application/json',
                                }), body: JSON.stringify(body) }))];
                    case 1: return [2 /*return*/, _c.apply(void 0, [_d.sent()])];
                }
            });
        });
    },
    activate: function (apiUrl, accessToken, accountId, emailAddress, password, consents) {
        return __awaiter(this, void 0, void 0, function () {
            var locale, body, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        locale = _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* LocaleUtils */ "c"].getLocaleFromCookie();
                        body = {
                            emailAddress: emailAddress,
                            password: password,
                            consents: consents,
                        };
                        body = locale ? __assign(__assign({}, body), { locale: locale }) : body;
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getAccountUri(apiUrl) + "/activate/" + encodeURIComponent(accountId), __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }), body: JSON.stringify(body) }))];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
    changePassword: function (apiUrl, accessToken, accountId, password) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = unwrapResponse;
                        return [4 /*yield*/, fetch(getAccountUri(apiUrl) + "/changepassword/" + encodeURIComponent(accountId), __assign(__assign({}, baseOptions), { method: 'POST', headers: new Headers({
                                    Authorization: "Bearer " + accessToken,
                                    'Content-Type': 'application/json',
                                }), body: JSON.stringify({ password: password }) }))];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    },
};

function activateAccount(action) {
    var authState, token, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isLoggedInPasswordless(authState)) {
                    throw new Error('User needs to be logged-in with passwordless connection');
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken, 'openid', 'email')];
            case 2:
                token = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 6, , 8]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([account, 'activate'], authState.apiUrl, token, authState.userId, authState.email, action.payload.password, action.payload.consents)];
            case 4:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(setPasswordSuccess({
                        userId: authState.userId,
                        password: action.payload.password,
                        email: authState.email,
                        consents: action.payload.consents,
                    }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(setPasswordFailed(err_1))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function loginAfterAccountActivation(action) {
    var authState, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isLoggedInPasswordless(authState)) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 5, , 7]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(loginWithPassword({
                        email: action.payload.email,
                        password: action.payload.password,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.setPassword.success')];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(setPasswordFailed(err_2))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function signupPasswordless(action) {
    var authState, _a, email, personalDetails, selectedOptIns, reason, availableOptIns, optInUpdates, _b, protocol, host, redirectUri, result, err_3;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _c.sent();
                if (isUninitialized(authState)) {
                    throw new Error("Can't do signup when auth hasn't been initialized first");
                }
                _c.label = 2;
            case 2:
                _c.trys.push([2, 8, , 10]);
                _a = action.payload, email = _a.email, personalDetails = _a.personalDetails, selectedOptIns = _a.selectedOptIns, reason = _a.reason;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getOptIns)];
            case 3:
                availableOptIns = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(createOptInsUpdate, availableOptIns, selectedOptIns)];
            case 4:
                optInUpdates = _c.sent();
                _b = window.location, protocol = _b.protocol, host = _b.host;
                redirectUri = protocol + "//" + host + "/" + authState.routing.basePath + "/callback";
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([account, 'signup'], authState.apiUrl, redirectUri, email, { personalDetails: personalDetails, optins: optInUpdates }, reason)];
            case 5:
                result = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(signUpSuccess({
                        email: action.payload.email,
                        id: result.accountId,
                        accountDataToken: result.accountDataToken,
                    }))];
            case 6:
                _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.activationEmail.success')];
            case 7:
                _c.sent();
                return [3 /*break*/, 10];
            case 8:
                err_3 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(signUpFailed(err_3))];
            case 9:
                _c.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
var createAccountSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(SET_PASSWORD, activateAccount),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(SET_PASSWORD_SUCCESS, loginAfterAccountActivation),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(SIGNUP, signupPasswordless),
];

function isExpiredLinkError(error) {
    if ('error' in error) {
        var description = error.error_description || error.errorDescription;
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('the verification code has expired')) {
            return true;
        }
        // For an already activated account we inform the user the same as for an expired link
        if (description === null || description === void 0 ? void 0 : description.toLowerCase().includes('wrong email or verification code')) {
            return true;
        }
    }
    return false;
}

function login(action) {
    var returnPath, e_1, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                returnPath = action.payload.returnPath;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 7, , 9]);
                if (!(window && returnPath)) return [3 /*break*/, 5];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([sessionStorage, 'setItem'], 'login_returnPath', returnPath)];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                e_1 = _a.sent();
                console.error("Setting path to storage failed. Error: " + e_1);
                return [3 /*break*/, 5];
            case 5: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(crossOriginAuthentication, action.payload.email, action.payload.password, {
                    scope: 'openid profile email',
                })];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(loginFailed(err_1))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
var stateSpec = Object(specified__WEBPACK_IMPORTED_MODULE_25__["adjust"])(specified__WEBPACK_IMPORTED_MODULE_25__["Type"].object({
    email: Object(specified__WEBPACK_IMPORTED_MODULE_25__["optional"])(specified__WEBPACK_IMPORTED_MODULE_25__["Type"].string),
    targetAction: Object(specified__WEBPACK_IMPORTED_MODULE_25__["optional"])(specified__WEBPACK_IMPORTED_MODULE_25__["Type"].literal({
        forgotPassword: 1,
        signUp: 1,
    })),
}), { strict: false });
function parseState(state) {
    try {
        var result = JSON.parse(state);
        return Object(specified__WEBPACK_IMPORTED_MODULE_25__["verify"])(stateSpec, result).value();
    }
    catch (err) {
        return undefined;
    }
}
function parseHash$2() {
    var state, hash, result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = 'TODO:csrf';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 8]);
                try {
                    hash = _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].parse(window.location.hash.substring(1));
                    if (hash.state) {
                        state = _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* StringGuard */ "f"].guard('hash.state', hash.state);
                    }
                }
                catch (e) {
                    console.error('Error while parsing URL hash:', e);
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(parseHash$1, {
                        state: state,
                    })];
            case 2:
                result = _a.sent();
                if (!!result.accessToken) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(parseHashFailed(__assign({ error: new Error('No accessToken received after login') }, parseState(state))))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(onAccessTokenReceived, result.accessToken, true)];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                error_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(parseHashFailed(__assign({ error: error_1 }, parseState(state))))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function redirectAfterParseHash(action) {
    var routes, route, returnPath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload.redirect) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getFormattedRoutes)];
            case 1:
                routes = _a.sent();
                if (!routes) {
                    throw new Error('Need routes to redirect');
                }
                route = 'profile';
                if (!(action.payload.type === 'passwordless')) return [3 /*break*/, 2];
                if (action.payload.hasActivatedAccount) {
                    route = 'setPassword';
                }
                else {
                    route = 'createAccount';
                }
                return [3 /*break*/, 6];
            case 2: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([sessionStorage, 'getItem'], 'login_returnPath')];
            case 3:
                returnPath = _a.sent();
                if (!returnPath) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(goto({ path: decodeURIComponent(returnPath) }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([sessionStorage, 'removeItem'], 'login_returnPath')];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(goto({ route: route }))];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * If the user comes in passwordless and the link has expired, redirect
 * to 'link-expired' so they can request a new link
 */
function redirectAfterFailedParseHash(action) {
    var routes, _a, error, targetAction, query, description, redirectRoute;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getFormattedRoutes)];
            case 1:
                routes = _b.sent();
                if (!routes) {
                    throw new Error('Need routes to redirect');
                }
                _a = action.payload, error = _a.error, targetAction = _a.targetAction;
                query = {};
                if ('error' in error) {
                    description = error.error_description || error.errorDescription;
                    if (description && description.startsWith('gv__')) {
                        query.error = description.substring('gv__'.length);
                    }
                }
                redirectRoute = 'login';
                if (targetAction === 'forgotPassword' || targetAction === 'signUp') {
                    redirectRoute = 'linkExpired';
                    query.targetAction = targetAction;
                }
                else if (isExpiredLinkError(error)) {
                    redirectRoute = 'linkExpired';
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(goto({
                        route: redirectRoute,
                        query: Object.keys(query).length > 0 ? _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].stringify(query, true) : undefined,
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function recoverSession$1() {
    var authState, result, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isInitialized(authState)) {
                    return [2 /*return*/];
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 7, , 9]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(checkSession, {
                        scope: 'openid profile',
                        responseType: 'id_token token',
                    })];
            case 3:
                result = _a.sent();
                if (!!result.accessToken) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(recoverSessionFailed(new Error('No accessToken received during session recovery')))];
            case 4:
                _a.sent();
                return [2 /*return*/];
            case 5: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(onAccessTokenReceived, result.accessToken, false)];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(recoverSessionFailed(err_2))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function onAccessTokenReceived(accessToken, redirect) {
    var jwtContent, email, userInfo$1, opts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(jwt_decode__WEBPACK_IMPORTED_MODULE_22___default.a, accessToken)];
            case 1:
                jwtContent = _a.sent();
                email = jwtContent['https://grandvision/claims/email'];
                if (!!email) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(userInfo, accessToken)];
            case 2:
                userInfo$1 = _a.sent();
                if (!userInfo$1.email) {
                    throw new Error("Email claim should be in accessToken or accessToken should have at least 'openid email' scope");
                }
                email = userInfo$1.email;
                _a.label = 3;
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(cacheToken, accessToken)];
            case 4:
                _a.sent();
                opts = {
                    id: jwtContent.sub,
                    email: email,
                    redirect: redirect,
                };
                if (!(jwtContent['https://grandvision/claims/connection'] === 'email')) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(parseHashSucceeded(__assign(__assign({}, opts), { type: 'passwordless', hasActivatedAccount: jwtContent['https://grandvision/claims/activeAccount'] || false })))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(parseHashSucceeded(__assign(__assign({}, opts), { type: 'regular' })))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
var loginSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(LOGIN, login),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(PARSE_HASH, parseHash$2),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(PARSE_HASH_SUCCEEDED, redirectAfterParseHash),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(PARSE_HASH_FAILED, redirectAfterFailedParseHash),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLeading */ "k"])(RECOVER_SESSION, recoverSession$1),
];

function getReturnPath() {
    var _a = window.location, pathname = _a.pathname, search = _a.search, hash = _a.hash;
    return pathname + search + hash;
}
function logOut$1() {
    var basePath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getBasePath)];
            case 1:
                basePath = _a.sent();
                if (!basePath) {
                    throw new Error("Need basePath to generate logout return URI");
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(logout, window.location.protocol + "//" + location.host + "/" + basePath + "/logged-out?returnPath=" + getReturnPath())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function redirectAfterLogOut() {
    var returnPath, targetPath, historyWrapper, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(removeUserDataFromLS)];
            case 1:
                _a.sent();
                returnPath = _grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* QueryString */ "e"].parse(window.location.search).returnPath;
                targetPath = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_7__[/* isString */ "B"])(returnPath) ? returnPath : '/';
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(history)];
            case 2:
                historyWrapper = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 5, , 6]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(historyWrapper.replace, { pathname: targetPath })];
            case 4:
                _a.sent();
                window && window.location.reload();
                return [3 /*break*/, 6];
            case 5:
                err_1 = _a.sent();
                console.error(err_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
var logoutSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(LOG_OUT, logOut$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(LOGGED_OUT, redirectAfterLogOut),
];

function getStoreResult(apiConfig, storeId) {
    if (!apiConfig || !storeId) {
        return;
    }
    /**
     * We want to still show the prescription (without store name if this call fails. So we catch the error and don't
     * extend the prescription with store detail data, but don't send the use into a different flow.
     */
    return _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Stores */ "i"].getDetailsByCode(apiConfig.storesUrl, {
        code: storeId,
    }, apiConfig.apiKey).catch(console.error);
}
function onFetchList$1() {
    var auth, apiConfig_1, token, response, storeFetchResults, storeResponse_1, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$2(new Error("Can't fetch prescriptions when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 11, , 13]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 4:
                apiConfig_1 = _a.sent();
                if (!!apiConfig_1) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$2({
                        message: "Can't fetch stores without API Config",
                    }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 7:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Prescriptions.list, auth.apiUrl, token, {
                        customerId: auth.userId,
                    })
                    // Build store fetch call effects
                ];
            case 8:
                response = _a.sent();
                storeFetchResults = response.reduce(function (m, prescription) {
                    var _a;
                    if (!prescription.storeId) {
                        return m;
                    }
                    return __assign(__assign({}, m), (_a = {}, _a[prescription.storeId] = Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getStoreResult, apiConfig_1, prescription.storeId), _a));
                }, {});
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* all */ "a"])(storeFetchResults)
                    // Add store name to prescription
                ];
            case 9:
                storeResponse_1 = _a.sent();
                result = response.map(function (prescription) {
                    var _a;
                    return (__assign(__assign({}, prescription), { storeName: prescription.storeId && ((_a = storeResponse_1[prescription.storeId]) === null || _a === void 0 ? void 0 : _a.storeName) }));
                });
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListSuccess$2(result))];
            case 10:
                _a.sent();
                return [3 /*break*/, 13];
            case 11:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$2(__assign({}, err_1)))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function onFetchSigned() {
    var auth, token, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchSignedFailed(new Error("Can't fetch signed prescriptions when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 7, , 9]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Prescriptions.signedPrescriptions, auth.apiUrl, token, {
                        customerId: auth.userId,
                    })];
            case 5:
                response = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchSignedSucccess(response.prescriptionTokens))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchSignedFailed(__assign({}, err_2)))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getSignedTokens(accessToken, timeout) {
    var _a, success, timedOut;
    if (timeout === void 0) { timeout = 30000; }
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchSigned())];
            case 1:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* race */ "g"])({
                        success: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(FETCH_SIGNED_SUCCESS),
                        failed: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(FETCH_SIGNED_FAILED),
                        timedOut: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* delay */ "d"])(timeout),
                    })];
            case 2:
                _a = _b.sent(), success = _a.success, timedOut = _a.timedOut;
                if (success) {
                    return [2 /*return*/, success.payload];
                }
                if (timedOut) {
                    console.error("Fetching signed prescription failed because the request exceeded timeout of " + timeout);
                }
                return [2 /*return*/, []];
        }
    });
}
var prescriptionsSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_LIST, onFetchList$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_SIGNED, onFetchSigned),
];

function onFetchPageSaga(action, listApi, fetchPageSuccess, fetchPageFailed$1) {
    var auth, apiConfig, token, orderResponse, history_1, serverTotal, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to fetch orders.');
                }
                if (!!isLoggedIn(auth)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchPageFailed(new Error("Can't fetch orders when user isn't logged-in")))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                _a.trys.push([4, 11, , 14]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 5:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(listApi, apiConfig.ordersUrl, token, {
                        customerId: auth.userId,
                        limit: action.payload.limit,
                        offset: action.payload.skip,
                    }, apiConfig.apiKey)];
            case 6:
                orderResponse = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getOrderHistory)];
            case 7:
                history_1 = _a.sent();
                serverTotal = orderResponse.total;
                if (!(history_1 && history_1.total !== serverTotal)) return [3 /*break*/, 9];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].info, 'account.orders.history.outOfSync')];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchPageSuccess({
                    page: orderResponse.orders,
                    total: orderResponse.total,
                    limit: action.payload.limit,
                }))];
            case 10:
                _a.sent();
                return [3 /*break*/, 14];
            case 11:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchPageFailed$1(__assign({}, err_1)))];
            case 12:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].failed, 'account.fetchOrders.failed')];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function onPageFetch(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(onFetchPageSaga, action, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].list, fetchPageSuccess, fetchPageFailed)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onLegacyPageFetch(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(onFetchPageSaga, action, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].legacyList, fetchLegacyPageSuccess, fetchLegacyPageFailed)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchDetailSaga(action, detailsApi, fetchDetailSuccess, fetchDetailFailed$1) {
    var auth, apiConfig, token, orderResponse, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to fetch orders.');
                }
                if (!!isLoggedIn(auth)) return [3 /*break*/, 4];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetailFailed(new Error("Can't fetch order detail when user isn't logged-in")))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                _a.trys.push([4, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 5:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(detailsApi, apiConfig.ordersUrl, token, {
                        customerId: auth.userId,
                        orderId: action.payload.orderNumber,
                    }, apiConfig.apiKey)];
            case 6:
                orderResponse = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetailSuccess(orderResponse.order))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetailFailed$1(__assign({}, err_2)))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onDetailFetch(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(onFetchDetailSaga, action, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].details, fetchDetailSuccess, fetchDetailFailed)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onLegacyDetailFetch(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(onFetchDetailSaga, action, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].legacyDetails, fetchLegacyDetailSuccess, fetchLegacyDetailFailed)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onReorder(action) {
    var auth, _a, locale, country, currency, drafts, cartDraft, accessToken, tokens, _b, failed, success, timeout, checkoutRoute, message, err_3;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _c.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(reorderFailed(new Error("Can't reorder when user isn't logged-in")))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                _c.trys.push([3, 19, , 21]);
                _a = action.payload, locale = _a.locale, country = _a.country, currency = _a.currency, drafts = _a.drafts;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_26__[/* Utils */ "g"].parseAddToCartPayload, __assign(__assign({}, drafts), { currency: currency,
                        country: country,
                        locale: locale }))];
            case 4:
                cartDraft = _c.sent();
                if (!auth.putPrescriptionTokensOnCart) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 5:
                accessToken = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getSignedTokens, accessToken)];
            case 6:
                tokens = _c.sent();
                if (Array.isArray(tokens) && tokens.length) {
                    cartDraft = __assign(__assign({}, cartDraft), { custom: __assign(__assign({}, cartDraft.custom), { fields: __assign(__assign({}, cartDraft.custom.fields), { prescriptionSignatures: JSON.stringify(tokens) }) }) });
                }
                _c.label = 7;
            case 7: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_26__[/* ReduxDataSource */ "f"].Actions.createCart({ cartDraft: cartDraft }))];
            case 8:
                _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* race */ "g"])({
                        failed: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_26__[/* ReduxDataSource */ "f"].Actions.CART_FAILED),
                        success: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_26__[/* ReduxDataSource */ "f"].Actions.CART_SUCCESS),
                        timeout: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* delay */ "d"])(3000),
                    })];
            case 9:
                _b = _c.sent(), failed = _b.failed, success = _b.success, timeout = _b.timeout;
                if (!success) return [3 /*break*/, 14];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(reorderSuccess())];
            case 10:
                _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getCheckoutRoute)];
            case 11:
                checkoutRoute = _c.sent();
                if (!checkoutRoute) return [3 /*break*/, 13];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(redirect, checkoutRoute)];
            case 12:
                _c.sent();
                _c.label = 13;
            case 13: return [2 /*return*/];
            case 14:
                message = '';
                if (timeout) {
                    message = 'Reorder timed out';
                }
                else if (failed) {
                    message = 'Reorder failed';
                }
                if (!message) return [3 /*break*/, 16];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(reorderFailed({ message: message }))];
            case 15:
                _c.sent();
                return [3 /*break*/, 18];
            case 16: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(reorderFailed({
                    message: 'Reorder failed for an unknown reason',
                }))];
            case 17:
                _c.sent();
                _c.label = 18;
            case 18: return [3 /*break*/, 21];
            case 19:
                err_3 = _c.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(reorderFailed(__assign({}, err_3)))];
            case 20:
                _c.sent();
                return [3 /*break*/, 21];
            case 21: return [2 /*return*/];
        }
    });
}
var ordersSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_PAGE, onPageFetch),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_LEGACY_PAGE, onLegacyPageFetch),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_DETAIL, onDetailFetch),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_LEGACY_DETAIL, onLegacyDetailFetch),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(REORDER, onReorder),
];

function fetchOptIns$1() {
    var auth, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!isLoggedIn(auth)) {
                    throw new Error("Can't fetch opt-ins when user isn't logged in");
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([optIns, 'fetch'], auth.apiUrl, auth.userId)];
            case 2:
                result = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchOptInsSuccess(result))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchOptInsFailed(err_1))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function updateOptIns$1(action) {
    var auth, changedOptIns, updates, serverOptInsState_1, diff, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 11, , 13]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!isLoggedIn(auth)) {
                    throw new Error("Can't fetch opt-ins when user isn't logged in");
                }
                changedOptIns = action.payload;
                if (!(changedOptIns === undefined)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getChangedOptIns)];
            case 2:
                changedOptIns = _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(createOptInsUpdateForPrivacy, changedOptIns)];
            case 4:
                updates = _a.sent();
                if (!(Object.keys(updates).length > 0)) return [3 /*break*/, 10];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([optIns, 'fetch'], auth.apiUrl, auth.userId)
                    // Diff what is actually an opt-in update
                ];
            case 5:
                serverOptInsState_1 = _a.sent();
                diff = Object.entries(updates).reduce(function (acc, _a) {
                    var _b;
                    var _c = __read(_a, 2), key = _c[0], optIn = _c[1];
                    return (serverOptInsState_1.optinValues || {})[key] !== optIn.value
                        ? __assign(__assign({}, acc), (_b = {}, _b[key] = optIn, _b)) : acc;
                }, {});
                if (!(Object.keys(diff).length > 0)) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])([optIns, 'update'], auth.apiUrl, auth.userId, diff)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(updateOptInsSuccess())];
            case 8:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.updateOptins.success')];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(updateOptInsFailed(err_2))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
var privacySagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_OPT_INS, fetchOptIns$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(UPDATE_OPT_INS, updateOptIns$1),
];

function fetchUserData$1() {
    var auth, token, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!isLoggedIn(auth)) {
                    throw new Error("Can't fetch user data when not logged in");
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 2:
                token = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 6, , 8]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].details, auth.apiUrl, token, auth.userId)];
            case 4:
                response = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchUserDataSuccess(response.personalDetails))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchUserDataFailed(err_1))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateUserData$1(action) {
    var formName, auth, userData, formData, updatedUserData, token, err_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                formName = action.payload;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getUserData)];
            case 2:
                userData = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getFormData)];
            case 3:
                formData = _b.sent();
                if (!isLoggedIn(auth)) {
                    throw new Error("Can't fetch user data when not logged in");
                }
                if (!(userData && Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* statusSuccess */ "G"])(userData))) return [3 /*break*/, 11];
                updatedUserData = __assign(__assign({}, userData.result), (_a = {}, _a[formName] = formData[formName], _a));
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                token = _b.sent();
                _b.label = 5;
            case 5:
                _b.trys.push([5, 9, , 11]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].updateDetails, auth.apiUrl, token, auth.userId, {
                        personalDetails: updatedUserData,
                    })];
            case 6:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(updateUserDataSuccess({ server: updatedUserData, formName: formName }))];
            case 7:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.updateProfile.success')];
            case 8:
                _b.sent();
                return [3 /*break*/, 11];
            case 9:
                err_2 = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(updateUserDataFailed({ error: err_2, formName: formName }))];
            case 10:
                _b.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function updateForm(action) {
    var formData, formNames, serverData, newFormsState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getForms) || {}];
            case 1:
                formData = _a.sent();
                formNames = Object.keys(FormName);
                serverData = action.type === UPDATE_USER_DATA_SUCCESS
                    ? action.payload.server
                    : action.payload;
                newFormsState = formNames.reduce(function (formAcc, formName) {
                    var _a;
                    var form = formData[formName];
                    var clientForm = (form && form.state) || {
                        formValid: false,
                        formName: formName,
                        formState: {},
                    };
                    var serverForm = serverData[formName];
                    if (!serverForm) {
                        console.warn('No server form');
                        return formAcc;
                    }
                    var clientFieldNames = Object.keys(clientForm.formState);
                    var serverFieldNames = Object.keys(serverForm);
                    var combinedFieldNames = Array.from(new Set(__spread(clientFieldNames, serverFieldNames)));
                    var newFieldValues = combinedFieldNames.reduce(function (fieldAcc, fieldName) {
                        var _a;
                        var clientFieldState = clientForm.formState[fieldName] || {
                            name: fieldName,
                            value: '',
                        };
                        var serverValue = serverForm[fieldName];
                        var value = serverValue ? serverValue.toString() : clientFieldState.value;
                        return __assign(__assign({}, fieldAcc), (_a = {}, _a[fieldName] = __assign(__assign({}, clientFieldState), { value: value }), _a));
                    }, {});
                    return __assign(__assign({}, formAcc), (_a = {}, _a[formName] = __assign(__assign({}, clientForm), { formState: newFieldValues }), _a));
                }, {});
                if (!newFormsState.personalDetails) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(changeFormValue({
                        form: newFormsState.personalDetails,
                    }))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!newFormsState.billingAddress) return [3 /*break*/, 5];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(changeFormValue({
                        form: newFormsState.billingAddress,
                    }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                if (!newFormsState.preferredStore) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(changeFormValue({
                        form: newFormsState.preferredStore,
                    }))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
var profileSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_USER_DATA, fetchUserData$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(UPDATE_USER_DATA, updateUserData$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])([
        UPDATE_USER_DATA_SUCCESS,
        FETCH_USER_DATA_SUCCESS,
    ], updateForm),
];

var getAuth0ErrorCode = function (errorString) {
    var regex = /"auth0ErrorCode":"(\w+)"/;
    var result = errorString.match(regex);
    return result && result[1] ? result[1] : undefined;
};

function onResetPassword(action) {
    var authState, stateParams, _a, protocol, host, redirectUri, requestPayload, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _b.sent();
                _b.label = 2;
            case 2:
                _b.trys.push([2, 6, , 8]);
                stateParams = {
                    targetAction: 'forgotPassword',
                };
                _a = window === null || window === void 0 ? void 0 : window.location, protocol = _a.protocol, host = _a.host;
                redirectUri = protocol + "//" + host + "/" + authState.routing.basePath + "/callback";
                requestPayload = {
                    emailAddress: action.payload.email,
                    state: JSON.stringify(stateParams),
                    loginRedirectUrl: redirectUri,
                };
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Password.resetPassword, authState.apiUrl, requestPayload)];
            case 3:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(resetPasswordSuccess({
                        email: action.payload.email,
                    }))];
            case 4:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.resetPassword.success')];
            case 5:
                _b.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(resetPasswordFailed(err_1))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function onUpdatePassword(action) {
    var authState, token, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!!isLoggedInPasswordless(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(updatePasswordFailed(new Error("Can only update users' password when they're logged-in with passwordless link")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken, 'gv::update:password', 'email', 'profile', 'openid')];
            case 4:
                token = _a.sent();
                _a.label = 5;
            case 5:
                _a.trys.push([5, 9, , 11]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(account.changePassword, authState.apiUrl, token, authState.userId, action.payload.password)];
            case 6:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(updatePasswordSuccess({
                        password: action.payload.password,
                    }))];
            case 7:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.updatePassword.success')];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(updatePasswordFailed(err_2))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
var convertPayload = function (payload) { return ({
    email: payload.email,
    oldPassword: payload.currentPassword,
    password: payload.newPassword,
}); };
function onChangePassword(action) {
    var authState, token, changePasswordPayload, err_3, auth0ErrorCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!!isLoggedIn(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(changePasswordFailed(new Error("Can only update users' password when they're logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                token = _a.sent();
                changePasswordPayload = convertPayload(action.payload);
                _a.label = 5;
            case 5:
                _a.trys.push([5, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Password.changePassword, authState.apiUrl, token, authState.userId, changePasswordPayload)];
            case 6:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(changePasswordSuccess({
                        password: changePasswordPayload.password,
                    }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_3 = _a.sent();
                auth0ErrorCode = (err_3 === null || err_3 === void 0 ? void 0 : err_3.message) ? getAuth0ErrorCode(err_3.message) : undefined;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(changePasswordFailed(auth0ErrorCode || err_3))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function loginAfterPasswordUpdate(action) {
    var authState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                if (!isLoggedInPasswordless(authState)) {
                    console.error("User is not logged in via passwordless method. Login state: " + authState.state + ". Login type: " + authState.type + ".");
                    return [2 /*return*/];
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(crossOriginAuthentication, authState.email, action.payload.password)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function loginAfterPasswordChange(action) {
    var authState, routing, returnPath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                authState = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getRouting)];
            case 2:
                routing = _a.sent();
                if (!isLoggedIn(authState)) {
                    console.error("User is not regularly logged in. Login state: " + authState.state + ". Login type: " + authState.type + ".");
                    return [2 /*return*/];
                }
                returnPath = routing &&
                    encodeURIComponent(routing.basePath + '/' + routing.routes.changePassword + '?changePasswordResult=success');
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(loginWithPassword({
                        email: authState.email,
                        password: action.payload.password,
                        returnPath: returnPath,
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var resetPasswordSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(RESET_PASSWORD, onResetPassword),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(UPDATE_PASSWORD, onUpdatePassword),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(CHANGE_PASSWORD, onChangePassword),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(CHANGE_PASSWORD_SUCCESS, loginAfterPasswordChange),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(UPDATE_PASSWORD_SUCCESS, loginAfterPasswordUpdate),
];

var createProductLookup = function (productProjections) {
    var product = {};
    var variant = {};
    productProjections.forEach(function (p) {
        var variants = __spread([p.masterVariant], p.variants);
        variants.forEach(function (v) {
            var _a, _b;
            if (v.sku) {
                product = __assign(__assign({}, product), (_a = {}, _a[v.sku] = p, _a));
                variant = __assign(__assign({}, variant), (_b = {}, _b[v.sku] = v, _b));
            }
        });
    });
    return {
        product: product,
        variant: variant,
    };
};

function onDetailFetch$1(action) {
    var auth, token, response, productIds, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetailFailed$1(new Error("Can't fetch subscription details when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Subscriptions.details, auth.apiUrl, token, {
                        customerId: auth.userId,
                        subscriptionId: action.payload.subscriptionId,
                    })];
            case 5:
                response = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetailSuccess$1(response))];
            case 6:
                _a.sent();
                productIds = response.lineItems.map(function (i) { return i.productId; });
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchProductData({ productIds: productIds }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetailFailed$1(__assign({}, err_1)))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onPause(action) {
    var auth, token, detail, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(pauseFailed(new Error("Can't update subscription pausing state when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getSubscriptionDetail)];
            case 5:
                detail = _a.sent();
                if (!detail) return [3 /*break*/, 11];
                _a.label = 6;
            case 6:
                _a.trys.push([6, 9, , 11]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Subscriptions.pause, auth.apiUrl, token, auth.userId, detail.id, action.payload)];
            case 7:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(pauseSuccess({ subscriptionId: detail.id }))];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9:
                err_2 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(pauseFailed(__assign({}, err_2)))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function onPauseSuccess(action) {
    var subscriptionId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                subscriptionId = action.payload.subscriptionId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetail$1({ subscriptionId: subscriptionId }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.subscription.pause.success.toast')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onQuantity(action) {
    var auth, token, detail, quantity, subscriptionQuantity, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(quantityFailed(new Error("Can't update subscription quantity when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                token = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getSubscriptionDetail)];
            case 5:
                detail = _a.sent();
                if (!detail) return [3 /*break*/, 12];
                quantity = action.payload.quantity;
                subscriptionQuantity = detail.lineItems.reduce(function (q, i) { return i.quantity; }, 0);
                if (!(quantity === subscriptionQuantity)) return [3 /*break*/, 7];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(quantityFailed({ reason: 'quantity_same' }))];
            case 6:
                _a.sent();
                return [2 /*return*/];
            case 7:
                _a.trys.push([7, 10, , 12]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Subscriptions.quantity, auth.apiUrl, token, auth.userId, detail.id, action.payload)];
            case 8:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(quantitySuccess({
                        subscriptionId: detail.id,
                    }))];
            case 9:
                _a.sent();
                return [3 /*break*/, 12];
            case 10:
                err_3 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(quantityFailed(__assign({}, err_3)))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function onQuantitySuccess(action) {
    var subscriptionId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                subscriptionId = action.payload.subscriptionId;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchDetail$1({ subscriptionId: subscriptionId }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].success, 'account.subscription.quantity.success.toast')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onQuantityFailed(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!('reason' in action.payload)) return [3 /*break*/, 2];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* toast */ "vb"].info, 'account.subscription.quantity.noChange')];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}
function onFetchProductData(action) {
    var productIds, locale, auth, results, productData, lookup_1, succeeded_1, failed_1, error, error_1, productData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                productIds = action.payload.productIds;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* IntlSelectors */ "i"].getLocale)];
            case 1:
                locale = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 2:
                auth = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 11, , 13]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Products */ "h"].query, auth.apiUrl + "/products", {
                        filters: ["variants.sku:" + encodeURIComponent(productIds.map(function (id) { return "\"" + id + "\""; }).join(','))],
                        expand: ['productType'],
                    })];
            case 4:
                results = (_a.sent()).results;
                if (!(!results || !results.length)) return [3 /*break*/, 6];
                productData = productIds.reduce(function (acc, id) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[id] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error('Did not receive any product data for this product')), _a)));
                }, {});
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchProductDataFailed({
                        error: new Error("Did not receive any product data for these IDs: " + productIds.join(', ')),
                        productData: productData,
                    }))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                lookup_1 = createProductLookup(results);
                succeeded_1 = {};
                failed_1 = {};
                productIds.forEach(function (id) {
                    var _a, _b, _c, _d;
                    var product = lookup_1.product[id];
                    var variant = lookup_1.variant[id];
                    if (!product || !variant) {
                        failed_1 = __assign(__assign({}, failed_1), (_a = {}, _a[id] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error("No data was returned for variant with ID " + id)), _a));
                        return;
                    }
                    var productTypeName = _grandvision_products__WEBPACK_IMPORTED_MODULE_27__[/* Helpers */ "b"].getProductTypeName(product);
                    if (!productTypeName) {
                        failed_1 = __assign(__assign({}, failed_1), (_b = {}, _b[id] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error("Couldn't find productType from product with ID " + product.id + " for SKU " + id)), _b));
                    }
                    if (id in lookup_1.product && id in lookup_1.variant && productTypeName) {
                        var info = _grandvision_products__WEBPACK_IMPORTED_MODULE_27__[/* Helpers */ "b"].getVariantInfo(product, productTypeName, locale || 'en-IE', variant);
                        succeeded_1 = __assign(__assign({}, succeeded_1), (_c = {}, _c[id] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* successState */ "K"])(info), _c));
                    }
                    else {
                        failed_1 = __assign(__assign({}, failed_1), (_d = {}, _d[id] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error("No data was returned for variant with ID " + id)), _d));
                    }
                });
                if (!(Object.keys(succeeded_1).length > 0)) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchProductDataSuccess({ productData: succeeded_1 }))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8:
                if (!(Object.keys(failed_1).length > 0)) return [3 /*break*/, 10];
                error = new Error("Encountered errors for variants with the following IDs: " + Object.keys(failed_1).join(', '));
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchProductDataFailed({ error: error, productData: failed_1 }))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11:
                error_1 = _a.sent();
                productData = productIds.reduce(function (acc, id) {
                    var _a;
                    return (_a = {},
                        _a[id] = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* failedState */ "v"])(new Error("Encountered an error when fetching data. Error: " + error_1)),
                        _a);
                }, {});
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchProductDataFailed({ error: error_1, productData: productData }))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function onFetchList$2() {
    var auth, accessToken, result, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$3(new Error("Can't fetch subscription list when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 7, , 9]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                accessToken = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].Subscriptions.list, auth.apiUrl, {
                        customerId: auth.userId,
                        accessToken: accessToken,
                    })];
            case 5:
                result = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListSuccess$3(result.subscriptions))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_4 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(fetchListFailed$3(err_4))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function onSaveSubscriptionAddress(action) {
    var auth, accessToken, custom, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                if (!!isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(saveSubscriptionAddressFailed(new Error("Can't update subscription address when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 8, , 10]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 4:
                accessToken = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getSubscriptionDetail)];
            case 5:
                custom = (_a.sent()).custom;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Customers */ "c"].changeAddress, auth.apiUrl, accessToken, auth.userId, {
                        fields: _grandvision_forms__WEBPACK_IMPORTED_MODULE_4__[/* Util */ "D"].getValuesFromState(action.payload),
                        externalId: custom === null || custom === void 0 ? void 0 : custom.membershipId,
                        addressTypes: ['delivery-subscription'],
                    })];
            case 6:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(saveSubscriptionAddressSuccess())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_5 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(saveSubscriptionAddressFailed(err_5))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
var subscriptionsSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_DETAIL$1, onDetailFetch$1),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(PAUSE, onPause),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(PAUSE_SUCCESS, onPauseSuccess),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(QUANTITY, onQuantity),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(QUANTITY_FAILED, onQuantityFailed),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(QUANTITY_SUCCESS, onQuantitySuccess),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_PRODUCT_DATA, onFetchProductData),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(FETCH_LIST$1, onFetchList$2),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(SUBSCRIPTION_ADDRESS_SAVE, onSaveSubscriptionAddress),
];

function onUnlinkOrder(action) {
    var auth, formattedRoutes, getSuccessRoute, apiConfig, _a, orderNumber, orderToken, requestBody, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getFormattedRoutes)];
            case 2:
                formattedRoutes = _b.sent();
                getSuccessRoute = function (orderNumber) {
                    return (formattedRoutes === null || formattedRoutes === void 0 ? void 0 : formattedRoutes.unlinkOrder) ? formattedRoutes.unlinkOrder + "/success?orderNumber=" + orderNumber
                        : "unlink-order/success?orderNumber=" + orderNumber;
                };
                _b.label = 3;
            case 3:
                _b.trys.push([3, 10, , 12]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 4:
                apiConfig = _b.sent();
                if (!!apiConfig) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(unlinkOrderFailed(new Error('ApiConfig is unreachable')))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6:
                _a = action.payload, orderNumber = _a.orderNumber, orderToken = _a.orderToken;
                requestBody = { orderNumber: orderNumber, orderToken: orderToken };
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].unlink, auth.apiUrl, requestBody, apiConfig.apiKey)];
            case 7:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(unlinkOrderSuccess())];
            case 8:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(goto({ path: getSuccessRoute(orderNumber) }))];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10:
                err_1 = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(unlinkOrderFailed(__assign({}, err_1)))];
            case 11:
                _b.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function onUnlinkAppointment(action) {
    var auth, formattedRoutes, getSuccessRoute, apiConfig, _a, appointmentToken, appointmentId, requestBody, err_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getFormattedRoutes)];
            case 2:
                formattedRoutes = _b.sent();
                getSuccessRoute = function (appointmentId) {
                    return (formattedRoutes === null || formattedRoutes === void 0 ? void 0 : formattedRoutes.unlinkAppointment) ? formattedRoutes.unlinkAppointment + "/success?appointmentId=" + appointmentId
                        : "unlink-appointment/success?appointmentId=" + appointmentId;
                };
                _b.label = 3;
            case 3:
                _b.trys.push([3, 10, , 12]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 4:
                apiConfig = _b.sent();
                if (!!apiConfig) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(unlinkAppointmentFailed(new Error('ApiConfig is unreachable')))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6:
                _a = action.payload, appointmentToken = _a.appointmentToken, appointmentId = _a.appointmentId;
                requestBody = { appointmentId: appointmentId, appointmentToken: appointmentToken };
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Appointments */ "a"].unlink, auth.apiUrl, requestBody, apiConfig.apiKey)];
            case 7:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(unlinkAppointmentSuccess())];
            case 8:
                _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(goto({ path: getSuccessRoute(appointmentId) }))];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10:
                err_2 = _b.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(unlinkAppointmentFailed(__assign({}, err_2)))];
            case 11:
                _b.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
var unlinkOrderSagas = [
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(unlinkAppointment.type, onUnlinkAppointment),
    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(unlinkOrder.type, onUnlinkOrder),
];

function authInit(action) {
    var _a, domain, customDomain, clientId, basePath;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, domain = _a.domain, customDomain = _a.customDomain, clientId = _a.clientId, basePath = _a.basePath;
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(init$1, {
                        clientID: clientId,
                        domain: customDomain || domain,
                        audience: 'fake_https://api.local:3080/',
                        redirectUri: window.location.protocol + "//" + window.location.host + "/" + basePath + "/callback",
                    })];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onGoto(action) {
    var pathname, routes, requestedRoute, historyWrapper;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!('path' in action.payload)) return [3 /*break*/, 2];
                pathname = ("/" + action.payload.path).replace('//', '/');
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(redirect, pathname)];
            case 1:
                _a.sent();
                return [2 /*return*/];
            case 2: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getFormattedRoutes)];
            case 3:
                routes = _a.sent();
                if (!routes) {
                    throw new Error('Need routes to redirect');
                }
                requestedRoute = routes[action.payload.route];
                if (!requestedRoute) {
                    throw new Error("Tried to go to optional route '" + action.payload.route + "' but it is not set. Formatted routes contained: '" + String(requestedRoute) + "'");
                }
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(history)];
            case 4:
                historyWrapper = _a.sent();
                if (!action.payload.query) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(historyWrapper.push, {
                        pathname: requestedRoute,
                        search: action.payload.query,
                    })];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(historyWrapper.push, { pathname: requestedRoute })];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function onCreateOrder(action) {
    var auth, apiConfig, loggedIn, token, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 1:
                auth = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ApiConfigSelectors */ "b"].getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to create order.');
                }
                if (!isInitialized(auth)) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(recoverSession())];
            case 3:
                _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* race */ "g"])({
                        loggedIn: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(PARSE_HASH_SUCCEEDED),
                        loginFailed: Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* take */ "i"])(RECOVER_SESSION_FAILED),
                    })];
            case 4:
                loggedIn = (_a.sent()).loggedIn;
                if (!loggedIn) return [3 /*break*/, 6];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* select */ "h"])(getAuth)];
            case 5:
                auth = _a.sent();
                _a.label = 6;
            case 6:
                if (!!isLoggedIn(auth)) return [3 /*break*/, 8];
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(createOrderFailed(new Error("Can only create order on behalf of user when they're actually logged-in")))];
            case 7:
                _a.sent();
                return [2 /*return*/];
            case 8: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(getToken)];
            case 9:
                token = _a.sent();
                _a.label = 10;
            case 10:
                _a.trys.push([10, 13, , 15]);
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* call */ "b"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_11__[/* Orders */ "e"].createForCustomer, apiConfig.ordersUrl, auth.userId, token, action.payload, apiConfig.apiKey)];
            case 11:
                result = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(createOrderSuccess(result))];
            case 12:
                _a.sent();
                return [3 /*break*/, 15];
            case 13:
                err_1 = _a.sent();
                return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* put */ "f"])(createOrderFailed(err_1))];
            case 14:
                _a.sent();
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/];
        }
    });
}
function sagas () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* all */ "a"])(__spread(addressBookSagas, appointmentsSagas, createAccountSagas, loginSagas, logoutSagas, ordersSagas, subscriptionsSagas, prescriptionsSagas, privacySagas, profileSagas, resetPasswordSagas, unlinkOrderSagas, [
                    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(GOTO, onGoto),
                    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(INIT, authInit),
                    Object(redux_saga_effects__WEBPACK_IMPORTED_MODULE_21__[/* takeLatest */ "j"])(CREATE_ORDER, onCreateOrder),
                ]))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

/**
 * Auth Module
 *
 * Contains all components related to users authentication
 *
 * @grandvision/auth
 */
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* ReducersRegistry */ "l"].register('auth', reducer);
_grandvision_state__WEBPACK_IMPORTED_MODULE_0__[/* SagaRegistry */ "p"].register('auth', sagas);


//# sourceMappingURL=index.es.js.map


/***/ })

}]);